/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_tp.js                                                                                */
/**********************************************************************************************************************/
/* Controller.TP */

/**
 * @class this.Controller.TP
 */
HafasWebapp.prototype.Controller.TP = {
  /**
   * @class this.Controller.TP.index
   *
   * @param data
   */

  // Strawberry 1.5: [BugFix] Von kleinigkeiten die in der RMV Version aufgefallen sind und [Upgrade] schnelleres Rendern ohne klonen
  currentView: null,
  currentCluster: 0,
  selectedConnection: null,     // Strawberry 1.6.0
  currentConnections: [],       // Strawberry 1.6.0
  tariffSelectBoxes: [],
  scrollButtonsState: {},
  currentForm: null,    // um außerhalb von postForm eine Referenz auf das Formular zu haben; wird in renderIndex gesetzt
  localOptionsActive: Hafas.Config.Options.storeOptions, // Flag used to save if the options should be saved locally, false if the options are specified via URL parameters
  localOptionsLoaded: false, // Flag used to save whether the options were loaded once from the storage at webapp / context start
  currentSelectedTariff:{},
  dragableInputElements: [],
  draggingInputsActive: false,
  viasOpen: false,
  viaContextsMenus: [],
  viaTogglePressed: false,
  removeViaRunning: false,
  updateViaFieldsRunning: false,
  showViaFormRunning: false,
  showViaFormTimeout: null,
  focusSelector: null, // for restoring focus after some action is performed
  index: function (params) {
    params = params || {};   // check if params for index method have been passed

    tpController = this.Controller.TP;
    this.Controller.TP.groupFavMode = 'TI';
    Hafas.bind(this.Controller.TP.cleanup, this)();

    this.Controller.TP.visibleClusterGroup = this.Controller.TP.getCurrentClusterBitmask();
    Hafas.bind(this.Controller.TP.setInitialSort,this)(this.Controller.TP.getClusterIndexByBitmask(this.Controller.TP.visibleClusterGroup));

    // Tarif-Filter
    this.Controller.TP.tariffFilter = {
      usageL: "ONEWAY",
      classL: "SECOND",
      cardL: "NONE",
      typePersL: "ADULT"
    };

    this.Controller.TP.clusterOptions = [
      {
        type: 'TI',
        label: Hafas.Modules.i18n.get('TP.index.t_N_ClusterOptDuration'),
        icon: 'customer/haf_ic_duration.png'
      },
      {
        type: 'CO',
        label: Hafas.Modules.i18n.get('TP.index.t_N_ClusterOptPrice'),
        icon: 'customer/haf_ic_price.png'
      },
      {
        type: 'CF',
        label: Hafas.Modules.i18n.get('TP.index.t_N_ClusterOptComfort'),
        icon: 'customer/haf_ic_changes.png'
      },
      {
        type: 'UT',
        label: Hafas.Modules.i18n.get('TP.index.t_N_ClusterOptUseableTime'),
        icon: 'customer/haf_ic_time_work.png'
      }
    ];

    this.Controller.TP.geoLocalization = null;
    this.Controller.TP.currentPosition = null;
    this.Controller.TP.outwardDateTimePicker = null;

    this.Controller.TP.currentConnections = [];
    this.Controller.TP.selectedConnection = null;
    this.Controller.TP.reconstructConnection = null; // Strawberry 1.6.0

    if (params.highlightAlarmElements === true) {
      // When navigating from alarm center, the alarm elements should be highlighted once
      this.Controller.TP.highlightAlarmElements = true;
    }

    Hafas.Modules.Loader.loadTemplateFiles(['tp.index.html', 'tp.result.detail.html','common.options.html'], Hafas.bind(function () {
      Hafas.bind(this.Controller.TP.renderIndex, this)(params);
    }, this));
  },

  createIndexModel: function () {
    var favorites = null;
    if (Hafas.Config.Switches.useFavorites) {
      this.Controller.Favorites.instance.checkDataConsistency();
      favorites = this.Controller.Favorites.instance.getData();
    }

    var model = {};

    if (Hafas.Config.TP.useQueryOptions) {
      model.customerOptions = this.Controller.TP.options.get();
      model.optionsChanged = this.Controller.TP.options.haveOptionsChanged();
      model.useOptions = true;
      model.vias = this.Controller.TP.getViaOptionGroup(model.customerOptions.questionList);
      model.viaList = this.Controller.TP.instance.getViaList();
      model.viasOpen = this.Controller.TP.viasOpen;
      model.viaCount = this.Controller.TP.instance.getViaCount();
      model.viaStatusText = this.Controller.TP.getViaStatusText.bind(this)();
    }

    if (Hafas.Config.UI.showFavorites) {
      model.customerFavorites = favorites;
    }


    return model;
  },

  renderIndex: function (params) {
    params = params || {};   // check if params for index method have been passed
    var model = Hafas.bind(this.Controller.TP.createIndexModel, this)();

    // In some cases, it is not necessary to add the initial call of the form to the history (e.g. coming from the alarm center "details" link)
    if (Hafas.Modules.History && (params.addToHistory === undefined || params.addToHistory == true))
      Hafas.Modules.History.addData("TP", "index", {});

    var me = this;

    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ TP.index +++ DEBUG Model +++', model)
    }

    // EuSpirit Start
    if (Hafas.Config.Switches.useEuSpirit && Hafas.Config.euSpiritRegions && Hafas.Config.euSpiritRegions.length !== 0) {

      var euRegionOptionsFrom = Hafas.Config.euSpiritRegions.map(function (region, index) {
        var result = {
          index: index,
          value: region.prvCtx,
          id: region.prvCtx,
          group: region.optgroup,
          content: [{text: region.name}]
        };
        // Für aktive Region selected status
        if (me.Controller.TP.euProvider && me.Controller.TP.euProvider.From && index === me.Controller.TP.euProvider.From.index) {
          result.selected = true;
        }
        return result;
      });

      var euRegionOptionsTo = Hafas.Config.euSpiritRegions.map(function (region, index) {
        var result = {
          index: index,
          value: region.prvCtx,
          id: region.prvCtx,
          group: region.optgroup,
          content: [{text: region.name}]
        };

        // Für aktive Region selected status
        if (me.Controller.TP.euProvider && me.Controller.TP.euProvider.To && index === me.Controller.TP.euProvider.To.index) {
          result.selected = true;
        }
        return result;
      });

      this.Controller.TP.euProvider = this.Controller.TP.euProvider || {
        From: {},
        To: {}
      };

      model.euFromOptions = {
        holder: 'HFS_EuSelectFromWrap',
        id: 'HFS_EuSelectFrom',
        hideLabel: true,
        label: Hafas.Modules.i18n.get('TP.index.t_N_EuSpiritDepRegion'),
        options: euRegionOptionsFrom,
        callback: function (data) {
          Hafas.ps.pub('/tp/changeEUSpiritOption', [{name: 'euDepRegion', value: data.value}]);
        }
      };

      model.euToOptions = {
        holder: 'HFS_EuSelectToWrap',
        id: 'HFS_EuSelectTo',
        hideLabel: true,
        label: Hafas.Modules.i18n.get('TP.index.t_N_EuSpiritArrRegion'),
        options: euRegionOptionsTo,
        callback: function (data) {
          Hafas.ps.pub('/tp/changeEUSpiritOption', [{name: 'euArrRegion', value: data.value}]);
        }
      };
    }
    // EUSpirit Ende

    var formContainer = Hafas("#" + me.formContainer);
    formContainer.innerHTML = Hafas.Modules.Render.renderTemplate("TP_TplIndex", model);

    Hafas.Util.gui.focusTabOrMenuButton();

    me.Controller.TP.currentForm = Hafas('#HFS_FormTripSearch', false, formContainer);

    // Lade eventuell ge?nderte Optionen in die Formular-GUI
    Hafas.ps.pub('/options/setChangedOptionsInputForm', [{}]);


    if (Hafas.Config.TP.unifiedPlanner.show) {
      me.Controller.TP.setFormForOverview(false);
    }

    me.Controller.TP.inpFrom = Hafas.Core.newType('hafasSuggest', {
      loc: "From",
      type: "S",
      onSelect: function (loc) {
        Hafas.bind(me.Controller.TP.validateSelection, me)('dep', loc);
      },
      onClear: function () {
        Hafas.ps.pub('/map/clearLocationMarker', ["dep"]);
      },
      onBlur: function(){
        // Wenn nichts mehr im Inputfeld eingegeben wurde, Location auch aus Datenobjekt löschen
        if(me.Controller.TP.inpFrom.inp.value.length == 0){
          try {
              me.Controller.TP.instance.clearDep();
          } catch (e) {
            Hafas.logger.warn(Hafas.logger.ERROR_TYPES.JS, "tp.clearDep", "Departure-Eingabefeld konnte nicht geleert werden.", e);
          }
        }
      }
    });
    me.Controller.TP.inpTo = Hafas.Core.newType('hafasSuggest', {
      loc: "To",
      type: "Z",
      onSelect: function (loc) {
        Hafas.bind(me.Controller.TP.validateSelection, me)('arr', loc);
      },
      onClear: function () {
        Hafas.ps.pub('/map/clearLocationMarker', ["arr"]);
      },
      onBlur: function() {
        // Wenn nichts mehr im Inputfeld eingegeben wurde, Location auch aus Datenobjekt löschen
        if(me.Controller.TP.inpTo.inp.value.length == 0){
           try {
             me.Controller.TP.instance.clearArr();
           } catch (e) {
             Hafas.logger.warn(Hafas.logger.ERROR_TYPES.JS, "tp.clearArr", "Arrival-Eingabefeld konnte nicht geleert werden.", e);
           }
        }
      }
    });

    var tmpLoc = me.Controller.TP.instance.getLocation("dep");
    if (tmpLoc != null) {
      me.Controller.TP.inpFrom.setLocation(tmpLoc);
    }

    tmpLoc = me.Controller.TP.instance.getLocation("arr");
    if (tmpLoc != null) {
      me.Controller.TP.inpTo.setLocation(tmpLoc);
    }

    // Wenn Vias im Formular angezeigt werden, muss Drag & Drop initialisiert werden
    if(Hafas.Config.TP.vias.showInForm){
       Hafas.bind(this.Controller.TP.initializeSortableInputs,this)();
    }


    Hafas.ps.pub('/options/init', [{context: "TP"}]);

    if (Hafas.Config.TP.useQueryOptions && Hafas.Config.Options.storeOptions && me.Controller.TP.localOptionsLoaded === false) {
      // Use stored options in loading the view once, if options are active and the storeOptions config is set
      Hafas.ps.pub('/options/storage/set');
      me.Controller.TP.localOptionsLoaded = true;
    }

    // setting tdp-configuration
    var dateTimePickerConfig = {
      holder: "HFS_TpDateTimePickerHolder",
      id: "TpOutDTP",
      config: {},
      current: {
        date: me.Controller.TP.instance.getOutDate(),
        time: me.Controller.TP.instance.getOutTime(),
        // Strawberry 1.5: [BugFix] Von kleinigkeiten die in der RMV Version aufgefallen sind und [Upgrade] schnelleres Rendern ohne klonen
        enquiry: me.Controller.TP.instance.getOutFrwd(),
        isNowMode: me.Controller.TP.instance.getTimeNow()
      }
    };

    me.Controller.TP.dateTimePicker = Hafas.Core.newType('hafasTimeDatePicker', dateTimePickerConfig);

    // Favoriten als SegmentedControl
    if (Hafas.Config.UI.showFavoriteBox === true) {
      if (Hafas("#HFS_CustomerFavoritesWrap") !== null) {
        Hafas.Core.newType('HafasSegmentedControl', {holder: 'HFS_CustomerFavoritesWrap'}).initiate();
      }
    }

    // EuSpirit Selectboxen
    if (Hafas.Config.Switches.useEuSpirit && Hafas.Config.euSpiritRegions && Hafas.Config.euSpiritRegions.length !== 0) {
      this.Controller.TP['euSpiritSelectBoxFrom'] = Hafas.Core.newType('HafasSelectBox', model.euFromOptions).initiate({callback:true});
      this.Controller.TP['euSpiritSelectBoxTo'] = Hafas.Core.newType('HafasSelectBox', model.euToOptions).initiate({callback:true});
      // Switch From To erst nach Eingabe der Regionen aktivieren
      var stateFrom = this.Controller.TP['euSpiritSelectBoxFrom'].getState();
      var stateTo = this.Controller.TP['euSpiritSelectBoxTo'].getState();
      if (stateFrom.active === 0 || stateTo.active === 0) {
        Hafas('#HFS_TpSwitchFromTo', false).disabled = true;
      }
    }

    if(Hafas.Config.TP.vias.showInForm && this.Controller.TP.viasOpen){
       this.Controller.TP.updateViaFieldVisibility.bind(this)();
       this.Controller.TP.showViaForm.bind(this)();
    }

    me.Controller.TP.currentView = "index";

    if(this.Controller.Common.initialStartSet === true) {
      Hafas.ps.pub('/GUI/form/hide');
      Hafas.bind(this.Controller.GUI.common.showPageLoader, this)(Hafas.Modules.i18n.get('TP.index.t_N_WaitSearchConnection'));
    }


    Hafas.ps.pub('/app/events/renderDone');
    Hafas.ps.pub('/app/updateBanner', ['tpInput']);

    // f?lle die UIActions des TP-Moduls
    // TP_TplFormUIActions
    if (Hafas("#" + me.formUIHiddenActions)) {
      Hafas("#" + me.formUIHiddenActions).innerHTML = Hafas.Modules.Render.renderTemplate("Common_TplFormUIActions", {appcontext: 'TP'});
    }

    Hafas.bind(this.Controller.TP.restoreTripMarker, this)();

    // Track
    Hafas.ps.pub('/tracking/screen/journey-planner-main', [{typ: 'screen', key: 'journey-planner-main'}]);
    Hafas.ps.pub('/tracking/screen/tripplanner-main', [{typ: 'screen', key: 'tripplanner-main'}]);
    // Wenn keine initiale Suche gestartet wurde über URL Parameter, dann Formular ganz normal anzeigen
    if(this.Controller.Common.initialStartSet === undefined) {
      Hafas.ps.pub('/GUI/form/show', [{}]);
    }else{
      // Bei Direkt angetriggerter Suche wird das Formular nicht eingeblendet
      Hafas.ps.pub('/GUI/form/hide', [{}]);
    }

    if (this.Controller.TP.highlightAlarmElements === true) {
      // Highlight specific elements if we came from Push via "Add trip alarm"
      Hafas.ps.pub('/GUI/common/highlightingInput',[{type: 'element', element: Hafas('#' + this.Controller.TP.inpFrom.inp.id), className: 'js_highLightingGlow', keepClass: true }]);
      Hafas.ps.pub('/GUI/common/highlightingInput',[{type: 'element', element: Hafas('#' + this.Controller.TP.inpTo.inp.id), className: 'js_highLightingGlow', keepClass: true }]);
    }

    Hafas.ps.pub('/favorites/update'); // Commit [8654bb8] Strawberry 1.5.0
    Hafas.ps.pub('/app/events/resize');
    Hafas.ps.pub('/app/contextLoaded/' + me.appContext);
    // Render Onboarding tooltip
    if(Hafas.Config.Switches.useOnboarding) {
      Hafas.ps.pub('/gui/showOnboardingToolTip', [{
        id: "mainOptions",
        context: "TP",
        highlightingPadding:8,
        anchorElement: Hafas('#HFS_OptionsButtonTP', false)
      }]);
    }
  },
  /**
   * Initializes all TP Input fields with the sortable / draggable functionality
   *
   * @method initializeSortableInputs
   */
  initializeSortableInputs: function(){
      // Alle drag handles finden
      var dragHandles = Hafas('#HFS_TPCoreForm [data-field="draghandle"]',true);

      var self = this;
      for(var d=0; d < dragHandles.length;d++){
         var mouseMoveListener;
         var tmpHandle = dragHandles[d];
         tmpHandle.onmousedown = function(){
           self.Controller.TP.calculateDraggableInputs.bind(self)();


           var handle = this;
           var idOfInput = handle.getAttribute('data-drag-for');
           var inputToMove = Hafas('#HFS_' + idOfInput + 'Container',false);

           // Highlight Error ggfs. entfernen
           var viaIndex = inputToMove.getAttribute("data-via-index");
           if(viaIndex !== null){
              Hafas('[data-form-via="' + viaIndex + '"] .lyr_tpInputWrap',false).removeClassName('js_highLightingError');
           }

           var originalPosY = Hafas.Util.getPosY(inputToMove);

           self.Controller.TP.draggingInputsActive = true;

           var relClientRectY =  inputToMove.getBoundingClientRect().top - Hafas('#HFS_TPInputMainWrapper').getBoundingClientRect().top;

           // Klasse an Hauptcontainer beim Draggen heften
           Hafas('#HFS_TPInputMainWrapper',false).addClassName("lyr_tpDragInProgress");

           mouseMoveListener = function (evt) {
             // stop touch event
             evt.stopPropagation();
             evt.preventDefault();

              var width = inputToMove.clientWidth;

              var maxContainerRangeY = Hafas('#HFS_TPInputMainWrapper').clientHeight - Hafas.Util.getPosY(Hafas('#HFS_TPInputMainWrapper') ) - relClientRectY;
              if(Hafas('#TP_ResultActionbar',false)){
                maxContainerRangeY += Hafas('#TP_ResultActionbar',false).clientHeight;
              }

              var clientY = evt.clientY || evt.touches[0].clientY;

              var posY = Math.min(maxContainerRangeY, (clientY - originalPosY - (inputToMove.clientHeight/2)));

              inputToMove.setAttribute('drag-input-container',true);
              inputToMove.style.position = 'absolute';
              inputToMove.style.width = width + 'px';
              inputToMove.style.left = '40px';
              inputToMove.style.zIndex = 1000;
              inputToMove.style.top = Math.max(Math.min(0,-relClientRectY), posY) + "px";
              inputToMove.setAttribute('drag-y-sort', inputToMove.getBoundingClientRect().top);

              var containerSpacer = Hafas('#HFS_' + idOfInput + 'ContainerSpacer',false);
              Hafas.Util.gui.setVisibility(containerSpacer,true);

              self.Controller.TP.updateSortableInput.bind(self,evt.clientY, idOfInput,posY,inputToMove)();
           }

           Hafas('#HFS_TPInputMainWrapper').addEventListener('mousemove', mouseMoveListener);
           Hafas('#HFS_TPInputMainWrapper').addEventListener('touchmove', mouseMoveListener);
         }
         tmpHandle.ontouchstart = tmpHandle.onmousedown;

         var self = this;
         var resetInputMouseMove = function(){
          if(self.Controller.TP.draggingInputsActive) {
            Hafas('#HFS_TPInputMainWrapper',false).removeClassName("lyr_tpDragInProgress");
            if (Hafas('#HFS_TPInputMainWrapper')) {
              Hafas('#HFS_TPInputMainWrapper').onmousemove = null;
              var elems = Hafas('[data-dragtype]', true);
              var newOrder = [];
              for (var f = 0; f < elems.length; f++) {
                var tmpElement = elems[f];
                tmpElement.setAttribute('drag-y-sort', tmpElement.getBoundingClientRect().top);
                var objOrder = {
                  sort: parseInt(tmpElement.getAttribute("drag-y-sort")),
                  type: tmpElement.getAttribute("data-dragtype")
                };
                var isVia = false;
                var viaShown;
                if (tmpElement.getAttribute("data-via-index") != null) {
                  isVia = true;
                  objOrder.viaIndex = parseInt(tmpElement.getAttribute("data-via-index"));
                  viaShown = Hafas('[data-form-via="' + objOrder.viaIndex + '"]',false).getAttribute("hidden");
                }
                if(!isVia || viaShown == null) {
                  newOrder.push(objOrder);
                }
                tmpElement.removeAttribute('style');
                tmpElement.removeAttribute("drag-width");
              }
              self.Controller.TP.updateInputLocationsOrder.bind(self)(newOrder);

              var containerSpacer = Hafas('.lyr_tpInputHollowPlaceholder', true);
              for (var f = 0; f < containerSpacer.length; f++) {
                var tmpSpacer = containerSpacer[f];
                Hafas.Util.gui.setVisibility(tmpSpacer, false);
              }
            }
          }
          self.Controller.TP.draggingInputsActive = false;
          Hafas('#HFS_TPInputMainWrapper')?.removeEventListener('mousemove', mouseMoveListener);
          Hafas('#HFS_TPInputMainWrapper')?.removeEventListener('touchmove', mouseMoveListener);
         }
         Hafas.Core.listenToEvent(window, "mouseup", resetInputMouseMove);
         Hafas.Core.listenToEvent(window, "touchend", resetInputMouseMove);
         Hafas.Core.listenToEvent(window, "touchcancel", resetInputMouseMove);
      }

      // Initializes context menues (For mode with duration of stay)
      if(Hafas.Config.TP.vias.durationOfStay) {
         this.Controller.TP.updateViaContextMenus.bind(this)();
      }
  },
  cancelDragDrop: function (){
    if(!this.Controller.TP.draggingInputsActive){
      return;
    }

    Hafas('#HFS_TPInputMainWrapper',false).removeClassName("lyr_tpDragInProgress");
    if (Hafas('#HFS_TPInputMainWrapper')) {
      Hafas('#HFS_TPInputMainWrapper').onmousemove = null;
      var elems = Hafas('[data-dragtype]', true);
      var newOrder = [];
      for (var f = 0; f < elems.length; f++) {
        var tmpElement = elems[f];
        tmpElement.setAttribute('drag-y-sort', tmpElement.getBoundingClientRect().top);
        var objOrder = {
          sort: parseInt(tmpElement.getAttribute("drag-y-sort")),
          type: tmpElement.getAttribute("data-dragtype")
        };
        var isVia = false;
        var viaShown;
        if (tmpElement.getAttribute("data-via-index") != null) {
          isVia = true;
          objOrder.viaIndex = parseInt(tmpElement.getAttribute("data-via-index"));
          viaShown = Hafas('[data-form-via="' + objOrder.viaIndex + '"]',false).getAttribute("hidden");
        }
        if(!isVia || viaShown == null) {
          newOrder.push(objOrder);
        }
        tmpElement.removeAttribute('style');
        tmpElement.removeAttribute("drag-width");
        //
      }
      this.Controller.TP.updateInputLocationsOrder.bind(this)(newOrder);

      var containerSpacer = Hafas('.lyr_tpInputHollowPlaceholder', true);
      for (var f = 0; f < containerSpacer.length; f++) {
        var tmpSpacer = containerSpacer[f];
        Hafas.Util.gui.setVisibility(tmpSpacer, false);
      }
    }
    this.Controller.TP.draggingInputsActive = false;
  },
  /**
   * updates all the via context menus for via duration options
   *
   * @method updateViaContextMenus
   */
  updateViaContextMenus: function(){
    this.Controller.TP.clearViaContextMenus.bind(this)();
    Hafas('.lyr_viaActionBtn', true).forEach(function (elem) {
      var menuConf = Hafas.Core.clone(Hafas.Config.TP.vias.actionMenu);
      var contentToAdd = [];
      menuConf.className = 'lyr_tpViaOptionsContextMenu';
      menuConf.zIndex = 20000;
      menuConf.title = Hafas.Modules.i18n.get(menuConf.title);
      menuConf.stickTo = 'right';
      var cont = menuConf.content;
      for(var idx = 0, length = cont.length; idx < length; idx++){
        var viaIdx = elem.getAttribute("id");
        viaIdx = viaIdx.replace((Hafas.Config.TP.vias.durationOfStay) ? 'HFS_ViaMore_' : 'HFS_ViaDelete_', '');
        var viaData = this.Controller.TP.instance.getVia(viaIdx);

        // Text für Kontextmenü wählen je nach dem, ob bereits eine Aufenthaltsdauer gesetzt ist
        if(cont[idx].id === 'changeLayoverDur'){
          if (!viaData || viaData.min === 0) {
            cont[idx].text = Hafas.Modules.i18n.get('common.label.t_N_SetViaLayover');
          }
        }
        // Menüeintrag für das Löschen der Aufenthaltsdauer nur einblenden, wenn auch eine gesetzt ist
        if(cont[idx].id !== 'deleteLayoverDur' || viaData.min > 0){
          if (cont[idx].text) {
            cont[idx].text = Hafas.Modules.i18n.get(cont[idx].text);
          }
          cont[idx].viaIndex = viaIdx;
          contentToAdd.push(cont[idx]);
        }
      }
      menuConf.content = contentToAdd;

      // Via Menü an Button binden
      var viaMenu = Hafas.Core.newType('HafasContextMenu', menuConf);
      viaMenu.addTo(elem);

      // Via Menü abspeichern
      this.Controller.TP.viaContextsMenus.push(viaMenu);
    }.bind(this));
  },
  /**
   * removes all via context menus
   *
   * @method clearViaContextMenus
   */
  clearViaContextMenus: function(){
     for(var v=this.Controller.TP.viaContextsMenus.length - 1; v >= 0;v--){
        var tmpMenu = this.Controller.TP.viaContextsMenus[v];
        tmpMenu.hide();
        tmpMenu.destroy();
     }
     this.Controller.TP.viaContextsMenus = [];
  },
  updateInputLocationsOrder: function(order){
    var tpInstance = this.Controller.TP.instance;
    order.sort(function(a,b){
      return a.sort - b.sort;
    })
    for(var s=0; s < order.length;s++){
       var loc,min;
       switch(order[s].type){
         case "dep":
         case "arr": loc = tpInstance.getLocation(order[s].type);break;
         case "via":
           loc = null;
           if(tpInstance.getVia(order[s].viaIndex) != "") {
             var tmpVia = tpInstance.getVia(order[s].viaIndex);
             loc = tmpVia.loc;
             min = tmpVia.min;
             order[s].min = min;
           }
           break;
       }
       order[s].loc = loc;
    }
    order = Hafas.Core.clone(order);

    // Locations neu setzen, in jedem Fall vorher alle VIA Marker verwerfen
    this.Controller.Map.clearAllViaMarker.bind(this)();

    // Via Liste resetten
    tpInstance.setViaList([]);

    // Über neue Ordnung iterieren und Locations in der TP Modul Instanz setzen
    for(var m=0; m < order.length;m++){
       if(m == 0){
         // Start
         tpInstance.setLocation("dep",order[m].loc);
       }else if(m == order.length-1){
         // Ziel
         tpInstance.setLocation("arr", order[m].loc);
       }else{
         // Vias
         var viaIdx = m-1;
         var min = order[m].min || 0;
         // Typ überprüfen (Lösung über Parsen der lid Notlösung, da Typ nicht im Datenmodell verfügbar :(
         if(order[m].loc != null) {
           // Wenn Typ für nicht zulässig, entsprechend Feld rot highlighten
           if (Hafas.Config.TP.vias.stationOnly && order[m].loc.type !== "S") {
             Hafas.ps.pub('/GUI/common/highlightingInput', [{type: 'via', viaIndex: viaIdx, className: 'js_highLightingError', keepClass: true }]);
             // Toast anzeigen
             Hafas.ps.pub('/GUI/smallAlert/show', [Hafas.Modules.i18n.get('common.label.t_N_ViaTypeConflict')]);
           }else{
             // in jedem Fall highlightingError Klasse entferne
             Hafas('#HFS_Via'+viaIdx, false).closest('.lyr_tpInputWrap').removeClassName("js_highLightingError");
           }
         }else{
           // in jedem Fall highlightingError Klasse entferne
           Hafas('#HFS_Via'+viaIdx, false).closest('.lyr_tpInputWrap').removeClassName("js_highLightingError");
         }

         tpInstance.setVia({location: order[m].loc, min: min},viaIdx);
         if(order[m].loc != null) {
           Hafas('#HFS_Via' + viaIdx, false).value = order[m].loc.name;
         }
       }
    }

    // Wenn nach dem Umordnen Start oder Ziel nicht mehr belegt sind, so sind die Marker dafür aus der Karte zu entfernen
    if(tpInstance.getLocation("dep") == null){
       this.Controller.Map.clearLocationMarker.bind(this)("dep");
    }
    if(tpInstance.getLocation("arr") == null){
      this.Controller.Map.clearLocationMarker.bind(this)("arr");
    }

    Hafas.bind(this.Controller.TP.options.get, this.Controller.TP.options)(); // trigger update of the model in the options module to set the duration // taken from confirmDurationForVia
    this.Controller.TP.updateViaFieldVisibility.bind(this)();
    this.Controller.TP.updateViaContextMenus.bind(this)();
    this.Controller.TP.calculateDraggableInputs.bind(this)();

    if(this.Controller.TP.currentView == 'overview') {
      Hafas.ps.pub('/tp/events/trigger/unified');
    }
  },
  updateSortableInput: function(posY, id, relPosY,currentDraggedElem){
     var foundId = false;

     // Relative Position des Elements (linke, obere Ecke im Container ermitteln)
     var elemPosY = currentDraggedElem.getBoundingClientRect().top - Hafas('#HFS_TPInputMainWrapper').getBoundingClientRect().top;

     var inputsToMove = [];
     var offset = 4; // Muss noch geprüft werden
     var indexOfDraggedElement = -1;


     // Richtung von oben  nach unten
     var direction = 'down';
     for(var f=0; f < this.Controller.TP.dragableInputElements.length;f++){
         var tmpElement = this.Controller.TP.dragableInputElements[f];
         if(foundId && (elemPosY > 0) && (elemPosY + offset > this.Controller.TP.dragableInputElements[f-1].posY)){
            inputsToMove.push({data: tmpElement, idx: f});
         }
         // Aktuell bewegtes Element wird ermittelt
         if(tmpElement.id == id){
             foundId = true;
             indexOfDraggedElement = f;
         }
     }
     // Andere Richtung versuchen
     if(inputsToMove.length == 0){
        for(var b=indexOfDraggedElement;b > 0; b--){
            var tmpElement = this.Controller.TP.dragableInputElements[b-1];

            if(elemPosY > 0 && elemPosY < (this.Controller.TP.dragableInputElements[b-1].posY + this.Controller.TP.dragableInputElements[b-1].elem.clientHeight)){
               inputsToMove.push({data: tmpElement, idx: b-1});
            }
        }
        direction = 'up';
     }

     // Für jedes Feld, welches bewegt werden muss wird das zugehörige Placehoder Element angezeigt
     var boundingTopMinY = Hafas('#HFS_TPInputMainWrapper',false).getBoundingClientRect().top;

     for(var m=0; m < inputsToMove.length;m++){
        var dataElem = inputsToMove[m].data;
        var inputToMove = Hafas('#HFS_' + dataElem.elem.id + 'Container',false);

        var elemPosYOffset = 0;
        if(m > 0){
             for(var t=m;t > 0;t--){
                elemPosYOffset += (inputsToMove[t].data.posY - inputsToMove[t-1].data.posY);
             }
        }
        elemPosYOffset += (indexOfDraggedElement*48);

        inputToMove.style.position = 'absolute';


        //  Berechnete Position vom Element nach Mausbewegung
        var currPosY = -elemPosY + elemPosYOffset;

        // Element wird entgegengesetzt verschoben zu dem aktuellen Element, welches bewegt wird
        var minY = 48;
        // if(Hafas.Config.TP.vias.durationOfStay && dataElem.id.indexOf("Via") != -1){
        //    minY += 18;
        // }
        var topValue = Math.max(currPosY, -minY);
        if(direction == 'up'){
           minY *= -1;
           topValue = Math.min(currPosY, -minY);
        }

        inputToMove.style.top = topValue + "px";
        inputToMove.style.left = '40px';
        inputToMove.style.zIndex = 900;
        inputToMove.setAttribute('drag-input-container',true);
        inputToMove.style.width = currentDraggedElem.clientWidth + "px";

        var containerSpacer = Hafas('#HFS_' + dataElem.elem.id + 'ContainerSpacer',false);
        Hafas.Util.gui.setVisibility(containerSpacer,true);
     }
  },
  calculateDraggableInputs: function(){
    var draggableInputs = Hafas('[data-drag-element]',true,Hafas('#HFS_TPInputMainWrapper'));
    var draggableElementsObj = [];
    for(var i=0; i < draggableInputs.length;i++){
      var draggableInput = draggableInputs[i];
      var viaIndex = draggableInput.getAttribute('data-via-form-index');
      var viaCount = this.Controller.TP.instance.getViaCount();
      if(viaIndex === null || viaIndex <= viaCount){
        draggableElementsObj.push({
          elem: draggableInput,
          id: draggableInput.id,
          posY: draggableInputs[i].getBoundingClientRect().top - Hafas('#HFS_TPInputMainWrapper').getBoundingClientRect().top
        });
      }
    }
    this.Controller.TP.dragableInputElements = draggableElementsObj;
  },
  removeVia: function(viaIndex){
    var _me = this;
    if (_me.Controller.TP.removeViaRunning === true) {
      // Don't jump into recursive calls
      return;
    }
    _me.Controller.TP.removeViaRunning = true;

    // Remove from options
    _me.Controller.TP.options.setRandomParameter("HFS_Via" + viaIndex, "value", "");

    // Clear from data.query.viaLocL
    _me.Controller.TP.instance.clearVia(viaIndex);

    if(Hafas.Config.TP.vias.showInForm){
      // Handles the via field visibility and updates the vias in storage and options
      _me.Controller.TP.updateViaFieldVisibility.bind(this)();
      // Collect the draggable elements from TP form
      _me.Controller.TP.calculateDraggableInputs.bind(this)();
      // Remove the error highlighting
      Hafas('#HFS_Via'+viaIndex, false).closest('.lyr_tpInputWrap').removeClassName("js_highLightingError");

      // Remove marker on the map
      _me.Controller.Map.clearLocationMarker.bind(this)("via",{index: viaIndex});
    }
    // Set options text
    Hafas.ps.pub('/options/setChangedOptionsInputForm', [{}]);

    if(_me.Controller.TP.currentView !== 'index'){
      // Trigger a new search
      Hafas.ps.pub('/tp/events/trigger/unified');
    }
    _me.Controller.TP.removeViaRunning = false;
  },
  changeViaDuration: function(ctxMenu){
    for(var c=0; c < ctxMenu.options.content.length;c++){
      if(ctxMenu.options.content[c].id === 'changeLayoverDur'){
        // Dialog zum Einstellen der Aufenthaltsdauer anzeigen
        this.Controller.TP.showDurationPopover.bind(this)(ctxMenu.options.content[c].viaIndex);
      }
    }
  },
  showDurationPopover: function(viaIndex){
    var _me = this;
    var anchorElement = Hafas('#HFS_ViaMore_' + viaIndex,false);
    var currentViaData = _me.Controller.TP.instance.getVia(viaIndex);

    var model = {
      viaIndex: viaIndex,
      hours: parseInt(currentViaData.min / 60),
      minutes: parseInt(currentViaData.min % 60)
    };

    _me.Controller.TP.viaDurationPopover = Hafas.Core.newType("HafasOverlay", {
      app: _me,
      title: '',
      anchorElement: anchorElement,
      anchoredOverlay: 'DESKTOP',
      centerArrow: true,
      outputHTML: Hafas.Modules.Render.renderTemplate("TP_AtomTplDurationPopover", model),
      cssClass: 'lyr_viaDurationPopover',
      onClose: function () {
        Hafas.Util.gui.restoreFocus('#HFS_ViaMore_' + viaIndex);
      }.bind(this),
      callback: function (html, err) {
        Hafas.Util.gui.selectInputText(Hafas('#HFS_ViaDuration_hours',false));
      }
    });
  },
  /**
   * Shows a via info popup, when number of vias is exceeded
   *
   * @method showViaInfoPopup
   */
  showViaInfoPopup: function(){

    var _me = this;
    var model = {};
    _me.Controller.TP.viaExceededPopover = Hafas.Core.newType("HafasOverlay", {
      app: _me,
      title: '',
      outputHTML: Hafas.Modules.Render.renderTemplate("TP_AtomTplViaExceededPopover", model),
      cssClass: 'lyr_viaExceededPopover',
      onClose: function () {

      }.bind(this),
      callback: function (html, err) {
      }
    });
  },
  /**
   * Closes the via info popup (number of vias exceeded)
   *
   * @method closeConfirmViaExceededPopover
   */
  closeConfirmViaExceededPopover: function(){
    this.Controller.TP.viaExceededPopover.close();
  },
  confirmDurationForVia: function(data){
     var _me = this;
     var viaIndex = data.viaIndex;
     var inputHours = Hafas('#HFS_ViaDuration_hours',false);
     var inputMinutes = Hafas('#HFS_ViaDuration_minutes',false);
     var hoursFromInput = parseInt(inputHours.value);
     var minutesFromInput = parseInt(inputMinutes.value)

     // Prüfen, ob korrekte Zahlen eingegeben worden sind, sonst highlighten
     var hoursValid = !(isNaN(parseInt(hoursFromInput)));
     var minutesValid = !(isNaN(parseInt(minutesFromInput)));

     // Check if both hours and minutes are not filled
     if(!hoursValid && !minutesValid){
       Hafas.ps.pub('/GUI/common/highlightingInput', [{
         type: 'layover_minutes',
         className: 'js_highLightingError',
         keepClass: true
       }]);
       Hafas.ps.pub('/GUI/common/highlightingInput', [{
         type: 'layover_hours',
         className: 'js_highLightingError',
         keepClass: true
       }]);
        return;
     }else{
       if(hoursValid) {
         inputHours.value = hoursFromInput;
         inputHours.removeClassName("js_highLightingError");
       }
       if(minutesValid) {
         inputMinutes.value = minutesFromInput;
         inputMinutes.removeClassName("js_highLightingError");
       }
     }

     var minutes = 0;
     // Check if hours were entered
     if(isNaN(hoursFromInput) == false) {
       minutes = hoursFromInput * 60;
     }
     if(isNaN(minutesFromInput) == false) {
       minutes += minutesFromInput;
     }
     this.Controller.TP.instance.setViaDuration(viaIndex, {minDuration: minutes });
     this.Controller.TP.options.get(); // trigger update of the model in the options module to set the duration

     // Wenn Verspätung > 0 Minuten, Feld in der Übersicht sichtbar machen:
     this.Controller.TP.updateDurationViaTxt.bind(this)(minutes,viaIndex);

     if(_me.Controller.TP.viaDurationPopover){
       _me.Controller.TP.viaDurationPopover.close();
       _me.Controller.TP.viaDurationPopover = null;
     }

     // Trigger unified planner search
    if (_me.Controller.TP.currentView === 'overview') {
      Hafas.ps.pub('/tp/events/trigger/unified');
    }
  },
  updateDurationViaTxt: function(minutes,viaIndex){
    var layoverTxt = this.Controller.TP.formatViaDurationSummary(minutes);
    var targetContainer = Hafas('[data-form-via="' + viaIndex + '"] .lyr_viaDurationSummary',false);
    var show = (minutes > 0)?true:false;

    targetContainer.innerHTML = layoverTxt;
    Hafas.Util.gui.setVisibility(targetContainer,show);

    // Contextmenüs aktualisieren
    this.Controller.TP.updateViaContextMenus.bind(this)();
  },
  resetDurationForVia: function(data){
    var viaIndex = data.viaIndex;
    Hafas('#HFS_ViaDuration_hours',false).value = '0';
    Hafas('#HFS_ViaDuration_hours',false).removeClassName("js_highLightingError");
    Hafas('#HFS_ViaDuration_minutes',false).value = '0';
    Hafas('#HFS_ViaDuration_minutes',false).removeClassName("js_highLightingError");
    this.Controller.TP.instance.setViaDuration(viaIndex, {minDuration: 0 });
  },
  deleteViaDuration: function(ctxMenu){
    for(var c=0; c < ctxMenu.options.content.length;c++){
      if(ctxMenu.options.content[c].id === 'deleteLayoverDur'){
        // Via Dauer entsprechend löschen
        var viaIndex = ctxMenu.options.content[c].viaIndex;
        this.Controller.TP.instance.setViaDuration(viaIndex, {minDuration: 0 });
        this.Controller.TP.updateDurationViaTxt.bind(this)(0,viaIndex);

        // Trigger unified planner search
        if (this.Controller.TP.currentView === 'overview') {
          Hafas.ps.pub('/tp/events/trigger/unified');
        }
      }
    }
  },
  deleteViaCtxMenu: function(ctxMenu){
    for(var c=0; c < ctxMenu.options.content.length;c++){
      if(ctxMenu.options.content[c].id === 'deleteVia'){
        // Via entsprechend löschen
        this.Controller.TP.removeVia.bind(this)(ctxMenu.options.content[c].viaIndex);
        this.Controller.TP.updateViaContextMenus.bind(this)();
      }
    }
  },
  getViaOptionGroup: function(questionList){
    for(var v=0; v < questionList.length;v++){
       if(questionList[v].name === 'via_group'){
         return questionList[v].groupElements;
       }
    }
    return null;
  },
  validateSelection: function (type, loc) {
    // location setzen
    this.Controller.TP.instance.setLocation(type, loc);

    if (type === 'dep') {
      // form validieren
      this.Controller.TP.validate(['From'], Hafas.bind(function () {
        Hafas.Core.newType("hafasValidation", {
          form: this.Controller.TP.currentForm
        });
      }, this));
    } else if (type === 'arr') {
      // form validieren
      this.Controller.TP.validate(['To'], Hafas.bind(function () {
        Hafas.Core.newType("hafasValidation", {
          form: this.Controller.TP.currentForm
        });
      }, this));
    }
  },
  showLocationSelectionPopover: function(data,triggerElem){

    var _me = this;
    var model = {
      loc: Hafas.Modules.Render.objectKeeper.get(data.loc),
      id: data.id,
      favEntry: data.favEntry
    };

    if (data.allowDelete !== undefined) {
      model.allowDelete = data.allowDelete
    }

    // Typ überprüfen
    var type = model.loc.type;

    // Prüfen, ob der Via Button noch im Popover dargestellt werde darf (Station-only Via Schalter wird dabei mit betrachtet)
    if(Hafas.Config.TP.vias.amount > 0 &&
        _me.Controller.TP.instance.getViaCount() < Hafas.Config.TP.vias.amount &&
        (!Hafas.Config.TP.vias.stationOnly || type === "S") &&
        Hafas.Config.Switches.useEuSpirit === false
    ){
       model.showViaButton = true;
    }
    triggerElem.parentNode.addClassName('lyr_selectedFav');

    if(_me.Controller.TP.locationSelectPopover) {
      Hafas.bind(_me.Controller.TP.hideLocationSelectionPopover, _me)();
    }



    model.popoverCloseEvent = '/tp/favorites/closeLocationPopover';
    _me.Controller.TP.locationSelectPopover = Hafas.Core.newType("HafasOverlay", {
      app: _me,
      title: '',
      anchorElement: triggerElem.parentNode,
      anchoredOverlay: 'DESKTOP',
      triggerElement: triggerElem,
      outputHTML: Hafas.Modules.Render.renderTemplate("TP_AtomTplLocationSelectPopover", model),
      cssClass: 'lyr_locationSelectPopover',
      onClose: function () {
        var anchor = this.Controller.TP.locationSelectPopover.getAnchorElement();
        if(anchor){
          anchor.removeClassName('lyr_selectedFav');
        }
        this.Controller.TP.locationSelectPopover = null;
        Hafas.ps.pub('/favorites/trackDialogAction',['dialog-cancelled']);
      }.bind(this),
      callback: function (html, err) {

      }
    });
  },
  showDefaultQuickFavoritePopover: function(data,triggerElem){
    var model = {
      favEntry:true,
      isDefaultIcon:true,
      name:data.name,
      prod:data.prod
    };

    model.popoverCloseEvent = '/tp/favorites/closeLocationPopover';
    this.Controller.TP.locationSelectPopover = Hafas.Core.newType("HafasOverlay", {
      app: this,
      title: '',
      anchorElement: triggerElem.parentNode,
      anchoredOverlay: 'DESKTOP',
      triggerElement: triggerElem,
      outputHTML: Hafas.Modules.Render.renderTemplate("TP_AtomTplLocationSelectPopover", model),
      cssClass: 'lyr_locationSelectPopover',
      onClose: function () {
        var anchor = this.Controller.TP.locationSelectPopover.getAnchorElement();
        if(anchor){
          anchor.removeClassName('lyr_selectedFav');
        }
        this.Controller.TP.locationSelectPopover = null;
        Hafas.ps.pub('/favorites/trackDialogAction',['dialog-cancelled']);
      }.bind(this),
      callback: function (html, err) {

      }
    });
  },
  hideLocationSelectionPopover: function(){
    var _me = this;
    if(_me.Controller.TP.locationSelectPopover){
      var anchor = _me.Controller.TP.locationSelectPopover.getAnchorElement();
      if(anchor){
         anchor.removeClassName('lyr_selectedFav');
      }
      _me.Controller.TP.locationSelectPopover.close();
      _me.Controller.TP.locationSelectPopover = null;
      Hafas.ps.pub('/favorites/trackDialogAction',['dialog-cancelled']);
    }
  },
  showConnectionsHistoryPopover:function (data,triggerElem){
    var _me = this;
    triggerElem.parentNode.addClassName('lyr_selectedFav');
    if(_me.Controller.TP.ConnectionsHistoryPopover) {
      Hafas.bind(_me.Controller.TP.hideConnectionsHistoryPopover, _me)();
    }
    data.popoverCloseEvent = '/tp/favorites/connectionsHistory/closePopover';
    _me.Controller.TP.ConnectionsHistoryPopover = Hafas.Core.newType("HafasOverlay", {
      app: _me,
      title: '',
      anchorElement: triggerElem.parentNode,
      anchoredOverlay: 'DESKTOP',
      outputHTML: Hafas.Modules.Render.renderTemplate("TP_AtomTplConnectionsHistoryPopover", data),
      cssClass: 'lyr_locationSelectPopover',
      onClose: function () {
        var anchor = this.Controller.TP.ConnectionsHistoryPopover.getAnchorElement();
        if(anchor){
          anchor.removeClassName('lyr_selectedFav');
        }
        this.Controller.TP.ConnectionsHistoryPopover = null;
        Hafas.ps.pub('/favorites/trackDialogAction',['dialog-cancelled']);
      }.bind(this),
      callback: function (html, err) {

      }
    });


  },
  hideConnectionsHistoryPopover: function(){
    var _me = this;
    if(_me.Controller.TP.ConnectionsHistoryPopover){
      var anchor = _me.Controller.TP.ConnectionsHistoryPopover.getAnchorElement();
      if(anchor){
        anchor.removeClassName('lyr_selectedFav');
      }
      _me.Controller.TP.ConnectionsHistoryPopover.close();
      _me.Controller.TP.ConnectionsHistoryPopover = null;
      Hafas.ps.pub('/favorites/trackDialogAction',['dialog-cancelled']);
    }
  },
  selectDateTimeFromPicker: function (hciDate, hciTime, enquiry, nowMode) {
    this.Controller.TP.instance.setOutTime(hciTime);
    this.Controller.TP.instance.setOutDate(hciDate);
    this.Controller.TP.instance.setTimeNow(nowMode);
    this.Controller.TP.instance.setOutFrwd(enquiry);
    // Unified Planner Neusuche darf nur angestossen werden, wenn man in der Overview ist
    if(this.Controller.TP.currentView == 'overview') {
      Hafas.ps.pub('/tp/events/trigger/unified');
    }
  },
  setLocation: function (type, location) {
    this.Controller.TP.instance.setLocation(type, location);
    if (type == "dep")
      this.Controller.TP.inpFrom.setLocation(location);
    else if (type == "arr")
      this.Controller.TP.inpTo.setLocation(location);
  },
  setDate: function (hcidate) {
    this.Controller.TP.instance.setOutDate(hcidate);
    this.Controller.TP.dateTimePicker.setDate(hcidate);
    this.Controller.TP.dateTimePicker.setTimeNow(false);
    this.Controller.TP.instance.setTimeNow(false);
    this.Controller.TP.dateTimePicker.updateDisplay();
  },
  setTime: function (hcitime) {
    this.Controller.TP.instance.setOutTime(hcitime);
    this.Controller.TP.dateTimePicker.setTime(hcitime);
    this.Controller.TP.dateTimePicker.setTimeNow(false);
    this.Controller.TP.instance.setTimeNow(false);
    this.Controller.TP.dateTimePicker.updateDisplay();
  },
  setEnquiry: function (enquiry) {
    this.Controller.TP.dateTimePicker.setEnquiry(enquiry);
    this.Controller.TP.dateTimePicker.setTimeNow(false);
    this.Controller.TP.instance.setTimeNow(false);
    this.Controller.TP.instance.setOutFrwd(enquiry);
    this.Controller.TP.dateTimePicker.updateDisplay();
  },
  /**
   * Set a parameter in the instance's query model.
   * @param {Object} params - Details of the parameter to set.
   * @param {string} params.id - The ID of the query parameter, currently only 'HFS_wheelchair' or 'HFS_economic'
   * @param {boolean} params.value - The value to set (true or false)
   */
  setQueryParameter: function (params) {
    if (params.id && params.value != null) {
      var instance = this.Controller.TP.instance;
      switch (params.id) {
        case 'HFS_wheelchair':
          instance.setJourneyFilter({name: 'ATTRJ', mode: 'INC', jnyFltrValue: 'HS', value: params.value});
          break;
        case 'HFS_economic':
          instance.setQueryParameter('economic', params.value);
          break;
      }
    }
  },
  toggleCurrentPosition: function (boolval, location) {
    this.main.Controller.TP.geoLocalization = boolval;
    this.main.Controller.TP.currentPosition = location;
    this.main.Controller.TP.toggleSuggestGeoFilter(boolval, location);
  },
  toggleSuggestGeoFilter: function (boolval, location) {
    var suggestInstances = ["inpFrom", "inpTo", "inpHFS_Via0", "inpHFS_Via1"];
    if (location == null) {
      for (var j = 0; j < suggestInstances.length; j++) {
        this[suggestInstances[j]].setLocationFilter(null, boolval);
      }
      return;
    }
    for (var j = 0; j < suggestInstances.length; j++) {
      this[suggestInstances[j]].setLocationFilter({
          "ngramm": {
            "crd": {
              "x": location.lon,
              "y": location.lat
            },
            "type": "DIST_PERI"
          },
          "type": "NGR"
        },
        boolval);
    }
  },
  /**
   * Show or hide via input fields as needed.
   * @param {boolean} focusFirstVia - Whether to focus the first via automatically if shown
   */
  updateViaFieldVisibility: function (focusFirstVia) {
    if (this.Controller.TP.updateViaFieldsRunning === true) {
      // Don't jump into recursive calls
      return;
    }
    this.Controller.TP.updateViaFieldsRunning = true;
    var animationTimeout = 500;
    // Check how many via containers are allowed to be shown
    var tpInstance = this.Controller.TP.instance;
    var formViaElements = Hafas('[data-form-via]',true);

    // Reset duration of stay (GUI)
    Hafas('[data-form-via] .lyr_viaDurationSummary',true).forEach(function(elem){
       elem.innerHTML = '';
    });

    for(var v=0; v < formViaElements.length;v++){
      var label = (Hafas('label[for="HFS_Via' + v + '"]') || {});
      var viaCount = tpInstance.getViaCount();
      var viaElem = formViaElements[v];
      var viaIdx = parseInt(viaElem.getAttribute("data-form-via"));
      var viaActionButton = (Hafas.Config.TP.vias.durationOfStay)?Hafas('#HFS_ViaMore_' + viaIdx):Hafas('#HFS_ViaDelete_' + viaIdx);
      if (viaIdx <= viaCount) {
        var storedTimeout = this.Controller.TP['inpHFS_Via' + v + '_inputTimeout'];
        if (storedTimeout !== null) {
          window.clearTimeout(storedTimeout);
          storedTimeout = null;
        }
        viaElem.removeClassName('lyr_collapseVia');
        Hafas.Util.gui.setVisibility(viaElem,true);
        // Hide delete/context menu icon if via is empty
        var domElemDurationSummary = Hafas('[data-form-via="' + viaIdx + '"] .lyr_viaDurationSummary',false);
        var viaField = Hafas('#HFS_Via' + viaIdx);
        var currentViaInput = viaField.value;
        if(tpInstance.getVia(viaIdx) !== ""){
           viaActionButton.style.visibility = '';
           var tmpVia = tpInstance.getVia(viaIdx);
           if (viaField) {
             this.Controller.TP["inpHFS_Via" + v]?.setLocation(tmpVia.loc);
             if (currentViaInput !== viaField.value) {
               // input value changed ? -> announce
               Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('a11y.announce.t_N_ElementTextChanged', {
                 element: (label.textContent || Hafas.Modules.i18n.get('common.label.t_N_Unknown')),
                 text: viaField.value
               }));
             }
           }
           if(tmpVia.min > 0) {
             domElemDurationSummary.innerHTML = this.Controller.TP.formatViaDurationSummary(tmpVia.min);
             Hafas.Util.gui.setVisibility(domElemDurationSummary, true);
           }else{
             Hafas.Util.gui.setVisibility(domElemDurationSummary, false);
           }
        }else{
           viaActionButton.style.visibility = 'hidden';
           if (viaField) {
             this.Controller.TP["inpHFS_Via" + v]?.resetLocation(false);
             // input value changed ? -> announce
             if (currentViaInput !== viaField.value) {
               Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('a11y.announce.t_N_ElementTextRemoved', {
                 element: (label.textContent || Hafas.Modules.i18n.get('common.label.t_N_Unknown'))
               }));
             }
           }
           Hafas.Util.gui.setVisibility(domElemDurationSummary,false);
        }

      }else{
        // Fade out field
        viaElem.addClassName('lyr_collapseVia');
        var storedTimeout = this.Controller.TP['inpHFS_Via' + v + '_inputTimeout'];
        if (storedTimeout !== null) {
          window.clearTimeout(storedTimeout);
          storedTimeout = null;
        }
        this.Controller.TP['inpHFS_Via' + v + '_inputTimeout'] = window.setTimeout(function() {
          Hafas.Util.gui.setVisibility(viaElem, false);
        },animationTimeout);
      }
    }

    if (focusFirstVia) {
      // Accessibility: Focus after animationTimeout + 1, showing/hiding of via will have concluded then
      window.setTimeout(function () {
        var firstVia = Hafas('#HFS_Via0');
        if (firstVia && Hafas.Util.gui.isVisible(firstVia)) {
          firstVia.focus();
        }
      }, (animationTimeout + 1));
    }

    //update via more options menu
    Hafas.ps.pub('/tp/switchLocationsDone',[]);
    this.Controller.TP.updateViaFieldsRunning = false;
  },
  formatViaDurationSummary: function (minutes) {
    var durationStr = "";
    if (minutes < 60) {
      durationStr = minutes + ' ' + Hafas.Modules.i18n.get('common.times.t_S_Minutes_P');
    } else {
      durationStr = Hafas.Util.date.formatDuration(minutes)  + ' ' + Hafas.Modules.i18n.get('common.times.t_S_Hours_P');
    }
    var layoverTxt = Hafas.Modules.i18n.get('common.label.t_N_ViaLayoverSummary',{time:durationStr});
    return layoverTxt;
  },
  toggleViaFormContainer: function(){
     // If Via Button has already been pressed
     // and via section is already expanding / minimizing, we don't want to handle another click event (that may have propagated through double click)
     if(this.Controller.TP.viaTogglePressed){
       return;
     }
    this.Controller.TP.viaTogglePressed = true;
    this.Controller.TP.skipOpenViaForm = true;
     this.Controller.TP.updateViaFieldVisibility.bind(this)(true);
    this.Controller.TP.skipOpenViaForm = false;
     if(!this.Controller.TP.viasOpen){
       this.Controller.TP.showViaForm.bind(this)();
       Hafas.ps.pub('/tracking/event/tripplanner-via-expand-pressed', [{typ: 'event', key: 'tripplanner-via-expand-pressed' }]);
     }else{
       this.Controller.TP.hideViaForm.bind(this)();
       Hafas.ps.pub('/tracking/event/tripplanner-via-collapse-pressed', [{typ: 'event', key: 'tripplanner-via-collapse-pressed' }]);
     }
  },
  showViaForm: function(){
    if (this.Controller.TP.showViaFormRunning === true || this.Controller.TP.skipOpenViaForm === true) {
      // Don't jump into recursive calls or skip on purpose on in toggle function
      return;
    }
    this.Controller.TP.showViaFormRunning = true;
    this.Controller.TP.viasOpen = true;
    var viaFormWrap = Hafas('#HFS_TP_ViaFormWrap',false);
    var viaMainWrapper = Hafas('#HFS_TPInputMainWrapper',false);
    var animationTimeout = 500;

    // Tooltip Text ändern
    var viaTooltip = Hafas('#HFS_ViaFormToggleButton .lyr_tooltipText',false);
    if (viaTooltip) {
      viaTooltip.innerHTML = Hafas.Modules.i18n.get('common.label.t_N_CollapseViaSection');
    }


    // Via Status anzeige im Formular ausblenden
    Hafas.Util.gui.setVisibility(Hafas('#HFS_ViaStatusDisplay',false),false);
    Hafas.Util.gui.setVisibility(viaFormWrap,true);

    window.setTimeout(function() {
      Hafas('#HFS_TPCoreForm', false).addClassName('lyr_viaOpened');
      viaMainWrapper.removeClassName('lyr_collapsed');
      var viaFormToggleButton = Hafas('#HFS_ViaFormToggleButton i', false);
      if (viaFormToggleButton) {
        Hafas('#HFS_ViaFormToggleButton i', false).className = 'haf_ic_via_collapse';
      }
      window.setTimeout(function () {
        Hafas.bind(this.Controller.TP.calculateDraggableInputs, this)();
        this.Controller.TP.viaTogglePressed = false;
        this.Controller.TP.showViaFormRunning = false;
      }.bind(this), animationTimeout);
    }.bind(this),0);
  },
  hideViaForm: function(){
    var viaToggleButton = Hafas('#HFS_ViaFormToggleButton',false);

    var inputErrors = this.Controller.TP.instance.validateQueryLocations();
    if(inputErrors.VIA_TYPE_MISMATCH !== undefined){
      Hafas.ps.pub('/GUI/smallAlert/show', [Hafas.Modules.i18n.get('common.label.t_N_ViaTypeConflict')]);
      return;
    }
    this.Controller.TP.viasOpen = false;

    var viaFormWrap = Hafas('#HFS_TP_ViaFormWrap',false);
    var viaMainWrapper = Hafas('#HFS_TPInputMainWrapper',false);
    var animationTimeout = 500;
    var tpInstance = this.Controller.TP.instance;


    var viaCnt = tpInstance.getViaCount();
    if(viaCnt > 0){
      viaFormWrap.style.maxHeight = '28px';
      // Status Text entsprechend setzen
      Hafas('#HFS_ViaStatusText', false).innerHTML = this.Controller.TP.getViaStatusText.bind(this)();
    }

    // Ausführen wenn Options eingeschaltet sind, und Vias im Formular angezeigt werden
    if(Hafas.Config.TP.useQueryOptions && Hafas.Config.TP.vias.showInForm) {
      Hafas('#HFS_TPCoreForm', false).removeClassName('lyr_viaOpened');
      viaMainWrapper.addClassName('lyr_collapsed');
      Hafas('#HFS_ViaFormToggleButton i', false).className = 'haf_ic_via_expand';

      // Tooltip Text ändern
      Hafas('#HFS_ViaFormToggleButton .lyr_tooltipText', false).innerHTML = Hafas.Modules.i18n.get('common.label.t_N_ExpandViaSection')

      // Prüfen ob Vias eingegeben worden sind, wenn ja Via Status in Eingabemaske zeigen
      window.setTimeout(function () {
        if (viaCnt > 0) {
          Hafas.Util.gui.setVisibility(Hafas('#HFS_ViaStatusDisplay', false), true);
        }
        window.setTimeout(function () {
          viaFormWrap.style.removeProperty("max-height");
          this.Controller.TP.viaTogglePressed = false;
        }.bind(this), 1);
        Hafas.Util.gui.setVisibility(Hafas('#HFS_TP_ViaFormWrap', false), false);
      }.bind(this), animationTimeout);
    }
  },
  getViaStatusText: function(){
    var viaStatusText = '';
    var tpInstance = this.Controller.TP.instance;
    var viaCnt = tpInstance.getViaCount();
    // Status Text entsprechend setzen
    if(viaCnt == 1) {
      var viaL = this.Controller.TP.instance.getViaList();
      for(var v=0; v < viaL.length;v++) {
        var currVia = tpInstance.getVia(v);
        if(currVia.loc !== undefined && currVia.loc !== null && currVia.loc != "") {
          viaStatusText = Hafas.Modules.i18n.get('common.label.t_N_Via') + " " + currVia.loc.name;
          break;
        }
      }
    }else{
      viaStatusText = Hafas.Modules.i18n.get('common.label.t_N_ViasAvailable',{count: viaCnt });
    }
    return viaStatusText;
  },
  updateVias: function(){
    var vias = this.Controller.TP.instance.getViaList();
     for(var v=0; v < vias.length;v++){
       var buttonVisibility = 'visible';
       var label = (Hafas('label[for="HFS_Via' + v + '"]') || {});

        var tmpVia = vias[v];
        var viaField = Hafas('#HFS_Via' + v, false);
        var currentViaInput = viaField.value;
        if (tmpVia.loc !== undefined && tmpVia.loc !== null && Object.keys(tmpVia.loc).length > 0) {
          if (viaField) {
            this.Controller.TP["inpHFS_Via" + v]?.setLocation(tmpVia.loc);
            // input value changed ? -> announce
            if (currentViaInput !== viaField.value) {
              Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('a11y.announce.t_N_ElementTextChanged', {
                element: (label.textContent || Hafas.Modules.i18n.get('common.label.t_N_Unknown')),
                text: viaField.value
              }));
            }
          }
          buttonVisibility = 'visible';
        } else {
          if (viaField) {
            this.Controller.TP["inpHFS_Via" + v]?.resetLocation();
            // input value changed ? -> announce
            if (currentViaInput !== viaField.value) {
              Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('a11y.announce.t_N_ElementTextRemoved', {
                element: (label.textContent || Hafas.Modules.i18n.get('common.label.t_N_Unknown'))
              }));
            }
          }
          buttonVisibility = 'hidden';
        }

        // Via Elemente in Formular aktualisieren, sofern Modus "Via in Form anzeigen" aktiviert ist
        if (Hafas.Config.TP.vias.showInForm) {
          var viaButton = Hafas('button[data-via-index="' + v + '"]', false);
          if (viaButton !== null) {
            viaButton.style.visibility = buttonVisibility;
          }
           var durationSummary = Hafas('[data-form-via="' + v + '"] .lyr_viaDurationSummary', false);
           if (tmpVia.min == 0) {
             if (durationSummary !== null) {
               durationSummary.innerHTML = '';
             }
             Hafas.Util.gui.setVisibility(durationSummary, false);
           } else {
             this.Controller.TP.updateDurationViaTxt.bind(this)(tmpVia.min, v);
           }
        }
     }
     Hafas.bind(this.Controller.TP.updateStoredVias, this)();
  },
  /**
   * Update vias in session storage and local storage without updating any of the other stored options
   */
  updateStoredVias: function () {
    // Create list of all via suggest instances to iterate over
    var viaSuggests = [];
    for (var i = 0; i < Hafas.Config.TP.vias.amount; i++) {
      viaSuggests.push(this.Controller.TP['inpHFS_Via' + i]);
    }

    // Only update storage if all suggests have been initialized with values from storage to avoid overwriting them
    if (viaSuggests.some(viaSuggest => !viaSuggest.hasBeenInitializedFromStorage) && this.Controller.TP.removeViaRunning === false) {
      return;
    }

    // Update session storage
    viaSuggests.forEach(viaSuggest => viaSuggest.setInputInStorage());

    // Update local storage without changing any other stored options
    if (Hafas.Util.isCookieTypeActive('functional') === true && Hafas.Config.TP.useQueryOptions) {
      // Get stored vias
      var storedOptions = this.Controller.TP.options.getOptionStorage();
      if (storedOptions) { // else: will be initialized after first search
        var parsedOptions = JSON.parse(storedOptions.mod);
        var storedViaGroupIndex = parsedOptions.questionList.findIndex(item => item.id === 'HFS_Via_Group');

        // Get modified vias
        var modifiedOptions = JSON.parse(this.Controller.TP.options.getModifiedModel());
        var modifiedViaGroup = modifiedOptions?.questionList?.find(item => item.id === 'HFS_Via_Group');

        // Replace stored vias with modified vias
        if (modifiedViaGroup) {
          parsedOptions.questionList[storedViaGroupIndex] = modifiedViaGroup;

          // Store changed options
          storedOptions.mod = JSON.stringify(parsedOptions);
          this.Controller.TP.options.storeOptionModel(storedOptions);
        }
      }
    }
  },
  setVia: function(vIdx,loc){
    // We have to set the location in the via suggest for VIAs too, otherwise VID url parameter won't work properly because of a missing activeLoc
    var inpVia = this.Controller.TP['inpHFS_Via' + vIdx];
    if (inpVia !== undefined) {
      inpVia.setLocation(loc);
    }
    this.Controller.TP.options.setRandomParameter("HFS_Via" + vIdx, "value", loc);
    Hafas.Modules.Validation.resetErrorField('HFS_Via' + vIdx);
    var viaWrap = Hafas('[data-form-via="' + vIdx + '"] .lyr_tpInputWrap', false);
    if (viaWrap) viaWrap.removeClassName('js_highLightingError');
    Hafas.ps.pub('/options/gui/toggle/via/options', [{id: "HFS_Via" + vIdx, visibility: true}]);
    Hafas.ps.pub('/options/setChangedOptionsInputForm', [{}]);
    if(Hafas.Config.TP.vias.showInForm){
       this.Controller.TP.updateViaFieldVisibility.bind(this)();
       this.Controller.TP.calculateDraggableInputs.bind(this)();
    }else{
      // Für das alte Via Konzept muss hier das Inputfeld manuell gefüllt werden
      var viaField = Hafas('#HFS_Via' + vIdx, false);
      if (viaField) {
        viaField.value = Hafas.Util.getLocationAttribute(loc, "name");
      }
    }
  },
  /**
   * Resets a via input and clears the corresponding suggest storage
   */
  resetVia: function (viaInput) {
    var viaIndexMatch = viaInput.id.match(/\d+/);
    Hafas.ps.pub('/map/clearLocationMarker',["via",{index: parseInt(viaIndexMatch[0])}]);
    viaInput.resetLocation();
  },
  /**
   * Clears all via inputs and suggest storage
   */
  resetVias: function () {
    var viaIndex = 0;
    var viaInput = this.Controller.TP['inpHFS_Via' + viaIndex];
    while (viaInput) {
      this.Controller.TP.resetVia(viaInput);
      viaIndex++;
      viaInput = this.Controller.TP['inpHFS_Via' + viaIndex];
    }
  },
  postForm: function (data) {
    // Parameter direkt wieder löschen, wird nur für die initiale Erkennung relevant
    delete this.Controller.Common.initialStartSet;

    var _me = this;

    // Remove Push highlighting, if not already done by selecting locations
    Hafas.ps.pub('/GUI/common/removeHighlightingFromInput',[{type: 'element', element: Hafas('#' + this.Controller.TP.inpFrom.inp.id, false), className: 'js_highLightingGlow'}]);
    Hafas.ps.pub('/GUI/common/removeHighlightingFromInput',[{type: 'element', element: Hafas('#' + this.Controller.TP.inpTo.inp.id, false), className: 'js_highLightingGlow'}]);

    if (typeof data.ev != 'undefined')
      data.ev.preventDefault();

    // If postForm was triggered by an input element we must blur it, because otherwise focus stays within the input field
    // which then triggers the suggest to reopen, as it gains focus again
    // This can be problematic if unified planner is on
    var focusEl = document.activeElement;
    if (focusEl.tagName.toLowerCase() === 'input')
      focusEl.blur();

    //Wird die Suche durch extere Parameter gestartet.
    data.searchFromExternal = !!data.searchFromExternal; // Strawberry 1.6.0

    // favorite marker/star boolean
    this.Controller.TP.markerIsLoaded = false;
    this.Controller.TP.selectedConnection = null; // Strawberry 1.5: [BugFix] Beim Zur�ck von Verbindungsdeatils zur �bersicht wird nicht mehr die erste sondern die zuletzt gezeigt Verbindung auf der Karte dargestellt.


    // Aktive Selektion zurücksetzen
    delete this.Controller.TP.activeSelection;

    delete this.Controller.TP.scrollButtonsState;

    // close all additional resultcontainer
    Hafas.ps.pub('/GUI/results/additional/hideAll');

    // close date time picker if it is open
    this.Controller.TP.dateTimePicker.cancel();

    // validate time fields
    var timeInputs = Hafas('[data-app-tp="time"]', true),
      i = 0,
      len = timeInputs.length;
    for (i; i < len; i++) {
      var input = timeInputs[i];
      Hafas.ps.pub('/tp/validateTime', [input]);
    }

    var validateInputs = ['From', 'To'];

    // Get Via Inpufields
    Hafas('[data-form-via]',true).map(function (viaElem) {
      var viaIdx = parseInt(viaElem.getAttribute("data-form-via"),10);
      validateInputs.push('HFS_Via'+viaIdx);
    });

    this.Controller.TP.validate(validateInputs, Hafas.bind(function () {
      var form = Hafas.Core.newType("hafasValidation", {
        showInputFieldMessages: false,
        form: data.form
      });
      // If input are valid -> proceed with connection search
      var inputErrors = this.Controller.TP.instance.validateQueryLocations();
      this.Controller.TP.resetFormErrors();
      if (form.valid && Object.keys(inputErrors).length == 0) {

        // Via Form soll eingeklappt sein
        if(Hafas.Config.TP.vias.showInForm && Hafas.Config.TP.unifiedPlanner.show && this.Controller.TP.currentView == 'index') {
          this.Controller.TP.hideViaForm.bind(this)();
        }

        if (data.searchFromExternal && (!Hafas.Config.TP.unifiedPlanner.show)) {
          Hafas.bind(this.Controller.GUI.common.showPageLoader, this)(Hafas.Modules.i18n.get('TP.index.t_N_WaitSearchConnection'));
        }

        // show loadingImage and set Button to disabled
        if (data.form.elements.submitTPForm) {
          Hafas.bind(this.Controller.App.triggerLoadingImage, this)(data.form.elements.submitTPForm);
        }

        // Reset cluster
        for (var c = 0; c < Hafas.Config.TP.cluster.length; c++) {
          if (typeof Hafas.Config.TP.cluster[c].requested != 'undefined') {
            delete Hafas.Config.TP.cluster[c].requested;
          }
        }

        // Search connection

        this.Controller.TP.visibleClusterGroup = this.Controller.TP.getCurrentClusterBitmask();

        this.Controller.TP.instance.search({
            ptCallback: Hafas.bind(this.Controller.TP.showResultOverview, this),
            ivCallback: Hafas.bind(this.Controller.TP.showIVResultOverview, this)
        });

        // this.Controller.TP.addToSearchHistory();

        // Tracking
        Hafas.ps.pub('/tracking/event/connection-request', [{
          typ: 'event',
          key: 'connection-request',
          data: {type: 'initial'}
        }]);
        Hafas.ps.pub('/tracking/event/tripplanner-request-triggered', [{
          typ: 'event',
          key: 'tripplanner-request-triggered',
          data: {type: 'initial'}
        }]);

        // remove instances of connectionmaps (-> classic Version)
        this.Controller.Map.connectionMaps = [];
      }else{
        // Fehler aufgetreten
        this.Controller.TP.handleFormErrors.bind(this)(inputErrors,focusEl);
        // In jedem Fall das Formular anzeigen und einen möglichen Pageloader verstecken
        Hafas.ps.pub('/GUI/form/show');

        // Wenn das Formular wieder angezeigt wird, muss jedoch die TabNavigationHeading wieder ausgeblendet werden,
        // wenn wir uns nicht im Index befinden (z.B. bei Unified Planner Overview)
        if (this.Controller.TP.currentView !== 'index') {
          Hafas.ps.pub('/GUI/tabNavigationHeading/hide', []);
        }
        this.Controller.GUI.common.hidePageLoader();
      }
    }, this));

    if (!Hafas.Config.UI.showOptionsOnInit) {
      Hafas.ps.pub('/GUI/tabs/closeAll');
      Hafas.ps.pub('/GUI/options/closeAll');
    }
    Hafas.ps.pub('/app/events/renderDone');
    return false;
  },
  resetFormErrors: function(){
    Hafas.ps.pub('/GUI/common/removeHighlightingFromInput',[{type:'dep', className: 'js_highLightingError'} ]);
    Hafas.ps.pub('/GUI/common/removeHighlightingFromInput',[{type:'arr', className: 'js_highLightingError'} ]);
    Hafas.ps.pub('/GUI/smallAlert/hide');
  },
  handleFormErrors: function(errors, formerFocusElement) {
    var toastText = '';
    var fieldsToHighlight = [];
    if (errors.DEP_MISSING !== undefined && errors.ARR_MISSING !== undefined) {
      toastText = Hafas.Modules.i18n.get('TP.error.form.t_N_requiredFromTo');
      fieldsToHighlight.push('dep');
      fieldsToHighlight.push('arr');
    } else if(errors.VIA_TYPE_MISMATCH !== undefined) {
      toastText = Hafas.Modules.i18n.get('common.label.t_N_ViaTypeConflict');
    } else if(errors.DEP_MISSING !== undefined) {
      toastText = Hafas.Modules.i18n.get('TP.error.form.t_N_FromMissing');
      fieldsToHighlight.push('dep');
    } else if(errors.ARR_MISSING !== undefined) {
      toastText = Hafas.Modules.i18n.get('TP.error.form.t_N_ToMissing');
      fieldsToHighlight.push('arr');
    } else if(errors.DEP_ARR_IDENTICAL !== undefined) {
      toastText = Hafas.Modules.i18n.get('TP.error.form.t_N_FromToViaIdentical');
      fieldsToHighlight.push('dep');
      fieldsToHighlight.push('arr');
    }
    Hafas.Util.gui.focusElement(formerFocusElement)

    // Remove Push highlighting
    Hafas.ps.pub('/GUI/common/removeHighlightingFromInput',[{type: 'element', element: Hafas('#' + this.Controller.TP.inpFrom.inp.id, false), className: 'js_highLightingGlow'}]);
    Hafas.ps.pub('/GUI/common/removeHighlightingFromInput',[{type: 'element', element: Hafas('#' + this.Controller.TP.inpTo.inp.id, false), className: 'js_highLightingGlow'}]);
    // We go through all the fields that should be highlighted and call the respective function
    for(var i = 0; i < fieldsToHighlight.length; i++) {
      var field = fieldsToHighlight[i];
      Hafas.ps.pub('/GUI/common/highlightingInput', [{type: field, className: 'js_highLightingError', keepClass: true }]);
    }
    // Toast anzeigen
    Hafas.ps.pub('/GUI/smallAlert/show', [toastText]);
  },
  // Strawberry 1.6.0
  searchReconstruction: function (data, type) {
    // Formular in jedem Fall ausblenden
    Hafas.ps.pub('/GUI/form/hide');
    Hafas.bind(this.Controller.GUI.common.showPageLoader, this)(Hafas.Modules.i18n.get('ShareTrip.t_N_WaitForRecon')); // Strawberry 1.6.0
    this.Controller.TP.instance.reconstruct(data, type);
  },
  addToSearchHistory: function () {
    if (Hafas.Config.Switches.useFavorites && Hafas.Util.isCookieTypeActive('functional') === true) {
      var depLoc = this.main.Controller.TP.instance.getLocation('dep');
      var arrLoc = this.main.Controller.TP.instance.getLocation('arr');
      if (depLoc != null && arrLoc != null) {
        var currentViaList = this.main.Controller.TP.instance.getViaList();
        if (Hafas.Config.Switches.useFavorites && !Hafas.Config.Favorites.addLocationOnSuggest) {
          this.main.Controller.Favorites.instance.addLocation(depLoc, 'History');
          this.main.Controller.Favorites.instance.addLocation(arrLoc, 'History');

          // Vias auch zur History hinzufügen, wenn sie aktiviert sind
          if(Hafas.Config.TP.vias.amount > 0 && currentViaList != null) {
            for (var i = 0; i < currentViaList.length; i++) {
              if (currentViaList[i].loc != null && Object.keys(currentViaList[i].loc).length > 0) {
                var viaLocHistory = currentViaList[i].loc;
                this.main.Controller.Favorites.instance.addLocation(viaLocHistory, 'History');
              }
            }
          }
        }
        var model = {
          dep: depLoc,
          arr: arrLoc,
          opt: {
            version: Hafas.Config.Options.version,
            hash: Hafas.Util.createHash.hex_md5(depLoc.name + arrLoc.name)
          }
        };
        if (Hafas.Config.Favorites.storeQueryOptions) {
          var chgOptTxt = this.main.Controller.TP.options.getOptionTexts({historyFavorites: true});
          if (chgOptTxt.infoText !== "") {
            var modifiedModel = this.main.Controller.TP.options.getModifiedModel();
            var hashStr = Hafas.Util.createHash.hex_md5(depLoc.name + arrLoc.name + chgOptTxt.infoText);
            model.opt.txt = chgOptTxt.infoText;
            model.opt.mod = modifiedModel;
            model.opt.hash = hashStr;
          }
        }
        this.main.Controller.Favorites.instance.addConnection(model, 'History');
      }
    }
  },
  // Strawberry 1.5: [UPDATE] ServerInfo MapLayerConfig in die Basis gebracht
  getCurrentClusterBitmask: function () {
    if (typeof Hafas.Config.TP.selectL !== 'undefined' && Hafas.Config.TP.selectL.length > 0) {
      if (typeof this.currentCluster != 'undefined') {
        return Hafas.Config.TP.selectL[this.currentCluster].bitmaskResolved;
      } else {
        return Hafas.Config.TP.selectL[0].bitmaskResolved;
      }
    } else {
      return null;
    }
  },
  setInitialSort: function (clusterIndex) {
    if(Hafas.Config.TP.useGrouping) {
      var tpController;
      if(Hafas.Util.checkPath(this, 'main.Controller.TP')) tpController = this.main.Controller.TP;
      if(Hafas.Util.checkPath(this, 'Controller.TP')) tpController = this.Controller.TP;
      if (!tpController.selectedClusterSort) {
        tpController.currentSort = Hafas.Config.TP.cluster[clusterIndex].initSortType;
      } else {
        // Ein Cluster kann unterschiedliche conScoring-Optionen haben
        var conScoringTypeList = Hafas.Config.TP.cluster[clusterIndex].conScoringL.map(function (cluster) {
          return cluster.type;
        });
        // Ist die ausgewählte Clustersortierung verfügbar
        if (conScoringTypeList.indexOf(tpController.selectedClusterSort) !== -1) {
          tpController.currentSort = tpController.selectedClusterSort;
        } else {
          tpController.currentSort = Hafas.Config.TP.cluster[clusterIndex].initSortType;
        }
      }
    }
  },
  validate: function (items, callback) {
    var tpController = this.main.Controller.TP;
    var resolvedCount = 0;
    var itemLength = items.length;

    // Increments the counter, firing the callback when all items are resolved
    function resolveMe() {
      resolvedCount++;
      if (resolvedCount === itemLength) {
        callback();
      }
    }

    for (var i = 0; i < itemLength; i++) {
      var itemId = items[i];
      var locationId;
      var isVia = false;
      var viaIndex;

      switch (itemId) {
        case 'From':
          locationId = 'dep';
          break;
        case 'To':
          locationId = 'arr';
          break;
        default:
          var firstPartOfId = 'HFS_Via';
          if(itemId.slice(0,firstPartOfId.length) === firstPartOfId) {
            locationId = 'via';
            isVia = true;
            viaIndex = itemId.slice(firstPartOfId.length);
            break;
          } else {
            resolveMe();
          }
          break;
      }

      var location;
      if (isVia) {
        location = tpController.instance.getVia(viaIndex);
        if (location) {
          // HCIViaLocation != HCIlocation
          location = location.loc;
        }
      } else {
        location = tpController.instance.getLocation(locationId);
      }

      var input = tpController['inp' + itemId];
      var inputText = input.getInputText();

      // is there valid location in suggest instance?
      if(!Hafas.Util.location.isValid(location) && input && Hafas.Util.location.isValid(input.activeLoc)) {
        location = input.activeLoc;
        if (isVia) {
          tpController.instance.setVia({location: location}, viaIndex);
        } else {
          tpController.instance.setLocation(locationId, location);
        }
      }
      // location and inputtext aren't synchronized.
      if(!location && inputText) {
        location = {name:inputText};
      }

      // Location is valid -> resolve
      if (Hafas.Util.location.isValid(location) && Hafas.Util.getLocationAttribute(location,'name') === inputText) {
        resolveMe();
      } else if(isVia && !location) {
        // Empty via input is okay, because if there's one via the second input field is shown -> resolve
        resolveMe();
      } else {
        // Something is missing in location -> validate -> LocMatch -> resolve
        if(Object.keys(location).length > 0) {
          var valid = input.validateLocation(true, resolveMe);
          if (valid === true) {
            resolveMe();
          }
        } else {
          // Empty Location -> resolve -> show error (see validateQueryLocations)
          resolveMe();
        }
      }
    }
  },
  setGeoLocationPosition: function (locObj, inputId) {
    if (inputId == "To")
      this.Controller.TP.instance.setLocation('arr', locObj);
    else
      this.Controller.TP.instance.setLocation('dep', locObj);
    // Unified Planner Direktsuche nur antriggern, wenn man sich in der Overview befindet
    if(this.Controller.TP.currentView == 'overview') {
      Hafas.ps.pub('/tp/events/trigger/unified');
    }
  },
  // Strawberry 1.6.0
  showReconstructedConnection: function (data) {
    // Page Loader ausblenden
    this.Controller.GUI.common.hidePageLoader();
    // Formular ausblenden, weil weiter unten in die Details gesprungen wird
    Hafas.ps.pub('/GUI/form/hide');

    if (data.err) {
      Hafas.bind(this.Controller.TP.showReconstructionError, this)(data);
      return;
    }
    if (typeof data.dep != 'undefined' && typeof data.dep.locResolved != 'undefined') {
      this.Controller.TP.instance.setLocation('dep', data.dep.locResolved);
    }
    if (typeof data.arr != 'undefined' && typeof data.arr.locResolved != 'undefined') {
      this.Controller.TP.instance.setLocation('arr', data.arr.locResolved);
    }
    // Strawberry 1.5: Diverse Korrekturen in Verbindung mit der Rekonstruktion und dem History Modul, au�erdem werden die Bl�tter Buttons bei Aufruf mit Rekonstruktionskontext nicht mehr angezeigt
    data.isReconstruction = true;
    data.connectionType = 'PT';

    // show overview first if details are shown in overview
    if(typeof Hafas.Config.UI.showTPResultsInOverview != 'undefined' && Hafas.Config.UI.showTPResultsInOverview == true) {
      Hafas.bind(this.Controller.TP.showResultOverview, this)(data);
    }

    var currConnection = data.renderConnections[0];
    Hafas.bind(this.Controller.TP.renderConnectionDetails, this)(currConnection, data);
  },
  highlightActiveSelection: function (type, subcluster) {
    if (typeof this.Controller.TP.activeSelection == 'undefined') {
      this.Controller.TP.activeSelection = {connType: type, arrayIdx: 0};
    } else {
      this.Controller.TP.activeSelection.connType = type;
    }
    var overviewElem = null;
    if (typeof subcluster != 'undefined') {
      this.Controller.TP.activeSelection.subclusterGrpId = subcluster;
      overviewElem = Hafas('#HFS_ConnectionId_' + this.Controller.TP.activeSelection.connType + '_' + subcluster + '_' + this.Controller.TP.activeSelection.arrayIdx);
    } else {
      overviewElem = Hafas('#HFS_ConnectionId_' + this.Controller.TP.activeSelection.connType + '_' + this.Controller.TP.activeSelection.arrayIdx);
    }
    if (overviewElem) {
      overviewElem.addClassName('lyr_overviewItemActive');
    }

  },
  showResultOverview: function (response, options) {
      var me = this;

      Hafas.bind(this.Controller.TP.cleanupSegmentedControls, this)();
      this.Controller.GUI.common.hidePageLoader();

      this.Controller.TP.markerIsLoaded = false;
      this.Controller.TP.addToSearchHistory();

      response.isReconstruction = !!response.isReconstruction;

      if (Hafas.Config.TP.unifiedPlanner.show) {
        me.Controller.TP.setFormForOverview(true);
      }

      /* gun | 2018-07-27
       * Save query into history object, reason -> when restored, it is not sure if you can access the values from the controls -> maybe they were cleared, who knows?
       * But only do this wasn't done before.
       * ngr | 2020-11-02: Always do! Otherwise changed inputs won't be saved and cause problems e.g. within print configurator
       */
      response.query = {
        dep: this.Controller.TP.instance.getLocation("dep"),
        arr: this.Controller.TP.instance.getLocation("arr"),
        outDate: this.Controller.TP.instance.getOutDate(),
        outTime: this.Controller.TP.instance.getOutTime(),
        outFrwd: this.Controller.TP.instance.getOutFrwd(),
        cls: this.Controller.TP.instance.getProductClass(),
      };

      /* Send metainfo to iframe API */
      this.Controller.App.sendMetaInformation("TP","showResult", {
        dep: {
          name: response.query.dep.name
        },
        arr: {
          name: response.query.arr.name
        }
      });

      if(Hafas.Config.TP.useQueryOptions) {
        var viaList = this.Controller.TP.options.getModelsByType("via");
        response.query.via = [];
        for (var i = 0; i < viaList.length; i++) {
          if ((viaList[i].value != "") && (typeof viaList[i].viaType == "undefined" || viaList[i].viaType != "anti")) {
            response.query.via.push(viaList[i].value);
          }
        }
      }

      // Start und Ziel aus Anfrage Formular uebernehmen. // Strawberry 1.6.0
      var depLocName = response.query.dep.name; // Explicitly only the original name, not smart location name to be used in hash
      var arrLocName = response.query.arr.name; // Explicitly only the original name, not smart location name to be used in hash

      response.currentHash = Hafas.bind(me.Controller.TP.getCurrentConnectionHash, me)(depLocName, arrLocName);
      response.isFavorite = Hafas.bind(me.Controller.TP.isConnectionFavorite, me)(depLocName, arrLocName);

      // Strawberry 1.5: Diverse Korrekturen in Verbindung mit der Rekonstruktion und dem History Modul, au�erdem werden die Bl�tter Buttons bei Aufruf mit Rekonstruktionskontext nicht mehr angezeigt
      if (Hafas.Modules.History) {
        if (response.isReconstruction) { // Strawberry 1.6.0
          Hafas.Modules.History.addOrUpdateData("TP", "reconstruction", response);
        } else {
          var optionsModel = {};
          if (Hafas.Config.TP.useQueryOptions === true) {
            optionsModel = me.Controller.TP.options.getModifiedModel();
          }
          var histModel = {
            response: response,
            optionModel: optionsModel
          };
          Hafas.Modules.History.addOrUpdateData("TP", "overview", histModel);
        }
      }

      // remove loadingImage
      if (me.trigger) {
        if (me.triggerLoadingImage) {
          try {
            me.trigger.removeChild(me.triggerLoadingImage);
            delete me.triggerLoadingImage;
          } catch (e) {
            // do nothing
          }
        }
        me.trigger.removeAttribute('disabled');
      }

      response.errorPage = {useExtended: false};
      if (Hafas.Config.TP.useExtendedErrorPage) {
        var fromType = response.query.dep.type;
        var toType = response.query.arr.type;
        if (fromType === "S") {
          response.errorPage.useExtended = true;
          response.errorPage.hasFromStation = true;
        }

        if (toType === "S") {
          response.errorPage.useExtended = true;
          response.errorPage.hasToStation = true;
        }
      }

      // Strawberry 1.5: Fehlertexte werden f�r die "Nicht-Cluster" werden jetzt sofern vom HCI geliefert (ab 1.21) direkt benutzt, ansonsten wird der Fehlercode ausgewertet und es werden Texte angezeigt, die clientseitig hinterlegt sind
      if (response.err !== "OK") {
        if (typeof response.errTxtOut != 'undefined') {
          response.errorPage.errTxtOut = response.errTxtOut;
          response.errorPage.useExtended = false;
        } else if (Hafas.Modules.i18n.get('common.errorcode.' + response.err) !== 'NO-TXT') {
          response.errorPage.errTxtOut = Hafas.Modules.i18n.get('common.errorcode.' + response.err);
        } else {
          response.errorPage.errTxtOut = Hafas.Modules.i18n.get('TP.error.t_N_noResultsExtended');
        }
      }

      // close all open tabs
      Hafas.ps.pub('/GUI/tabs/closeAll');

      // Blende das Formular aus (Classic Version), aber nur wenn der Wert "TP.unifiedPlanner.show"
      // in der Config mit "false" deklariert ist
      if (!Hafas.Config.TP.unifiedPlanner.show) {
        Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'TP'}]);
      } else {
        // Im Fall, dass der Unified Planner genutzt wird muss das Formular hier wieder explizit eingeblendet werden, da es sein kann, dass
        // man per Drag & Drop aus den Details hier landet und sonst die Form nicht eingeblendet wird
        Hafas.ps.pub('/GUI/form/show', [{appcontext: 'TP'}]);
        Hafas.ps.pub('/options/gui/toggle', [{target: 'HFS_CustomerOptionsWrap', open: false, view: 'options'}]);
        Hafas.ps.pub('/GUI/tabNavigationHeading/hide', []); // Beim Unified Planner muss explizit die TabNavigationHeading auf der Overview ausgeblendet werden
        // Favoriten ausblenden, wenn Formular auf der Ergebnisseite zu sehen ist
        var $favoritesWrap = Hafas('#HFS_CustomerFavoritesWrap', false);
        Hafas.Util.gui.setVisibility($favoritesWrap, false);
        // Suchen Button ausblenden
        if (Hafas.Config.TP.unifiedPlanner.requestOnChange) {
          var tpSearchButton = Hafas("[data-button='TPSearchButton']");
          Hafas.Util.gui.setVisibility(tpSearchButton, false);
        }
      }

      // hide resultDetailContainer if there are older results
      Hafas('#' + me.resultDetailContainer + ' [data-contid="' + me.appContext + '"]', false).innerHTML = '';

      var storedRequestData = me.Controller.TP.instance.getStoredRequest();

      if (me.Controller.TP.instance.getTimeNow()) {
        response.timeNow = true;
      } else {
        response.timeNow = false;
        if (typeof storedRequestData['PT'] != 'undefined') {
          response.date = storedRequestData['PT'].current.svcReqL[0].req.outDate;
        }
      }

      if (storedRequestData['PT']) {
        response.date = storedRequestData['PT'].current.svcReqL[0].req.outDate;
        if (typeof storedRequestData['PT'].current.svcReqL[0].req.outFrwd == 'undefined') {
          response.requestArrOrDep = '';
          response.requestIsArrival = false;
        } else {
          response.requestArrOrDep = '(' + Hafas.Modules.i18n.get('common.label.t_N_Departure') + ')';
          response.requestIsArrival = false;
          if (!storedRequestData['PT'].current.svcReqL[0].req.outFrwd) {
            response.requestArrOrDep = '(' + Hafas.Modules.i18n.get('common.label.t_N_Arrival') + ')';
            response.requestIsArrival = true;
          }
        }

        response.requestTime = storedRequestData['PT'].current.svcReqL[0].req.outTime;
        response.requestDate = storedRequestData['PT'].current.svcReqL[0].req.outDate;
      }

      response.showPrintIcon = Hafas.Util.deviceCanPrint();
      response.type = 'PT';
      response.initialGroup = me.Controller.TP.getCurrentClusterBitmask();


      // 1. iterate through renderConnections
      // kombinierte Meldungen f?r jede Verbindung

      var iConn = 0, iConnLen = 0;
      if (typeof response.renderConnections != 'undefined') {
        iConnLen = response.renderConnections.length;
      }
      for (iConn; iConn < iConnLen; iConn++) {
        var currConn = response.renderConnections[iConn];


        // Uebergabe der richtigen Connection beim Aufklappen der Zwischenhalte
        currConn.connectionIdx = iConn;


        // kombinierte Meldungen f�r jede Section
        var iSec = 0,
            iSecLen = currConn.secL.length;
        for (iSec; iSec < iSecLen; iSec++) {
          var currSection = currConn.secL[iSec];
          if (typeof Hafas.Config.Switches.useHimInterface != 'undefined' && Hafas.Config.Switches.useHimInterface == true && currSection.type == 'JNY') {
            var resolvedHIMLink = this.himInterface.getLink({
              type: 'createMsg_TP',
              section: currSection,
              connection: currConn
            });
            currSection.himCreateMsgLinkResolved = resolvedHIMLink;
          }
        }
      }


      // var overviewTplToUse = 'TP_TplOverview'; // Anpassung Atomic Styles
      var overviewTplToUse = 'TP_AtomsTplOverview_Oev';
      if ((me.Controller.TP.instance.isGroupingUsed()) && (!response.isReconstruction)) { // Strawberry 1.6.0
        // overviewTplToUse = 'TP_TplOverviewClustered'; / Anpassung Atomic Styles
        overviewTplToUse = 'TP_AtomsTplOverview_Cluster';
      }

      if (Hafas.Config.debug.showDataModel) {
        console.log('+++ TP.showResultOverview +++ DEBUG Model +++', response)
      }

      // Prüfen ob mindestens eine Verbindung im Ergebnis dem Anfragedatum entspricht
      var foundConnectionOnRequestDate = false;

      if (typeof response.renderConnections != 'undefined') {
        if (response.renderConnections.length == 0) {
          foundConnectionOnRequestDate = true;
        }
        for (var r = 0; r < response.renderConnections.length; r++) {
          // if Request is Arrival check against arr date
          var tmpConnDate = response.renderConnections[r].date;
          var dateToCheck = tmpConnDate;
          if (response.requestIsArrival) {
            var arrivalTimeStamp = Hafas.Core.newType("hafasTime", {
              date: tmpConnDate,
              time: response.renderConnections[r].arr.aTimeS
            });
            dateToCheck = arrivalTimeStamp.format("YYYYMMDD");
          }
          if (response.requestDate == dateToCheck) {
            foundConnectionOnRequestDate = true;
          }
        }
      } else {
        foundConnectionOnRequestDate = true;
      }

      // Bei einer Rekonstruktion spielt das Anfrage Datum keine Rolle
      response.foundConnectionOnRequestDate = foundConnectionOnRequestDate || response.isReconstruction;

      // Speichere wenn nötig und vorhanden die Scrollposition (scrollToTop ist beim First und Earlier true)
      if (!options || (options && !options.scrollToTop)) var scrollTopBefore = Hafas.Util.gui.getScrollTop('[data-render-element="result_container"]');

      // Set currentView to "overview" BEFORE rendering
      this.Controller.TP.currentView = "overview";

      Hafas.Modules.Render.render({
        file: 'tp.result.overview.html',
        target: 'TP_ResultOverview',
        template: overviewTplToUse,
        model: response,
        global: {view: this.Controller.TP.currentView}
      }, Hafas.bind(function () {

        // Springe auf die gespeicherte Scrollposition (scrollToTop ist beim First und Earlier true)
        if (!options || (options && !options.scrollToTop)) Hafas.Util.gui.setScrollTop('[data-render-element="result_container"]', scrollTopBefore);

        Hafas.bind(me.Controller.TP.highlightActiveSelection, me)(response.type);

        /* Public Transport Cluster ausw�hlen, wenn Gruppierung angeschaltet ist */
        if (me.Controller.TP.instance.isGroupingUsed() && !response.isReconstruction && (Hafas.Config.TP.groupingDisplay == 'cluster')) {
          if (typeof this.Controller.TP.showClusterGroup != 'undefined') {
            this.Controller.TP.selectClusterGroup(this.Controller.TP.showClusterGroup.id, true, this.Controller.TP.showClusterGroup.clusterIndex);
            delete this.Controller.TP.showClusterGroup;
          }
          // SegmentedControl f�r Cluster-Darstellung initialisieren
          if (Hafas.Config.TP.selectL.length > 1) {
            me.Controller.TP.segConClusterMain = Hafas.Core.newType('HafasSegmentedControl', {
              holder: 'HFS_tpMultimodalClusterTabs',
              callback: function (data) {
                var clusterMoreBtn = Hafas('#HFS_tpSegmentedCluster_moreTabBtn');
                if (data.trigger.dataset.clusterAction === 'more') {
                  // More cluster button pressed to open
                  Hafas.ps.pub('/tp/showMoreCluster/webapp', [data.trigger.getAttribute('data-cluster-linkwrapper'), true, data.activeIndex]);
                  if (clusterMoreBtn) {
                    clusterMoreBtn.classList.add('js_listOpen');
                  }
                } else {
                  // More cluster button pressed for closed
                  if (typeof me.Controller.TP.segConClusterMore != 'undefined') {
                    me.Controller.TP.segConClusterMore.hideAllPanels();
                    var clsListElem = Hafas('#HFS_SegConClusterMoreList');
                    var listVisibility = Hafas.Util.gui.isVisible(clsListElem);
                    Hafas.Util.gui.setVisibility(clsListElem, listVisibility);
                  }
                  Hafas.ps.pub('/tp/selectCluster/webapp', [data.trigger.getAttribute('data-cluster-linkwrapper'), true, data.activeIndex]);
                  if (clusterMoreBtn) {
                    clusterMoreBtn.classList.remove('js_listOpen')
                  }
                }
              }
            }).initiate();
            if (Hafas.Config.TP.selectL.length > Hafas.Config.TP.initVisibleCluster) {
              me.Controller.TP.segConClusterMore = Hafas.Core.newType('HafasSegmentedControl', {
                verticalMode: Hafas.Config.TP.clusterMoreVerticalMode,
                holder: 'HFS_tpSegmentedCluster_more',
                callback: function (data) {
                  if (typeof data.activeIndex !== 'undefined' && data.trigger.hasAttribute('data-cluster-linkwrapper')) {
                    // Klick auf einen Button in der MoreTabList
                    if (typeof me.Controller.TP.segConClusterMain != 'undefined') {
                      me.Controller.TP.segConClusterMain.hideAllPanels();
                      me.Controller.TP.segConClusterMain.setActiveByElement(Hafas('#HFS_tpSegmentedCluster_moreTabBtn', false), {noCallback: true});
                    }
                    Hafas.Util.gui.setVisibility(Hafas('#HFS_SegConClusterMoreList'), false);
                    var clusterIdx = me.Controller.TP.getClusterIndexByBitmask(data.trigger.getAttribute('data-cluster-linkwrapper'))
                    Hafas.ps.pub('/tp/selectCluster/webapp', [data.trigger.getAttribute('data-cluster-linkwrapper'), true, clusterIdx]);
                    if(Hafas('#HFS_tpSegmentedCluster_moreTabBtn'))
                      Hafas('#HFS_tpSegmentedCluster_moreTabBtn').classList.remove('js_listOpen')
                  }
                }
              }).initiate();
            }
          }
        }

        // Prüfen, ob Früher / Später links ggfs. deaktiviert werden müssen
        if (Hafas.Config.TP.useGrouping == false) {
          var currentQuery = this.Controller.TP.instance.data.query;
          if ((typeof currentQuery.outCtxScrF == 'undefined' || currentQuery.outCtxScrF == null) && Hafas('[data-scroll-link="later"]', false)) {
            Hafas('[data-scroll-link="later"]', false).disabled = true;
          }
          if ((typeof currentQuery.outCtxScrB == 'undefined' || currentQuery.outCtxScrB == null) && Hafas('[data-scroll-link="earlier"]', false)) {
            Hafas('[data-scroll-link="earlier"]', false).disabled = true;
          }
        }

        Hafas.ps.pub('/GUI/results/overview/show', [{}]);

        // is defined in classic-Version GUI-Functions
        Hafas.ps.pub('/GUI/window/scrollTo', ['top']);

        if (this.Controller.Map.instance) {
          this.Controller.Map.hideConnection();

          // Public Transport
          if (typeof response.renderConnections != 'undefined' && response.renderConnections.length > 0) {
            var currConnection = response.renderConnections[0];
            // Strawberry [BugFix] Beim Zur�ck von Verbindungsdeatils zur �bersicht wird nicht mehr die erste sondern die zuletzt gezeigt Verbindung auf der Karte dargestellt.
            this.Controller.Map.showConnection(this.Controller.TP.selectedConnection || currConnection);
          }
        }

        this.Controller.TP.currentConnections = response.renderConnections;
        this.Controller.TP.selectedConnection = null;

        var data = {
          parentContainer: Hafas("[data-additional-info='result_tp']"),
          context: 'TP'
        };
        Hafas.ps.pub('/options/setChangedOptionsInputForm', [data]);

        // Track
        // Strawberry 1.5: [IMPROVED] StandardTracking auf Basis der Kundenanforderungen und der webApp-Funktionalit�ten f�r GoogleAnalytics und Matomo
        // auch bei useGrouping true wird hier reingegangen.
        // Leider muss daher hier eine Abfrage stehen
        if (!me.Controller.TP.instance.isGroupingUsed() || response.isReconstruction) { // Strawberry 1.6
          Hafas.ps.pub('/tracking/screen/connection-overview', [{typ: 'screen', key: 'connection-overview'}]);
          Hafas.ps.pub('/tracking/screen/tripplanner-overview', [{typ: 'screen', key: 'tripplanner-overview'}]);
        } else if (me.Controller.TP.instance.isGroupingUsed()) {
          var c = 0,
              cLen = response.IVModes.length,
              ivmodes = '';
          for (c; c < cLen; c++) {
            var _iv = response.IVModes[c];
            ivmodes += c + '. ' + _iv.mode + ' (' + _iv.label + ') | ';
          }
          Hafas.ps.pub('/tracking/screen/connection-overview', [{typ: 'screen', key: 'connection-overview'}]);
          Hafas.ps.pub('/tracking/screen/tripplanner-overview', [{typ: 'screen', key: 'tripplanner-overview'}]);
        }

        Hafas.ps.pub('/GUI/results/resize', [{
          container: me.resultOverviewContainer,
          appcontext: me.appContext
        }]);

        if (Hafas.Config.Switches.useTRM) {
          var tmpArr = this.Controller.TP.instance.getLocation("arr");
          var lng = tmpArr.crd?.x;
          var lat = tmpArr.crd?.y;

          Hafas.ps.pub('/trm/setLocation', ['DESTINATION', {y: lat, x: lng}]);
        }
        Hafas.ps.pub('/app/updateBanner', ['tpOverview']);
        Hafas.ps.pub('/app/events/resize');

        if (typeof response.foundFirstConnection != 'undefined') {
          Hafas.ps.pub('/tp/firstLastConnectionFound', ['FRST']);
        }
        if (typeof response.foundLastConnection != 'undefined') {
          Hafas.ps.pub('/tp/firstLastConnectionFound', ['LAST']);
        }

        // Context-Menü initialisieren
        var moreOptionMenu =  Hafas.Util.gui._resolveMoreOptionMenu("TP","result");
        if(moreOptionMenu !== null){
          Hafas('#TP_ActionbarMoreBtn', true).forEach(function (elem) {
            Hafas.Core.newType('HafasContextMenu', moreOptionMenu).addTo(elem);
          });
        }
        // Tracking of subcluster open/close states, will be called after rendering and also at history back from details
        // Will only track subclusters opened by the user and not the default opened subclusters which are opened by
        // subclusterConnectionFound flag because that one is not available here
        var clusters = Hafas.Config.TP.cluster;
        if (clusters) {
          for (var i = 0; i < clusters.length; i++) {
            // Run over clusters and their subclusters
            var subclusters = clusters[i].subL;
            if (subclusters) {
              for (var sc = 0; sc < subclusters.length; sc++) {
                var subcluster = subclusters[sc];
                var subclusterExpanded = this.Controller.TP.instance.getSubclusterToggleStatus(subcluster.grpid);
                var openState = subclusterExpanded === true ? "opened" : "closed";
                Hafas.ps.pub('/tracking/event/tripplanner-overview-subcluster-*', [{
                  typ: 'event',
                  key: 'tripplanner-overview-subcluster-' + subcluster.grpid,
                  data: {state: openState}
                }]);
              }
            }
          }
        }

    },this));
  },

  getLocationsFromConnection: function(connection) {
    if(connection && Hafas.Util.checkPath(connection, "dep.locResolved") && Hafas.Util.checkPath(connection, "arr.locResolved")) {
      return [
        connection.dep.locResolved.crd,
        connection.arr.locResolved.crd
      ]
    }
    else
      return null;
  },

  /******************************************************************************************************************************************/
  // Strawberry 1.5: [UPDATE] ServerInfo MapLayerConfig in die Basis gebracht
  /******************************************************************************************************************************************/

  showReconstructionError: function (data) {
    var model = {
      err: data.err,
      errText: data.errText,
      viewHeader: {
        overview: Hafas.Modules.i18n.get('TP.results.t_N_ReconstructionErrorHeader')
      }
    };

    Hafas.Modules.History.addOrUpdateData("TP", "reconstructionError", data);

    Hafas("#TP_ResultOverview").innerHTML = Hafas.Modules.Render.renderTemplate("TP_AtomTplReconstructionError", model);

    this.Controller.TP.currentView = "overview";

    Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'TP'}]);
    Hafas.ps.pub('/GUI/results/overview/show', [{}]);
    Hafas.ps.pub('/app/events/resize');

  },

  sortConnectionByMode: function (connections) {
    var currSort = this.Controller.TP.currentSort;
    connections.sort(function (a, b) {
      if (typeof a.resolvedConnection.scoringResolved[currSort] !== 'undefined' &&
          typeof b.resolvedConnection.scoringResolved[currSort] !== 'undefined') {
        return b.resolvedConnection.scoringResolved[currSort].localeCompare(a.resolvedConnection.scoringResolved[currSort], undefined, {numeric: true});
      } else {
        return 0;
      }
    });
  },
  // TODO: Diese Funktion wird nirgends mehr aufgerufen. Entfernen? Sollte jetzt als Selectbox gelöst sein
  openSortList: function (clusterName) {
    var sortList = Hafas('[data-cluster-sortlist="' + clusterName + '"]', false);
    Hafas.Util.gui.setVisibility(sortList, true);
  },
  selectClusterSort: function (sortKey, groupName) {
    this.Controller.TP.selectedClusterSort = sortKey;
    this.Controller.TP.currentSort = sortKey;
    this.Controller.TP.closeSortList();

    Hafas.bind(this.Controller.TP.renderSortList, this)(groupName);

    // Gruppenresults neu rendern
    Hafas.bind(this.Controller.TP.updateGroupResults, this)(this.Controller.TP.instance.data.results, false, false);
  },
  closeSortList: function () {
    var sortList = Hafas('[data-cluster-sortlist]', true);
    sortList.forEach(function (elem) {
      Hafas.Util.gui.setVisibility(elem, false);
    });
  },
  renderSortList: function (clusterName) {
    /* Render Sortier-Liste */
    var clusterData = Hafas.bind(this.Controller.TP.getClusterByName, this)(clusterName);
    var clusterScoringL = Hafas.Core.clone(clusterData.conScoringL);
    var currentSort = null;
    // Strawberry 1.5: [FIX] Fr�here HCI-Versionen liefern keine ScoringList.
    if (clusterScoringL) {
      for (var c = 0; c < clusterScoringL.length; c++) {
        // Strawberry 1.5: [APP_Bug | #0081066] Cluster-Sort ist leer, wenn lokale Config benutzt wurde, ist jetzt gefixt
        if (typeof clusterScoringL[c].name == 'undefined') {
          clusterScoringL[c].label = Hafas.Modules.i18n.get('TP.results.t_N_clusterSort_' + clusterScoringL[c].type);
        } else {
          clusterScoringL[c].label = clusterScoringL[c].name;
        }
        if (this.Controller.TP.currentSort == clusterScoringL[c].type) {
          clusterScoringL[c].selected = true;
          currentSort = clusterScoringL[c].label;
        }
      }
    }

    var sortListTarget = Hafas('[data-cluster-sortwrapper="tp_' + clusterName + '"]', false);

    // use this in the atom module
    var sortListModel = {
      id: "HFS_ClusterSortSelectBox_" + clusterName,
      holder: "HFS_ClusterSortSelectBox_Holder_" + clusterName,                                                    // required
      input: "",                                                    // name of the invisible input element
      required: true,
      className: "hfs_clusterSortWrapper",
      label: Hafas.Modules.i18n.get('TP.results.t_N_clusterSortBy') + ":",
      caretIcon: {
        icnClass: "lyr_atomExpandCollapse",                                // Arrow-icon shows on the right side of the selectbox
        icnSize: 16
      },
      options: []                                                        // Array of expandable option elements
    };

    for (var i = 0; i < clusterScoringL.length; i++) {
      var currentOption = {
        value: clusterScoringL[i].type,
        selected: clusterScoringL[i].selected,
        content: {
          text: clusterScoringL[i].label,
          tooltip: clusterScoringL[i].label,    // important for A11y
          className: 'lyr_clusterOption'
        }
      };
      sortListModel.options.push(currentOption);
    }

    var focusSelector = Hafas.Util.gui.getFocusElementSelector();

    Hafas.Modules.Render.render({
      file: 'tp.result_overview.html',
      target: sortListTarget,
      template: 'TP_TplClusterSort',
      model: sortListModel,
      global: {view: this.Controller.TP.currentView}
    }, Hafas.bind(function () {
      var callback = function (params) {
        Hafas.ps.pub('/tp/selectClusterSort', [params.value, clusterName]);
      };
      Hafas.Core.newType('HafasSelectBox', {
        holder: 'HFS_ClusterSortSelectBox_Holder_' + clusterName,
        callback: callback
      }).initiate();
      if (!focusSelector) {
        focusSelector = Hafas.Util.node.getPath(Hafas.Util.node.getFirstVisibleAndFocusableElement(Hafas('#HFS_DocumentResultOverview')));
      }
      Hafas.Util.gui.restoreFocus(focusSelector);
    }, this));
  },
  setClusterByGrpId: function (grpId) {
    this.Controller.TP.currentCluster = this.Controller.TP.getClusterIndexByGrpId(grpId);
    this.Controller.TP.visibleClusterGroup = this.Controller.TP.getCurrentClusterBitmask();
  },

  /******************************************************************************************************************************************/
  /******************************************************************************************************************************************/

  prepareHimGrouping: function (renderConnections) {
    var iConn = 0;
    for (iConn; iConn < renderConnections.length; iConn++) {
      var currConn = renderConnections[iConn];
      if (typeof currConn.resolvedMsgL != 'undefined') {

        currConn.resolvedMsgL.combinedMessages =
          Hafas.Modules.Messages.getCombinedMessages({
            msgIdentifier: [
              currConn.resolvedMsgL['SUM_CON_HDR'],
              currConn.resolvedMsgL['SUM_CON_FTR']
            ]
          });

        currConn.resolvedMsgL.combinedMessagesSecHdr =
          Hafas.Modules.Messages.getCombinedMessages({
            msgIdentifier: [
              currConn.resolvedMsgL['RES_GLB_HDR'],
              currConn.resolvedMsgL['RES_GLB_FTR'],
              currConn.resolvedMsgL['RES_CON_HDR']
            ]
          });

        currConn.resolvedMsgL.combinedMessagesSecFtr =
          Hafas.Modules.Messages.getCombinedMessages({
            msgIdentifier: [
              currConn.resolvedMsgL['RES_CON_FTR']
            ]
          });

      }

      // Uebergabe der richtigen Connection beim Aufklappen der Zwischenhalte
      currConn.connectionIdx = iConn;


      // kombinierte Meldungen f?r jede Section
      var iSec = 0,
        iSecLen = currConn.secL.length;
      for (iSec; iSec < iSecLen; iSec++) {
        var currSection = currConn.secL[iSec];

        if (typeof currSection.jny != 'undefined') {
          currConn.resolvedSecMsgL = [];
          if (typeof currSection.jny.resolvedMsgL != 'undefined') {
            if (typeof currSection.jny.resolvedMsgL['RES_JNY'] != 'undefined') {
              var iResMsgL = 0,
                iResMsgLLen = currSection.jny.resolvedMsgL['RES_JNY'].length;
              for (iResMsgL; iResMsgL < iResMsgLLen; iResMsgL++) {
                var item = currSection.jny.resolvedMsgL['RES_JNY'][iResMsgL];
                if (item.type === 'HIM') {
                  currConn.resolvedSecMsgL.push(item);
                }
              }
            }
          }
        }

        if (typeof currSection.resolvedMsgL != 'undefined') {
          if (typeof currSection.jny != 'undefined' && typeof currSection.jny.resolvedMsgL != 'undefined') {
            currSection.jny.resolvedMsgL.combinedMessages =
              Hafas.Modules.Messages.getCombinedMessages({
                msgIdentifier: [
                  currSection.jny.resolvedMsgL['SUM_JNY'],
                  currSection.resolvedMsgL['SUM_SEC'],
                  currSection.resolvedMsgL['RES_SEC_HDR'],
                  currSection.resolvedMsgL['RES_SEC_FTR']
                ]
              });
          }

          if (typeof currSection.dep != 'undefined' && typeof currSection.dep.resolvedMsgL != 'undefined') {
            currSection.dep.resolvedMsgL.combinedMessages =
              Hafas.Modules.Messages.getCombinedMessages({
                msgIdentifier: [
                  currSection.dep.resolvedMsgL['RES_LOC']
                ]
              });
          }

          if (typeof currSection.arr != 'undefined' && typeof currSection.arr.resolvedMsgL != 'undefined') {
            currSection.arr.resolvedMsgL.combinedMessages =
              Hafas.Modules.Messages.getCombinedMessages({
                msgIdentifier: [
                  currSection.arr.resolvedMsgL['RES_LOC']
                ]
              });
          }
        }

        // kombinierte Meldungen in den Intermediate Stops
        if (typeof currSection.jny != 'undefined' && typeof currSection.jny.stopL != 'undefined') {
          var iStop = 0,
            iStopLen = currSection.jny.stopL.length;
          for (iStop; iStop < iStopLen; iStop++) {
            var currStop = currSection.jny.stopL[iStop];
            if (typeof currStop.resolvedMsgL != 'undefined') {
              currStop.resolvedMsgL.combinedMessages =
                Hafas.Modules.Messages.getCombinedMessages({
                  msgIdentifier: [
                    currStop.resolvedMsgL['RES_LOC']
                  ]
                });
            }
          }
        }
      }
    }
    return renderConnections;
  },
  updateGroupResults : function (data, requestsPending, forceSelection) {
    var tpController = this.Controller.TP;
    var me = this;

    Hafas.bind(tpController.updateHistoryIfOverview, me)(data);

    // Look for "favorite" cluster group
    var connectionGroupToCheck = this.Controller.TP.visibleClusterGroup;
    if (this.Controller.TP.visibleClusterGroup === 'heart') {
      connectionGroupToCheck = tpController.groupFavMode + '_score';
    }

    // If no more requests are running and there are no results for the current cluster (after this cluster has also been requested
    // "requested=true"), the system should jump to the next cluster
    connectionGroupToCheck = tpController.jumpToNextClusterIfNoResults(data, requestsPending, connectionGroupToCheck, forceSelection);

    // prepare results
    var bestConnections = Hafas.bind(tpController.getBestConnections, this)(data.groups);

    var currentClusterGroups = Hafas.Core.clone(Hafas.Config.TP.cluster);
    var focusSelector = Hafas.Util.gui.getFocusElementSelector();

    // Handle cluster groups and resolve bestConnection, active state and loading
    Hafas.bind(tpController.handleClusterGroups, me)(data.groups, currentClusterGroups, bestConnections, requestsPending);

    // Render cluster buttons
    Hafas.bind(tpController.renderClusterButtons, me)(currentClusterGroups, focusSelector);

    var currentVisibleClusterIndex = currentClusterGroups.findIndex(function(clusterGroup) {
      return clusterGroup.active === true;
    });
    if (currentVisibleClusterIndex === -1) {
      currentVisibleClusterIndex = 0;
    }
    var clustersToDisplayBitmasks = [];

    // If Cluster view mode is enabled, just show on cluster
    if (Hafas.Config.TP.groupingDisplay === 'cluster') {
      clustersToDisplayBitmasks.push(connectionGroupToCheck);
    } else {
      // For list mode everything needs to be rendered
      Hafas.Config.TP.cluster.forEach(function (cluster) {
        // Score - Gruppen werden nicht berücksichtigt
        if (cluster.type.indexOf("score") === -1) {
          clustersToDisplayBitmasks.push(cluster.bitmask);
        }
      });
    }

    clustersToDisplayBitmasks.forEach(function (clusterGroupToRender) {
      var renderConnections = [];
      var messagesResolved = {};
      var currentGroup = data.groups[clusterGroupToRender];
      if (currentGroup) {
        var connections = currentGroup.connections;
        // Sort connections by selected mode
        Hafas.bind(tpController.sortConnectionByMode, me)(connections);
        connections.forEach(function (connection) {
          // Display flag "showDetailViewHeader" is reset to false (will be set to true in detail view)
          connection.resolvedConnection.showDetailViewHeader = false;
          renderConnections.push(connection.resolvedConnection);
        })
        if (typeof currentGroup.messagesResolved != 'undefined') {
          messagesResolved = currentGroup.messagesResolved;
        }
      }

      var clusterSettings = {
        currentGrpLabel: '',
        currentGrpId: '',
        scrollingAllowed: false,
        subClusterAvailable: false
      }

      var subClusters = [];

      Hafas.bind(tpController.gatherSubclusterData, me)(subClusters, clusterGroupToRender, data.groups[clusterGroupToRender], clusterSettings);

      if (tpController.visibleClusterGroup !== 'settings') {
        var model = {
          grpLabel: clusterSettings.currentGrpLabel,
          grpId: clusterSettings.currentGrpId,
          messagesResolved: messagesResolved,
          requestsPending: requestsPending,
          renderConnections: renderConnections,
          type: clusterGroupToRender,
          currentLoadingState: currentClusterGroups[currentVisibleClusterIndex].currentLoadingState,
          scrollable: clusterSettings.scrollingAllowed,
          subcluster: subClusters,
          subClusterAvailable: clusterSettings.subClusterAvailable,
          foundConnectionOnRequestDate: tpController.isAnyConnectionOnRequestDate(renderConnections, data),
          offerScrollConnections: (clusterSettings.scrollingAllowed && renderConnections.length > 0),
          requestDate: data.requestDate
        };

        renderConnections = tpController.prepareHimGrouping(renderConnections);

        tpController.setClusterDateRangeBegin(renderConnections);

        tpController.checkSubClusterDateChanges(subClusters, clusterSettings);

        if (tpController.currentView !== "overview") {
          // Check if it's the details view, then we need to rerender the carousel
          // whenever new results arrive and the carousel is initialized already
          if(tpController.connectionCarouselDetails) {
            Hafas.bind(tpController.updateCarousel, me)();
          }
          return;
        }

        var renderTarget = Hafas('[data-result-conngroup="' + clusterGroupToRender + '"]');

        var scrollTopBefore = tpController.getScrollPosition(data, renderTarget);
        focusSelector = Hafas.bind(tpController.restoreClusterFocus, me)(focusSelector, requestsPending);

        Hafas.Modules.Render.render({
            file: 'tp.result.overview_cluster.html',
            target: renderTarget,
            template: 'TP_AtomTplListConnectionOverview_Cluster',
            model: model,
            global: {view: tpController.currentView}
          }, function () {
            Hafas.bind(tpController.clusterRenderingCallback, me)(data, subClusters, clusterGroupToRender, currentClusterGroups, clusterSettings, renderTarget, model, currentVisibleClusterIndex, requestsPending, focusSelector, renderConnections, scrollTopBefore);
          }
        );
      }
    });
  },
  updateHistoryIfOverview: function (data) {
    if (this.Controller.TP.currentView === "overview") {
      var optionsModel = {};
      if (Hafas.Config.TP.useQueryOptions === true) {
        optionsModel = this.Controller.TP.options.getModifiedModel();
      }
      Hafas.Modules.History.addOrUpdateData("TP", "overview", {
        response: data,
        optionModel: optionsModel
      });
    }
  },
  jumpToNextClusterIfNoResults: function (data, requestsPending, connectionGroupToCheck, forceSelection) {
    if (requestsPending) {
      return connectionGroupToCheck;
    }
    var groupAlreadyRequested = false;
    Hafas.Config.TP.cluster.forEach(function (cluster) {
      if (!groupAlreadyRequested && (cluster.bitmaskResolved === connectionGroupToCheck) && cluster.requested) {
        groupAlreadyRequested = true;
      }
    });

    if (typeof data.groups[connectionGroupToCheck] === 'undefined' && forceSelection && groupAlreadyRequested) {
      for (var i = 0; i < Hafas.Config.TP.cluster.length; i++) {
        var clusterType = Hafas.Config.TP.cluster[i].type;
        if (data.groups[clusterType] && data.groups[clusterType].connections.length > 0) {
          this.Controller.TP.selectClusterGroup(clusterType);
          return Hafas.Config.TP.cluster[i].bitmaskResolved;
        }
      }
    }
    return connectionGroupToCheck;
  },
  handleClusterGroups: function (groups, currentClusterGroups, bestConnections, requestsPending) {
    var me = this;
    if (Hafas.Config.TP.groupingDisplay !== 'cluster') {
      return;
    }
    currentClusterGroups.forEach(function (currentClusterGroup, clusterIndex) {
      var bestConnToCheck = currentClusterGroup.bitmask;
      var currentLoadingState = me.Controller.TP.instance.getClusterLoadingState(currentClusterGroup.grpid);
      currentClusterGroup.currentLoadingState = currentLoadingState;
      var tmpSubclusterConnections = [];
      var currentGroup = groups[bestConnToCheck];

      if (typeof currentGroup !== 'undefined') {
        if (typeof currentGroup.subcluster !== 'undefined') {
          for (var s in currentGroup.subcluster) {
            tmpSubclusterConnections = tmpSubclusterConnections.concat(currentGroup.subcluster[s].connections);
          }
          currentClusterGroup.bestConnection = me.Controller.TP.createBestConnectionData(tmpSubclusterConnections);
        } else {
          currentClusterGroup.bestConnectionData = me.Controller.TP.createBestConnectionData(currentGroup.connections);
        }
      }

      if (typeof bestConnections[bestConnToCheck] !== 'undefined') {
        currentClusterGroup.bestConnection = bestConnections[currentClusterGroup.bitmask];
        if (Hafas.Config.TP.showClusterTransfers) {
          currentClusterGroup.transfers = bestConnections[currentClusterGroup.bitmask].chg;
        }
      } else {
        if (me.Controller.TP.instance.isClusterRequested(currentClusterGroup.grpid) && !currentLoadingState.isLoaded) {
          currentClusterGroup.loading = true;
        } else if (!requestsPending && currentLoadingState.isLoaded && (typeof currentClusterGroup.subL === 'undefined' || tmpSubclusterConnections.length === 0)) {
          currentClusterGroup.unavailable = true;
        } else {
          currentClusterGroup.empty = true;
        }
      }

      currentClusterGroup.active = (parseInt(me.Controller.TP.visibleClusterGroup, 10) === currentClusterGroup.bitmask);
    });
  },
  renderClusterButtons(clusterGroups, focusSelector) {
    var me = this;
    if (clusterGroups) {
      clusterGroups.forEach(function (currentClusterGroup) {
        var clusterPreviewTarget = Hafas('[data-cluster-link="' + currentClusterGroup.bitmask + '"]');
        Hafas.Modules.Render.render({
            file: 'tp.result.overview_cluster.html',
            target: clusterPreviewTarget,
            template: 'TP_AtomTplClusterPreview',
            model: currentClusterGroup,
            global: {view: me.Controller.TP.currentView}
          },
          Hafas.bind(function () {
            Hafas.Util.gui.restoreFocus(focusSelector);
          }, me)
        );
      });
    }
  },
  gatherSubclusterData: function (subClusters, clusterGroupToRender, clusterGroupData, clusterSettings) {
    var me = this;
    Hafas.Config.TP.cluster.forEach(function (cluster) {
      if (cluster.bitmask === parseInt(clusterGroupToRender)) {
        clusterSettings.currentGrpLabel = Hafas.Modules.i18n.get(cluster.label);
        clusterSettings.currentGrpId = cluster.grpid;
        if (cluster.scrollable) {
          clusterSettings.scrollingAllowed = true;
        }
        // Subcluster Auswertung
        if (typeof cluster.subL != 'undefined') {
          clusterSettings.subClusterAvailable = true;

          var subclusterConnectionFound = false;
          cluster.subL.forEach(function (tmpSubCluster) {
            var subClusterData = {
              scrollable: tmpSubCluster.scrollable,
              name: tmpSubCluster.name,
              grpId: tmpSubCluster.grpid,
              renderConnections: [],
              icoResolved: tmpSubCluster.icoResolved,
              loadingState: me.Controller.TP.instance.getSubClusterLoadingState(clusterSettings.currentGrpId, tmpSubCluster.grpid),
              requests: tmpSubCluster.requests
            };

            if (clusterGroupData?.subcluster[tmpSubCluster.grpid]) {
              var tmpSubClConnectionData = clusterGroupData.subcluster[tmpSubCluster.grpid];
              Hafas.bind(me.Controller.TP.sortConnectionByMode, me)(tmpSubClConnectionData.connections);
              subClusterData.bestConnection = me.Controller.TP.createBestConnectionData(tmpSubClConnectionData.connections);
              tmpSubClConnectionData.connections.forEach(function (connection) {
                subClusterData.renderConnections.push(connection.resolvedConnection);
              });
            }

            // Check which subcluster needs to be opened by default.
            // 1. Subcluster
            // Subcluster, that have been opened before
            // If previous subclusters have no connection, open the first subcluster with a connection
            var subclExpandStatus = me.Controller.TP.instance.getSubclusterToggleStatus(tmpSubCluster.grpid);
            var expandByAutosend = false;
            tmpSubCluster.requests.forEach(function (request) {
              if (request.autosend) {
                expandByAutosend = true;
              }
            });
            if (!subclusterConnectionFound && expandByAutosend || subclExpandStatus === true) {
              // No cluster with a connection before && autosend for any cluster request is on
              // OR the expand status of the cluster (saved during runtime) is true
              // -> set expanded status of subcluster to true
              subClusterData.expanded = true;
              if (subClusterData.renderConnections.length > 0) {
                // Set flag that we have a subcluster with a connection
                subclusterConnectionFound = true;
              }
            } else {
              // Subcluster with connection exists already, autosend is false or subcluster was not opened before
              subClusterData.expanded = false;
            }

            subClusters.push(subClusterData);
          });
        }
      }
    });
  },
  getBestConnections: function (groups) {
    var tpController = this.Controller.TP;
    var bestConnectionsOutput = {};

    for (var groupKey in groups) {
      if ((typeof groups[groupKey].favGroup === 'undefined') || (groupKey === tpController.groupFavMode + '_score')) {
        var group = groups[groupKey];
        group.renderConnections = [];

        if (groupKey === this.Controller.TP.groupFavMode + '_score') {
          group.type = 'heart';
          group.grpid = 'heart';
        } else {
          group.type = groupKey;
          group.grpid = groupKey;
        }

        group.connections.sort(function (a, b) { //Sort by score/best match
          return b.resolvedConnection.scoringResolved[tpController.groupFavMode] - a.resolvedConnection.scoringResolved[tpController.groupFavMode];
        });
        group.connections.forEach(function (connection, index) {
          if (index === 0) {
            bestConnectionsOutput[group.type] = connection.resolvedConnection;
          }
          group.renderConnections.push(connection.resolvedConnection);
        });
      }
    }

    return bestConnectionsOutput;
  },
  getScrollPosition: function (data, renderTarget) {
    // Speichere wenn nötig und vorhanden die Scrollposition (scrollToTop ist beim First und Earlier true)
    if ((data.isScrollRequest || data.isFirstLastRequest) && !(data.scrollType === 'B' || data.firstLastParam === 'FRST')) {
      return Hafas.Util.gui.getScrollTop(Hafas('.lyr_flexScrolledContainer', true, renderTarget)[0]);
    }
    return null;
  },
  restoreClusterFocus: function (focusSelector, requestsPending) {
    // If no more requests are pending, focus can be restored to the refresh button (if necessary)
    if (this.Controller.TP.focusSelector && !requestsPending) {
      focusSelector = this.Controller.TP.focusSelector;
      this.Controller.TP.focusSelector = null; // avoid unintentionally restoring focus later on
    }
    return focusSelector;
  },
  // Prüfen ob mindestens eine Verbindung im Ergebnis dem Anfragedatum entspricht
  isAnyConnectionOnRequestDate: function (renderConnections, data) {
    if (typeof renderConnections === 'undefined' || renderConnections.length === 0) {
      return true;
    }
    var foundConnectionOnRequestDate = false;
    renderConnections.forEach(function (renderConnection) {
      var tmpConnDate = renderConnection.date;
      var dateToCheck = tmpConnDate;
      if (data.requestIsArrival) {
        var arrivalTimeStamp = Hafas.Core.newType("hafasTime", {
          date: tmpConnDate,
          time: renderConnection.arr.aTimeS
        });
        dateToCheck = arrivalTimeStamp.format("YYYYMMDD");
      }
      if (data.requestDate === dateToCheck) {
        foundConnectionOnRequestDate = true;
      }
    });
    return foundConnectionOnRequestDate;
  },
  checkSubClusterDateChanges(subClusters, clusterSettings) {
    if (clusterSettings.subClusterAvailable && subClusters.length > 0) {
      subClusters.forEach(function (subCluster) {
        tpController.setClusterDateRangeBegin(subCluster.renderConnections);
      });
    }
  },
  // Reset day change flag
  // Show date change. Relevant only if sorted by time
  setClusterDateRangeBegin: function (renderConnections) {
    var dateRangeBegin = null;
    renderConnections.forEach(function (renderConnection) {
      delete renderConnection.dateChanged;
      if (dateRangeBegin === null || renderConnection.date !== dateRangeBegin) {
        renderConnection.dateChanged = true;
        dateRangeBegin = renderConnection.date;
      }
    });
  },
  clusterRenderingCallback: function (data, subClusters, clusterGroupToRender, currentClusterGroups, clusterSettings, renderTarget, model, currentVisibleClusterIndex, requestsPending, focusSelector, renderConnections, scrollTopBefore) {
    var me = this;

    // Rerender Messages for Global Container
    Hafas.bind(tpController.renderGlobalMessages, this)(data.groups, clusterGroupToRender);

    // Springe auf die gespeicherte Scrollposition (scrollToTop ist beim First und Earlier true)
    // Jump to saved scroll position (scrollToTop is true if first or ealier
    if ((data.isScrollRequest || data.isFirstLastRequest)
      && !(data.scrollType === 'B' || data.firstLastParam === 'FRST')) {
      Hafas.Util.gui.setScrollTop(Hafas('.lyr_flexScrolledContainer', true, renderTarget)[0], scrollTopBefore);
    }

    // Number of connections per Cluster:
    if (Hafas('[data-tripLabel="tp_' + model.type + '"]')) {
      Hafas('[data-tripLabel="tp_' + model.type + '"]').innerHTML = clusterSettings.currentGrpLabel;
    }

    if (Hafas.Config.TP.useGrouping && Hafas.Config.TP.useClusterSort) {
      Hafas.bind(tpController.renderSortList, me)(clusterGroupToRender);
    }

    var activeConnectionSelection = tpController.activeSelection;
    if (this.Controller.Map.instance && currentClusterGroups[currentVisibleClusterIndex].currentLoadingState.isLoaded) {
      this.Controller.Map.hideConnection();

      // Select connections to show from clusters or subclusters respectively
      if (renderConnections.length > 0 && clusterSettings.subClusterAvailable === false) {
        // For all rendered connections collect the polyline coordinates and set them in the TRM
        Hafas.ps.pub('/trm/prepareJourneyPassesThrough', [renderConnections]);
        var currConnection = renderConnections[0];
        if (typeof activeConnectionSelection !== 'undefined' && typeof renderConnections[activeConnectionSelection.arrayIdx] !== 'undefined') {
          currConnection = renderConnections[activeConnectionSelection.arrayIdx];
        }
        this.Controller.Map.showConnection(tpController.selectedConnection || currConnection);
      } else {
        // check for subclusters
        if (clusterSettings.subClusterAvailable) {
          if (typeof data.groups[clusterGroupToRender] !== 'undefined') {
            for (var i = 0; i < subClusters.length; i++) {
              if (typeof activeConnectionSelection.subclusterGrpId === 'undefined' || (subClusters[i].grpId === activeConnectionSelection.subclusterGrpId)) {
                if (subClusters[i].renderConnections.length > 0) {
                  var subClusterConnIdx = activeConnectionSelection.arrayIdx || 0;
                  this.Controller.Map.showConnection(subClusters[i].renderConnections[subClusterConnIdx]);
                  break;
                }
              }
            }
          }
        }
      }
    }

    // If there are subclusters available in the selected cluster, expand the first one
    if (clusterSettings.subClusterAvailable) {
      var selectedSubclusterConn = false;
      for (var j = 0; j < subClusters.length; j++) {
        if (subClusters[j].renderConnections.length > 0 && !selectedSubclusterConn) {
          var subGrpId = subClusters[j].grpId;
          if (typeof activeConnectionSelection.subclusterGrpId !== 'undefined') {
            subGrpId = activeConnectionSelection.subclusterGrpId;
          }
          Hafas.bind(tpController.highlightActiveSelection, this)(model.type, subGrpId);
          selectedSubclusterConn = true;
        }
      }
    } else {
      Hafas.bind(tpController.highlightActiveSelection, this)(model.type);
    }


    // Hide all scroll elements
    var allScrollContainer = Hafas('[data-scroll-connections]', true);
    allScrollContainer.forEach(function (elem) {
      Hafas.Util.gui.setVisibility(elem, false);
    });

    // If scrollable, show corresponding scollable block
    if (model.offerScrollConnections && currentClusterGroups[currentVisibleClusterIndex].currentLoadingState.isLoaded) { // Strawberry 1.6.0
      // Show or hide the scroll elements of subclusters accordingly
      tpController.checkScrollComponentsVisibility(clusterSettings.currentGrpId);
    }
    if (typeof model.subcluster !== 'undefined') {
      model.subcluster.forEach(function (subCluster) {
        if (subCluster.scrollable === true && subCluster.renderConnections.length > 0) {
          tpController.checkScrollComponentsVisibility(subCluster.grpId);
        }
      });
    }

    Hafas.ps.pub('/GUI/results/resize', [{
      container: me.resultOverviewContainer,
      appcontext: me.appContext
    }]);
    Hafas.ps.pub('/app/events/resize');

    // Ladebalken wird beim Laden von Verbindungen angezeigt wenn dazu mehrere Requeste erforderlich sind.
    setTimeout(function () {
      var tmp = Hafas("#HFS_SpinnerBarDone_" + model.type);
      if (tmp)
        tmp.style.width = model.currentLoadingState.percentDone + "%";
    }, 0);
    if (requestsPending === false) {
      Hafas.ps.pub('/tp/overview/clusterAllLoaded');
    }
    Hafas.Util.gui.restoreFocus(focusSelector);
  },
  /**
   * For the given connection(s), collect the polyline coordinates and save them in TRM ARRAY_OF_ROUTES
   * @method prepareTrmJourney
   * @param {array|object} renderConnections Array of connections or just one connection as an object
   */
  prepareTrmJourney: function(renderConnections) {
    var connectionPolyCoords = [];
    var polyCoords;
    if (Array.isArray(renderConnections)) {
      for (var i = 0; i < renderConnections.length; i++) {
        var conn = renderConnections[i];
        polyCoords = Hafas.Util.getConnectionPolylineCoords(conn);
        connectionPolyCoords[i] = polyCoords;
      }
    } else {
      // Nur eine Verbindung, z.B. bei TP Details
      polyCoords = Hafas.Util.getConnectionPolylineCoords(renderConnections);
      connectionPolyCoords[0] = polyCoords;
    }
    Hafas.ps.pub('/trm/setLocation', ['ARRAY_OF_ROUTES', connectionPolyCoords]);
  },
  buildRemarkHash: function(remark){
    if (remark.remResolved) {
      // Bei Remarks Hash aus txtN und ico.res bilden, um Eindeutigkeit zu bestimmen
      var hashBase = "";
      if (remark.remResolved.txtN !== undefined) {
        hashBase += remark.remResolved.txtN;
      }
      if (remark.remResolved.txtS !== undefined) {
        hashBase += remark.remResolved.txtS;
      }
      if (remark.remResolved.icoResolved !== undefined) {
        hashBase += remark.remResolved.icoResolved.res;
      }
      return Hafas.Util.b64EncodeUnicode(hashBase);
    }
  },
  deleteMessageDuplicates: function(targetArray, srcArray){
    for(var s=0; s < srcArray.length;s++){
      var msgFound = false;
      for(var t=0; t < targetArray.length;t++){
        if(targetArray[t].type == 'REM' && this.Controller.TP.buildRemarkHash(targetArray[t]) == this.Controller.TP.buildRemarkHash(srcArray[s])){
          msgFound = true;
        }
        if(targetArray[t].type == 'HIM' && srcArray[s].type == 'HIM' && targetArray[t].himResolved.hid == srcArray[s].himResolved.hid) {
          msgFound = true;
        }
      }
      if(!msgFound){
        targetArray.push(srcArray[s]);
      }
    }
    return targetArray;
  },
  renderGlobalMessages: function(groups,clusterGroupToRender){
    // Global Meldungen müssen permanent neu gerendert werden, wenn neue TripSearch Requests verarbeitet worden sind
    // Diese Funktion merged bereits bestehende Meldungen aus anderen Requests mit neu ankommenden Messages (Cluster-Requests)
    var renderContainerSections = ["ConnectionOverviewHeader","ConnectionOverviewFooter"];
    var mergedData = {
      messagesResolved: {}
    };

    // Durch alle groups iterieren und für obige Sections merges durchführen
    for (var s = 0; s < renderContainerSections.length; s++) {
      var containerSec = renderContainerSections[s];
      // Alle Gruppen durchlaufen und messages Array mergen
      for (var g in groups) {
        var tmpGroup = groups[g];
        if (tmpGroup.messagesResolved !== undefined) {
          var currMsgContainer = tmpGroup.messagesResolved[containerSec];
          if (currMsgContainer !== undefined) {
            if (mergedData.messagesResolved[containerSec] === undefined) {
              mergedData.messagesResolved[containerSec] = currMsgContainer;
            } else {
              if(currMsgContainer !== undefined && currMsgContainer.messages !== undefined) {
                mergedData.messagesResolved[containerSec].messages = this.Controller.TP.deleteMessageDuplicates.bind(this)(mergedData.messagesResolved[containerSec].messages,currMsgContainer.messages);
              }
            }
          }
        }
      }

      // Kein Meldungen für den Container verfügbar, dann brauch nicht gerendert werden
      if(mergedData.messagesResolved[containerSec] === undefined){
        continue;
      }

      // Meldungen müssen nach dem Mergen noch einmal sortiert werden
      if(mergedData.messagesResolved[containerSec].messages !== undefined) {
        mergedData.messagesResolved[containerSec].messages.sort(function _sortFunc(a, b) {
          if (typeof a.sort === 'number' && typeof b.sort === 'number') return a.sort - b.sort;
        });
      }

      // Schlussendlich: Rendern des Message-Containers
      var msgSummaryContainer = Hafas('[data-result-conngroup="' + clusterGroupToRender + '"] [data-cluster-messages="'+containerSec+'"]',false);
      var msgResolvedContainer = mergedData.messagesResolved[containerSec];
      // Prüfen ob Container existiert und Meldungen vorhanden sind
      if(msgSummaryContainer && msgResolvedContainer.messages !== undefined && msgResolvedContainer.messages.length > 0){
        Hafas.Modules.Render.render({
          file: 'tp.result.overview_cluster.html',
          template: 'Tp_TplClusterMessageSection_SummaryGlobal',
          target: msgSummaryContainer,
          model: {msgData: mergedData.messagesResolved[containerSec]},
          global: {clusterGroupToRender: clusterGroupToRender}
        }, Hafas.bind(function(){
              Hafas.Util.gui.setVisibility(msgSummaryContainer,true);
        },this));
      }
    }
  },
  isScrollingStateAvailable: function (type, groupId) {
    // Gebe gespeicherte gedrückte ScrollingButtons
    return ((this.scrollButtonsState || {})[groupId] || {})[type];
  },
  isScrollingTypeAvailable: function (type, groupId) {
    var cluster = this.instance.data.query.cluster;
    var resultsIV = this.instance.data.resultsIV;
    var scrollingFound = false;
    for (var c = 0; c < cluster.length; c++) {
      if (typeof cluster[c].subL != 'undefined') {
        for (var s = 0; s < cluster[c].subL.length; s++) {
          if (cluster[c].subL[s].grpid == groupId) {
            for (var r = 0; r < cluster[c].subL[s].requests.length; r++) {
              var currSubClusterReqId = cluster[c].subL[s].requests[r].id;
              if (typeof resultsIV[currSubClusterReqId] != 'undefined' && typeof resultsIV[currSubClusterReqId]['outCtxScr' + type] != 'undefined') {
                return true;
              }
            }
          }
        }
      }
      if (cluster[c].grpid == groupId) {
        for (var g = 0; g < cluster[c].groups.length; g++) {
          if (typeof resultsIV[cluster[c].groups[g].id] != 'undefined' && typeof resultsIV[cluster[c].groups[g].id]['outCtxScr' + type] != 'undefined') {
            return true;
          }
        }
      }
    }
    return scrollingFound;
  },
  checkScrollComponentsVisibility: function (currentGrpId) {

    var scrollComponent = Hafas('[data-scroll-connections="' + currentGrpId + '"]', true);


    if (scrollComponent && scrollComponent.length !== 0) {
      for(var m= 0; m<scrollComponent.length;m++){
        Hafas.Util.gui.setVisibility(scrollComponent[m], true);
      }

      var earlierLink = Hafas('[data-scroll-link="earlier"][data-scroll-type="' + currentGrpId + '"]', false);
      if (this.isScrollingTypeAvailable('B', currentGrpId)) {
        earlierLink.removeAttribute("disabled");
      } else {
        earlierLink.setAttribute("disabled", true);
      }


      var laterLink = Hafas('[data-scroll-link="later"][data-scroll-type="' + currentGrpId + '"]', false);
      if (this.isScrollingTypeAvailable('F', currentGrpId)) {
        laterLink.removeAttribute("disabled");
      } else {
        laterLink.setAttribute("disabled", true);
      }
      var lastLink = Hafas('[data-scroll-link="last"][data-scroll-type="' + currentGrpId + '"]', false);
      if (lastLink != null) {
        if (this.isScrollingTypeAvailable('F', currentGrpId) && !this.isScrollingStateAvailable('LAST', currentGrpId)) {
          lastLink.removeAttribute("disabled");
        } else {
          lastLink.setAttribute("disabled", true);
        }
      }
      var firstLink = Hafas('[data-scroll-link="first"][data-scroll-type="' + currentGrpId + '"]', false);
      if (firstLink != null) {
        if (this.isScrollingTypeAvailable('F', currentGrpId) && !this.isScrollingStateAvailable('FRST', currentGrpId)) {
          firstLink.removeAttribute("disabled");
        } else {
          firstLink.setAttribute("disabled", true);
        }
      }
      Hafas('[data-scroll-link] img', true).forEach(function (elem) {
        elem.parentNode.removeChild(elem);
      });
      Hafas.ps.pub('/tp/earlierLaterConnectionFound', [{type: currentGrpId}]);
    }
  },
  createBestConnectionData: function (connectionList) {
    if (connectionList.length == 0)
      return {};

    function getDurMin(dur) {
      var durArr = dur.split(":");
      return durArr[0] * 60 + durArr[1];
    }

    var bestConnectionData = {
      dur: connectionList[0].resolvedConnection.dur,
      durN: connectionList[0].resolvedConnection.durN,
      durMin: getDurMin(connectionList[0].resolvedConnection.dur),
      changes: connectionList[0].resolvedConnection.chg
    };
    for (var k = 1; k < connectionList.length; k++) {
      var tmpConnection = connectionList[k].resolvedConnection;

      var tmpDurMin = getDurMin(tmpConnection.dur);

      if (tmpConnection.durMin < tmpDurMin) {
        bestConnectionData.dur = tmpConnection.dur;
        bestConnectionData.durN = tmpConnection.durN;
        bestConnectionData.durMin = tmpDurMin;
      }

      if (tmpConnection.chg < bestConnectionData.changes) {
        bestConnectionData.changes = tmpConnection.chg;
      }
    }
    return bestConnectionData;
  },
  // Subcluster auf- und zuklappen und dafür sorgen, dass Request ggfs. nach geladen werden
  toggleSubCluster: function (keepId) {
    // Wird aufgeklappt, ggfs. Request absetzen
    var subclusterData = Hafas.Modules.Render.objectKeeper.get(keepId);
    var clusterIndex = this.Controller.TP.getClusterIndexByBitmask(subclusterData.cluster.type);
    this.Controller.TP.instance.setSubclusterToggleStatus(subclusterData.subcluster.grpId, !subclusterData.subcluster.expanded)
    if (subclusterData.subcluster.expanded == false) {
      for (var s = 0; s < subclusterData.subcluster.requests.length; s++) {
        var tmpRequest = subclusterData.subcluster.requests[s];
        this.Controller.TP.instance.searchIV({
          cluster: clusterIndex,
          mode: tmpRequest.id,
          type: 'GROUP',
          label: Hafas.Modules.i18n.get('TP.index.t_N_SectionType' + subclusterData.subcluster.grpid)
        }, null, {addLoad: true});
      }
      /**/
    }
  },
  // an/abschalten von autoload clustern (z.b. bevor gesucht wurde)
  toggleClusterAutoload: function (params) {
    var clusterIndex = null;
    // cluster nach index?
    if (typeof params.index != 'undefined') {
      clusterIndex = params.index;
    }
    // cluster nach name? dann index finden
    else if (typeof params.cluster != 'undefined') {
      Hafas.Config.TP.cluster.forEach(function (elem, idx) {
        if (params.cluster == elem.type) {
          clusterIndex = idx;
        }
      });
    }

    if (clusterIndex) {

      // an/ausschalten?
      var enable = true;
      if (params.enabled == false) {
        enable = false;
      }

      Hafas.Config.TP.cluster[clusterIndex].autoload = enable;

      for (var k in Hafas.Config.TP.cluster[clusterIndex].groups) {
        this.instance.setGroupFilter(Hafas.Config.TP.cluster[clusterIndex].groups[k].id, enable); // Strawberry 1.5
      }
      this.instance.setCluster(Hafas.Config.TP.cluster);
    }
  },
  changeClusterSettings: function (type) {
    this.Controller.TP.groupFavMode = type;

    Hafas.bind(function () {
      Hafas.bind(this.Controller.TP.updateGroupResults, this)(this.Controller.TP.instance.data.results);
    }, this)();
  },
  getClusterIndexByBitmask: function (bitmask) {
    for (var t = 0; t < Hafas.Config.TP.cluster.length; t++) {
      var tmpCluster = Hafas.Config.TP.cluster[t];
      if (tmpCluster.bitmask == bitmask) {
        return t;
      }
    }
  },
  getClusterIndexByGrpId: function (grpId) {
    for (var t = 0; t < Hafas.Config.TP.cluster.length; t++) {
      var tmpCluster = Hafas.Config.TP.cluster[t];
      if (tmpCluster.grpid == grpId) {
        return t;
      }
    }
  },
  // Strawberry 1.5: [UPDATE] ServerInfo MapLayerConfig in die Basis gebracht
  getClusterByName: function (clusterName) {
    return Hafas.Config.TP.cluster[this.Controller.TP.getClusterIndexByBitmask(clusterName)];
  },
  selectClusterGroup: function (id, forceSelection, clusterIndex, fromList) {
    // Set TRM cluster parameter
    Hafas.ps.pub('/trm/setCluster', [Hafas.Config.TP.cluster[clusterIndex].grpid]);
    this.currentCluster = clusterIndex;
    if (this.visibleClusterGroup !== id) {
      this.selectedConnection = null;
      if (typeof this.activeSelection === 'undefined' || this.activeSelection.connType !== id) {
        this.activeSelection = {connType: id, arrayIdx: 0};
      }
    }
    var me = this;
    this.visibleClusterGroup = id;

    this.clusterFromList = false;
    if (typeof fromList !== 'undefined') {
      this.clusterFromList = fromList;
    }

    if ((Hafas.Config.TP.cluster[clusterIndex].bitmaskResolved !== id)) {
      Hafas.Config.TP.cluster.forEach(function (obj, index) {
        if (obj.type === id) {
          clusterIndex = index;
        }
      });
    }

    // Strawberry 1.5: [UPDATE] ServerInfo MapLayerConfig in die Basis gebracht
    // pr�fen ob Gruppe noch nicht per Autoload geladen wurde und pr?fen, ob der Cluster noch nicht angefragt wurde
    Hafas.Config.TP.cluster[clusterIndex].requested = true;
    this.instance.setClusterRequested(Hafas.Config.TP.cluster[clusterIndex].grpid);
    for (var g = 0; g < Hafas.Config.TP.cluster[clusterIndex].groups.length; g++) {
      var currGrp = Hafas.Config.TP.cluster[clusterIndex].groups[g];
      if (this.instance.isRequestGroupLoaded(currGrp) === false && currGrp.autosend === false) {
        this.instance.searchIV({
          mode: currGrp.id,
          type: "GROUP",
          label: Hafas.Modules.i18n.get(Hafas.Config.TP.cluster[clusterIndex].label)
        }, null, {addLoad: true});
      }
    }
    Hafas.bind(this.main.Controller.TP.setInitialSort,this)(clusterIndex);
    this.main.Controller.Map.hideConnection();
    Hafas.bind(this.main.Controller.TP.restoreTripMarker, this.main)();
    Hafas.bind(this.main.Controller.TP.updateGroupResults, this.main)(this.instance.data.results, this.instance.isRequestPending(), forceSelection);

    var tpOverviewResultContainer = Hafas('#HFS_TPOverviewResults');
    tpOverviewResultContainer.style.minHeight = '';

    Hafas.ps.pub('/GUI/results/resize', [{
      container: me.resultOverviewContainer,
      appcontext: me.appContext
    }]);
    Hafas.ps.pub('/app/events/resize');

    // Track
    Hafas.ps.pub('/tracking/event/tripplanner-overview-cluster-pressed', [{
      typ: 'event',
      key: 'tripplanner-overview-cluster-pressed',
      data: {type: id}
    }]);
    Hafas.ps.pub('/tracking/event/tripplanner-overview-result-pressed', [{
      typ: 'event',
      key: 'tripplanner-overview-result-pressed',
      data: {type: id}
    }]);

  },
  toggleClusterList: function (domElem) {
    var controller = this;
    if (controller.segConClusterMore) {
      // Reset more tab
      var clsListElem = Hafas('#HFS_SegConClusterMoreList');
      var oldListVisibility = Hafas.Util.gui.isVisible(clsListElem);
      var tpOverviewResultContainer = Hafas('#HFS_TPOverviewResults');

      Hafas.Util.gui.setVisibility(clsListElem, !oldListVisibility);
      // Sets a min height of #HFS_TPOverviewResults to get space when having no result but large cluster lists
      if (oldListVisibility === false) {
        // More cluster list was shown, set the min height (will be removed in the callback of SegmentedControl -> search for "tpOverviewResultContainer")
        tpOverviewResultContainer.style.minHeight = clsListElem.offsetHeight + "px";

        // Track that the more cluster was opened
        Hafas.ps.pub('/tracking/event/tripplanner-overview-cluster-more-opened', [{typ: 'event', key: 'tripplanner-overview-cluster-more-opened'}]);
      } else {
        tpOverviewResultContainer.style.minHeight = "";
      }

      var segConState = controller.segConClusterMore.getState();
      if (typeof segConState.focusIndex !== 'undefined') {
        controller.segConClusterMore.setFocusIndex(segConState.focusIndex);
      } else {
        controller.segConClusterMore.setFocusIndex(0);
      }
    }
  },
  showIVResultOverview: function (data, type) {
    var me = this;
    var targetContainer = Hafas('#HFS_TP_' + type + '_OverviewResults');

    if (Hafas.Modules.History)
      Hafas.Modules.History.addOrUpdateData("TP", "overviewIV", {
        data: data,
        type: type
      });
    data.type = type;
    data.headline = Hafas.Modules.i18n.get('TP.index.t_N_SectionType' + type);
    this.Controller.GUI.common.hidePageLoader();

    if (me.Controller.TP.instance.isGroupingUsed()) {
      var resultTplToUse = 'TP_TplOverviewIVCluster';
    } else {
      var resultTplToUse = 'TP_TplOverviewIV';
    }

    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ TP.showIVResultOverview +++ DEBUG Model +++', data)
    }

    var focusSelector = Hafas.Util.gui.getFocusElementSelector();

    Hafas.Modules.Render.render({
      file: 'tp.result.overview.html',
      target: targetContainer,
      template: 'TP_TplOverviewIV',
      model: data,
      global: {view: this.Controller.TP.currentView},
      callback: function () {
        Hafas.Util.gui.restoreFocus(focusSelector);
      }
    });

    if (!Hafas.Config.TP.unifiedPlanner.show) {
      Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'TP'}]);
    } else {
      // Im Fall, dass der Unified Planner genutzt wird muss das Formular hier wieder explizit eingeblendet werden, da es sein kann, dass
      // man per Drag & Drop aus den Details hier landet und sonst die Form nicht eingeblendet wird
      Hafas.ps.pub('/GUI/form/show', [{appcontext: 'TP'}]);
      Hafas.ps.pub('/options/gui/toggle', [{target: 'HFS_CustomerOptionsWrap', open: false, view: 'options'}]);
      Hafas.ps.pub('/GUI/tabNavigationHeading/hide', []); // Beim Unified Planner muss explizit die TabNavigationHeading auf der Overview ausgeblendet werden
      // Favoriten ausblenden, wenn Formular auf der Ergebnisseite zu sehen ist
      var $favoritesWrap = Hafas('#HFS_CustomerFavoritesWrap', false);
      Hafas.Util.gui.setVisibility($favoritesWrap, false);
      // Suchen Button ausblenden
      if (Hafas.Config.TP.unifiedPlanner.requestOnChange) {
        var tpSearchButton = Hafas("[data-button='TPSearchButton']");
        Hafas.Util.gui.setVisibility(tpSearchButton, false);
      }
    }

    Hafas.ps.pub('/GUI/results/resize', [{
      container: me.resultOverviewContainer,
      appcontext: me.appContext
    }]);
    Hafas.ps.pub('/app/events/resize');
  },

  /**
   * add and remove a connection from favorite list on the overview result
   * @param dep
   * @param arr
   * @param hash
   */
  toggleConnectionFavorite: function (depKey, arrKey, hash) {
    var dep = Hafas.Modules.Render.objectKeeper.get(depKey);
    var arr = Hafas.Modules.Render.objectKeeper.get(arrKey);
    var currentConnection;
    var favElement = Hafas('[data-favorite-marker="tp"]', false);
    var favoriteMarkerData = {
      currentHash: hash,
      query: { // query is necessary as it is used in some atoms (e.g. overviewField / favoriteMarker)
        dep: dep,
        arr: arr
      }
    };
    var announcement;

    if (Hafas.bind(this.Controller.TP.isConnectionFavorite, this)(dep.name, arr.name)) { // Explicitly name and not smartLocation.name for hash
      currentConnection = this.Controller.Favorites.instance.getConnectionByHash(hash, '');
      this.Controller.Favorites.instance.removeConnectionFav(hash);
      announcement = 'Favorites.t_N_removedConnectionFromFavorites';
      favoriteMarkerData.isFavorite = false;
      Hafas.ps.pub('/tracking/event/favorite-connection-unmarked', [{
        typ: 'event',
        key: 'favorite-connection-unmarked'
      }]);
    } else {
      currentConnection = this.Controller.Favorites.instance.getConnectionByHash(hash, 'History');
      this.Controller.Favorites.instance.addConnection(currentConnection);
      announcement = 'Favorites.t_N_addedConnectionToFavorites';
      favoriteMarkerData.isFavorite = true;
      Hafas.ps.pub('/tracking/event/favorite-connection-marked', [{typ: 'event', key: 'favorite-connection-marked'}]);
    }

    var focusSelector = Hafas.Util.gui.getFocusElementSelector();

    Hafas.Modules.Render.render({
      target: favElement,
      template: 'TP_AtomTplFieldConMarker',
      model: favoriteMarkerData
    }, Hafas.bind(function () {
      Hafas.Util.gui.restoreFocus(focusSelector);
      var i18nProps = {
        from: dep.name,
        to: arr.name
      };
      if (currentConnection.opt && currentConnection.opt.txt) {
        i18nProps.options = currentConnection.opt.txt;
      }
      Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get(announcement, i18nProps));
    }, this));
  },

  /**
   * check if a connection is stored as favorite
   * @param depLocName
   * @param arrLocName
   * @returns {boolean}
   */
  isConnectionFavorite: function (depLocName, arrLocName) {
    var isFavorite = false;
    // check if connection is favorite
    if (Hafas.Config.Switches.useFavorites) {
      var currentHash = Hafas.bind(this.Controller.TP.getCurrentConnectionHash, this)(depLocName, arrLocName);
      var isFavStored = this.Controller.Favorites.instance.isConnStored("", currentHash);
      isFavorite = isFavStored.connectionAlreadySet;
    }
    return isFavorite;
  },

  /**
   * Get the calculated hash for the current connection
   * @param depLocation
   * @param arrLocation
   */
  getCurrentConnectionHash: function (depLocationName, arrLocationName) {
    var currentConnStr = depLocationName + arrLocationName;
    if(Hafas.Config.Favorites.storeQueryOptions) {
      var optionText = this.Controller.TP.options.getOptionTexts().infoText;
      if(optionText != "") {
        currentConnStr += optionText;
      }
    }
    var currentConnHash = Hafas.Util.createHash.hex_md5(currentConnStr);
    return currentConnHash;
  },
  getConnectionByTypeAndIdx: function(data){
    var selectedGroup = null;
    var currConnection,
        results;
    if (this.Controller.TP.instance.isGroupingUsed() && !this.Controller.TP.instance.data.results.isReconstruction) {
      if (data.connectionType === 'heart') {
        selectedGroup = this.Controller.TP.groupFavMode + '_score';
      } else {
        selectedGroup = data.connectionType;
      }
      results = this.Controller.TP.instance.data.results.groups[selectedGroup];
      if (typeof data.subclusterGrpId !== 'undefined') {
        currConnection = results.subcluster[data.subclusterGrpId].connections[data.arrayIdx].resolvedConnection;
        currConnection.amount = results.subcluster[data.subclusterGrpId].connections.length;
        currConnection.subclusterGrpId = data.subclusterGrpId;
      } else {
        currConnection = results.connections[data.arrayIdx].resolvedConnection;
        currConnection.amount = results.connections.length;
        delete currConnection.subclusterGrpId;
      }
    } else {
      results = this.Controller.TP.instance.data.results.connectionResult;
      currConnection = this.Controller.TP.instance.data.results.renderConnections[data.arrayIdx];
      currConnection.amount = results.length;
    }
    return currConnection;
  },
  getConnectionResults: function(data){
    var results,selectedGroup;
    if (this.Controller.TP.instance.isGroupingUsed() && !this.Controller.TP.instance.data.results.isReconstruction) {
      if (data.connectionType == 'heart') {
        selectedGroup = this.Controller.TP.groupFavMode + '_score';
      } else {
        selectedGroup = data.connectionType;
      }
      if(data.subclusterGrpId !== undefined){
        results = this.Controller.TP.instance.data.results.groups[selectedGroup].subcluster[data.subclusterGrpId];
      }else {
        results = this.Controller.TP.instance.data.results.groups[selectedGroup];
      }
    } else {
      results = {
        connections: this.Controller.TP.instance.data.results.renderConnections
      };
    }
    return results;
  },
  toggleDetails: function (data) {
    if (typeof data.ev != 'undefined') {
      data.ev.preventDefault();
      data.ev.stopPropagation();
    }

    var loader = Hafas('#TP_ResultDetail [data-render-element="result_header"] [data-loader]', false);
    if (loader)  loader.remove();

    var me = this,
      selectedGroup,
      results,
      currConnection;

    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ TP.toggleDetails +++ DEBUG Model +++', currConnection);
    }

    if (Hafas.Config.UI.showTPResultsInOverview) {
      // If connection details are shown in overview, store expanded connections in history, so they can be restored when going back
      var expandedConnectionIds = Hafas.Modules.History.getCurrentData().additionalData?.data?.expandedConnectionIds || [];
      if (data.trigger.ariaExpanded === 'true') {
        // Connection is currently expanded and will be closed, thus remove from history state
        var connectionIdx = expandedConnectionIds.indexOf(data.trigger.id);
        if (connectionIdx > -1) {
          expandedConnectionIds.splice(connectionIdx, 1);
        }
      } else if (!expandedConnectionIds.includes(data.trigger.id)) { // avoid duplicates
        // Connection is currently closed and will be expanded, thus add to history state
        expandedConnectionIds.push(data.trigger.id);
      }
      Hafas.Modules.History.addAdditionalData('/tp/expandConnectionsByElementId', {expandedConnectionIds});
    }

    // Get current connection for usage in "renderConnectionDetails" function
    currConnection = Hafas.bind(this.Controller.TP.getConnectionByTypeAndIdx,this)(data);

    Hafas.bind(this.Controller.TP.renderConnectionDetails, this)(currConnection, data);

    //announce header text
    var actionbarTitle = Hafas(".lyr_atomActionbarTitle", true, Hafas("#TP_ResultDetail"));
    if (actionbarTitle.length > 0) {
      Hafas.Modules.a11y.Announce.assertive(actionbarTitle[0].innerText);
    }
    // focus first Element (Backbutton)
    Hafas.Util.gui.focusFirstElement("#TP_ResultDetail");

    if(Hafas.Config.TP.refreshDetailsOnDisplay && this.Controller.TP.detailAutoRefreshActive === undefined){
        this.Controller.TP.detailAutoRefreshActive = true;
        this.Controller.TP.details.refreshConnection.bind(this)({});
    }else{
        delete this.Controller.TP.detailAutoRefreshActive;
    }

    if (this.Controller.TP.focusSelector) {
      Hafas.Util.gui.restoreFocus(this.Controller.TP.focusSelector);
      this.Controller.TP.focusSelector = null; // avoid unintentionally restoring focus later on
    }
  },

  /**
   * Expand details for the given connections in connection overview.
   * @param {string[]} data.expandedConnectionIds - The HTML IDs of the connections to expand.
   */
  expandConnectionsByElementId: function (data) {
    if (Hafas.Config.UI.showTPResultsInOverview && data.expandedConnectionIds) {
      data.expandedConnectionIds.forEach(id => {
        var connectionElement = Hafas('#' + id);
        if (connectionElement && connectionElement.ariaExpanded !== 'true') {
          connectionElement.click();
        }
      });
    }
  },
  /**
   * Initializes a carousel with the provided data.
   *
   * @param {Array} data - An array of objects representing the content for the carousel.
   * @returns {void}
   *
   */
  initCarousel: function(data) {
    var me = this;

    // Connection Carousel am oberen Rand anlegen
    var pageOffset = 0;
    var centerOffset = 0;

    this.Controller.TP.connectionCarouselDetails = Hafas.Core.newType('HafasCarousel', {
      holder: 'HFS_TP_ConnectionDetailsCarousel',
      initialPaneIdx: data.arrayIdx,
      pageOffset: pageOffset,
      centerOffset: centerOffset,
      onchange: function(dataProvided){
        return function(dataCrsl) {
          var paneIdx = dataCrsl.paneIdx;
          var selectedConnData = {
            arrayIdx: paneIdx,
            connectionType: dataProvided.connectionType,
            subclusterGrpId: dataProvided.subclusterGrpId,
            isReconstruction: dataProvided.isReconstruction
          }
          me.Controller.TP.activeSelection = {
            arrayIdx: paneIdx,
            connType: dataProvided.connectionType
          };
          if (dataProvided.subclusterGrpId !== undefined) {
            // Wenn vorhanden, muss in der activeSelection auch immer die subclusterGrpId vermerkt werden
            me.Controller.TP.activeSelection.subclusterGrpId = dataProvided.subclusterGrpId;
          }
          var newConn = Hafas.bind(me.Controller.TP.getConnectionByTypeAndIdx,me)(selectedConnData);
          Hafas.bind(me.Controller.TP.renderConnectionDetailsContent,me)(newConn, selectedConnData);

        }
      }(data)
    }).initiate();
  },

  /**
   * Updates the content of an existing carousel used in the trip details.
   *
   * This function is responsible for refreshing the content or appearance of an
   * already initialized carousel.
   *
   * @returns {void}
   */
  updateCarousel: function() {
    // config to pass as params to get connection results
    var connectionParams = {
      connectionType: this.Controller.TP.activeSelection.connType,
      arrayIdx: this.Controller.TP.activeSelection.arrayIdx
    };
    // Current selection might be part of subcluster, then we need to set the subcluster Id as well
    if(this.Controller.TP.activeSelection.subclusterGrpId !== undefined) {
      connectionParams.subclusterGrpId = this.Controller.TP.activeSelection.subclusterGrpId;
    }
    var results = Hafas.bind(this.Controller.TP.getConnectionResults,this)(connectionParams);


    /* Determin correct arrayIdx by comparing the connections from the current result with the chksum
       from the current selected connection */
    var arrayIdx = this.Controller.TP.activeSelection.arrayIdx;
    for(var i = 0; i < results.connections.length; i++) {
      var connection = results.connections[i];
      if(connection.resolvedConnection.cksum === this.Controller.TP.selectedConnection.cksum) {
        arrayIdx = i;
      }
    }

    /* Before we initialize the new carousel, we need to clean up the old carousel instance
       so events will not be initialized multiple times
     */
    Hafas.bind(this.Controller.TP.details.connectionCarouselCleanup, this)();

    /* Render carousel template in the header of the detail view because atom needs to rerender new
       set of connections */
    Hafas.Modules.Render.render({
      file: 'tp.result_detail.html',
      target: 'HFS_TP_DetailCarouselWrap',
      template: 'TP_AtomTplConnectionDetailCarousel',
      model: {
        connections: results.connections
      },
      global: {view: this.Controller.TP.currentView}
    }, Hafas.bind(function () {
      // initialize parameter object to pass to init carousel function
      var connectionCarouselData = {
        connectionType: this.Controller.TP.activeSelection.connType,
        arrayIdx: arrayIdx
      }
      if(this.Controller.TP.activeSelection.subclusterGrpId !== undefined) {
        connectionCarouselData.subclusterGrpId = this.Controller.TP.activeSelection.subclusterGrpId
      }
      Hafas.bind(this.Controller.TP.initCarousel, this)(connectionCarouselData);
    },this));
  },

  // Strawberry 1.5: [FIX] Im Modus "showTPResultInOverview" gab es einen Fehler, der dazu f�hrte das die Results nicht mehr aufgeklappt worden sind, ist behoben, genau wie ein Fehler, der beim Umschalten auftrat, wenn keine Livemap in der WebApp angeschaltet war
  renderConnectionDetails: function (currConnection, data) {
    var me = this;
    var _targetTemplate = 'TP_ResultDetail';
    var results = Hafas.bind(this.Controller.TP.getConnectionResults,this)(data);

    if (Hafas.Config.UI.showTPResultsInOverview == false) {
      this.Controller.TP.currentView = "details";
    }

    Hafas.Modules.Render.render({
          file: 'tp.result_detail.html',
          target: _targetTemplate,
          template: 'TP_AtomTplConnectionDetailFrame',
          model: {
            showDetailViewHeader: true,
            connections: results.connections,
            currentConnection: currConnection
          },
          global: {view: this.Controller.TP.currentView}
        }, Hafas.bind(function (html) {

            Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
            Hafas.ps.pub('/GUI/results/details/show', [{}]);

    // Connection Carousel am oberen Rand anlegen
    var pageOffset = 0;
    var centerOffset = 0;

    this.Controller.TP.connectionCarouselDetails = Hafas.Core.newType('HafasCarousel', {
      holder: 'HFS_TP_ConnectionDetailsCarousel',
      initialPaneIdx: data.arrayIdx,
      pageOffset: pageOffset,
      centerOffset: centerOffset,
      onchange: function(dataProvided){
        return function(dataCrsl) {
          var paneIdx = dataCrsl.paneIdx;
          var selectedConnData = {
            arrayIdx: paneIdx,
            connectionType: dataProvided.connectionType,
            subclusterGrpId: dataProvided.subclusterGrpId,
            isReconstruction: dataProvided.isReconstruction
          }
          me.Controller.TP.activeSelection = {
            arrayIdx: paneIdx,
            connType: dataProvided.connectionType
          };
          if (dataProvided.subclusterGrpId !== undefined) {
            // Wenn vorhanden, muss in der activeSelection auch immer die subclusterGrpId vermerkt werden
            me.Controller.TP.activeSelection.subclusterGrpId = dataProvided.subclusterGrpId;
          }
          var newConn = Hafas.bind(me.Controller.TP.getConnectionByTypeAndIdx,me)(selectedConnData);
          Hafas.bind(me.Controller.TP.renderConnectionDetailsContent,me)(newConn, selectedConnData);

                  // Datum im Detail Header neu setzen:
                  var hfsDateTimeStamp = Hafas.Core.newType("hafasTime",{date: newConn.date});
                  Hafas('#HFS_TP_DetailConnDate',false).innerHTML = hfsDateTimeStamp.format('ddd') + ', ' +  hfsDateTimeStamp.format(Hafas.Config.dateOutputFormat);
          }
        }(data)
      }).initiate();

        // Focus back button
        Hafas.Util.gui.focusFirstElement('#HFS_DocumentDetailOverview');

    },this));

  },
  renderConnectionDetailsContent: function(currConnection,data){
    // Um durch die Verbindungen im Header pagen zu k?nnen, m?ssen die Indezes weitergereicht werden.
    // prev- und nextDisabled steuern die Darstellung und Funktion der Weiter/Zur?ck-Links

    // Die Pagerlinks duerfen aber nur verwendet werden, wenn die Details nicht unterhalb der Overview angezeigt
    // werden sollen. (Hafas.Config.TP.showTPResultsInOverview)


    if (typeof Hafas.Config.UI.showTPResultsInOverview != 'undefined' && Hafas.Config.UI.showTPResultsInOverview == true) {
      currConnection.disablePager = true;
    } else {
      currConnection.disablePager = false;
    }

    currConnection.arrayIdx = data.arrayIdx;
    currConnection.currentIdx = data.arrayIdx + 1;
    currConnection.nextIdx = data.arrayIdx + 1;
    currConnection.prevIdx = data.arrayIdx - 1;

    currConnection.prevDisabled = false;
    currConnection.nextDisabled = false;
    if (currConnection.prevIdx < 0) {
      currConnection.prevDisabled = true;
    }
    if (currConnection.nextIdx >= currConnection.amount) {
      currConnection.nextDisabled = true;
    }

    // show print icon if device can print
    currConnection.showPrintIcon = Hafas.Util.deviceCanPrint();
    currConnection.connectionType = data.connectionType;

    var _targetTemplate = 'TP_ResultDetail';

    // initial: bestimmt, ob der viewHeader der Details gerendert werden soll
    // default: wird gerendert
    currConnection.showDetailViewHeader = true;
    if (typeof Hafas.Config.UI.showTPResultsInOverview != 'undefined' && Hafas.Config.UI.showTPResultsInOverview == true) {
      // id vom Ergebnis-Detail-Container unter einer Ergebnis�bersicht
      _targetTemplate = "HFS_RES_" + currConnection.connectionType + "_" + currConnection.connectionIdx;
      // initial: bestimmt, ob der viewHeader der Details gerendert werden soll
      // wenn Hafas.Config.UI.showTPResultsInOverview == true wird der Header nicht gerendert
      currConnection.showDetailViewHeader = false;
    }else{
      if (Hafas.Modules.History)
        Hafas.Modules.History.addOrUpdateData("TP", "details", {
          currConnection: currConnection,
          data: data ,
          results: this.Controller.TP.instance.data.results
        });
    }

    var _targetTemplate = 'HFS_TP_DetailsConnectionContent';
    var me = this;
    if (typeof Hafas.Config.UI.showTPResultsInOverview != 'undefined' && Hafas.Config.UI.showTPResultsInOverview == true) {
      _targetTemplate = 'HFS_RES_' + data.connectionType + '_' + data.arrayIdx;
    }

    if (this.Controller.Map.instance) {
      this.Controller.Map.hideConnection();
      this.Controller.Map.showConnection(currConnection);
    }

    // Strawberry 1.5.0.3
    // Checken, ob f�r die Sections Turn-By-Turn Anweisungen hinzugekommen sind. Ggf. Aufklapppfeile hinzuf�gen /mroe
    for (var secIdx = 0; secIdx < currConnection.secL.length; secIdx++) {
      var currentSec = currConnection.secL[secIdx],
          nextSec = currConnection.secL[secIdx + 1],
          prevSec = currConnection.secL[secIdx - 1];
      currConnection.secL[secIdx].isExpandSectionResolved = this.Controller.TP.instance.isExpandSection(currentSec);

      if (typeof prevSec !== 'undefined') {
        if (prevSec.drawableLineResolved.res.type) {
          currConnection.secL[secIdx].drawableLineResolved.res.prevSec = {
            hideSec: prevSec.hideResolved,
            borderType: prevSec.drawableLineResolved.res.type,
            SecType: prevSec.type,
            current: {
              bgResolved: prevSec.drawableLineResolved.res.current.bgResolved,
              brdResolved: prevSec.drawableLineResolved.res.current.brdResolved
            }
          };
          if (prevSec.drawableLineResolved.res.light) {
            currConnection.secL[secIdx].drawableLineResolved.res.prevSec.light = {
              bgResolved: prevSec.drawableLineResolved.res.light.bgResolved,
              brdResolved: prevSec.drawableLineResolved.res.light.brdResolved
            };
          }
          if (prevSec.drawableLineResolved.res.dark) {
            currConnection.secL[secIdx].drawableLineResolved.res.prevSec.dark = {
              bgResolved: prevSec.drawableLineResolved.res.dark.bgResolved,
              brdResolved: prevSec.drawableLineResolved.res.dark.brdResolved
            };
          }
        }
      }
      if (typeof nextSec !== 'undefined') {
        if (nextSec.drawableLineResolved.res.type) {
          currConnection.secL[secIdx].drawableLineResolved.res.nextSec = {
            hideSec: nextSec.hideResolved,
            borderType: nextSec.drawableLineResolved.res.type,
            SecType: nextSec.type,
            current: {
              bgResolved: nextSec.drawableLineResolved.res.current.bgResolved,
              brdResolved: nextSec.drawableLineResolved.res.current.brdResolved
            }
          };
          if (nextSec.drawableLineResolved.res.light) {
            currConnection.secL[secIdx].drawableLineResolved.res.nextSec.light = {
              bgResolved: nextSec.drawableLineResolved.res.light.bgResolved,
              brdResolved: nextSec.drawableLineResolved.res.light.brdResolved
            };
          }
          if (nextSec.drawableLineResolved.res.dark) {
            currConnection.secL[secIdx].drawableLineResolved.res.nextSec.dark = {
              bgResolved: nextSec.drawableLineResolved.res.dark.bgResolved,
              brdResolved: nextSec.drawableLineResolved.res.dark.brdResolved
            };
          }
        }
      }
    }

    // Prüfen ob weitere aufklappbare Details in der Detailansicht benötigt werden
    for (var s = 0; s < currConnection.secL.length; s++) {
      var cSec = currConnection.secL[s];
      cSec.showFurtherDetailsResolved = (cSec.type == 'JNY' || (typeof cSec.childSecL != 'undefined' && cSec.childSecL.length > 0) || cSec.showElevationBtnResolved);
    }

    Hafas.Modules.Render.render({
      file: 'tp.result_detail.html',
      target: _targetTemplate,
      template: 'TP_AtomTplConnectionDetail',
      model: currConnection,
      global: {view: this.Controller.TP.currentView}
    }, function (html) {
      var _details = Hafas('#' + _targetTemplate, false);

      if (me.Controller.TP.highlightAlarmElements === true) {
        // Highlight specific elements if we came from Push via "Add trip alarm"
        Hafas.ps.pub('/GUI/common/highlightingInput',[{type: 'element', element: Hafas('.lyr_tpDetailsPushActionBtn i', false), className: 'js_highLightingGlowLarge', keepClass: true }]);
        me.Controller.TP.highlightAlarmElements = false; // Deactivate highlight mode after showing alarm button highlighting
      }

      // remove all empty lyr_tpMoreDetailRow
      var moreDetailRows = _details.querySelectorAll('.lyr_tpMoreDetailRow');

      if (moreDetailRows.length > 0) {
        for (var i = 0; i < moreDetailRows.length; i++) {
          var el = moreDetailRows[i];
          var content = el.innerText;
          if (content.trim().length === 0) {
            //el.remove();
            el.parentNode.removeChild(el);
          }
        }
      }
      // Track
      Hafas.ps.pub('/tracking/screen/connection-details', [{typ: 'screen', key: 'connection-details'}]);
      Hafas.ps.pub('/tracking/screen/tripplanner-details', [{typ: 'screen', key: 'tripplanner-details'}]);

      // toggle state
      // if user clicks item twice, ONLY the DetailContainer have to vanish
      try {
        if (data.trigger.parentNode && data.trigger.parentNode.className.match('js_overviewItemActive')) {
          if (data.trigger.parentNode.className.match('js_overviewItemActive')) {
            data.trigger.parentNode.className = data.trigger.parentNode.className.replace(' js_overviewItemActive', '');
            // var innerDetails                  = Hafas('#' + me.resultDetailContainer + ' [data-contid="' + me.appContext + '"]', false);
            // innerDetails.innerHTML            = '';
          } else {
            var activeObj = {
              arrayIdx: data.arrayIdx,
              connType: data.connectionType
            };
            if (data.subclusterGrpId !== undefined) {
              activeObj.subclusterGrpId = data.subclusterGrpId;
            }
            // setActiveClass
            Hafas.ps.pub('/GUI/results/overview/removeActive', [activeObj]);
            Hafas.ps.pub('/GUI/results/overview/setActive', [activeObj]);
          }
        } else {
          // setActiveClass
          var activeObj = {
            arrayIdx: data.arrayIdx,
            connType: data.connectionType
          };
          if (data.subclusterGrpId !== undefined) {
            activeObj.subclusterGrpId = data.subclusterGrpId;
          }
          Hafas.ps.pub('/GUI/results/overview/removeActive', [activeObj]);
          Hafas.ps.pub('/GUI/results/overview/setActive', [activeObj]);
        }
      } catch (e) {
        // einfach ignorieren
      }

      if (typeof Hafas.Config.UI.showTPResultsInOverview != 'undefined' && Hafas.Config.UI.showTPResultsInOverview === true) {
        if(data.isReconstruction === true) {
          _details.setAttribute('aria-hidden', 'false');
          _details.removeAttribute('hidden');
        }
      } else {
        // Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        // Hafas.ps.pub('/GUI/results/details/show', [{}]);
        Hafas.ps.pub('/app/updateBanner', ['tpDetails', me.Controller.TP.getLocationsFromConnection(currConnection)]);
        Hafas.ps.pub('/app/events/resize');
        Hafas.ps.pub('/app/events/resize', [{
          appcontext: me.appContext,
          method: 'tp/toggleDetails'
        }]);
      }
      // verkehrstagekalender?
      if (Hafas.Config.TP.serviceDays.show && Hafas.Config.TP.serviceDays.showAsCalendar && (typeof currConnection.sDays !== 'undefined') && (typeof currConnection.sDays.sDaysB !== 'undefined')) {
        var sDTPConfig = {
          holder: 'HFS_ServiceDaysCalendar_TP' + currConnection.connectionIdx + '_Calendar',
          id: 'TPServiceDays_' + currConnection.connectionIdx,
          config: {
            useDepArrSwitch: false,
            useTimePicker: false,
            useNowMode: false,
            isModal: false,
            showFullscreenInMobile: false,
            readOnly: true,
            a11yHidden: true,
            markedDays: currConnection.sDays.sDaysB
          }
        };

        Hafas.Core.newType('hafasTimeDatePicker', sDTPConfig);
      }

      if (Hafas.Config.TP.partialSearch.setChangeTime === false) {
        // PartialSearch Hafas Context Menu
        Hafas('.lyr_partialSearchLink', true).forEach(function (elem) {
          var newOptions = {
            trigger: ['clickLeft'],
            stickTo: 'bottom|center',
            zIndex: 2000,
            marginY: 20,
            className: 'lyr_topArrowContextMenu',
            content: [
              {
                text: Hafas.Modules.i18n.get('TP.results.partialSearch.t_N_arriveEarlier')
              },
              {
                text: Hafas.Modules.i18n.get('TP.results.partialSearch.t_N_departLater')
              }
            ]
          };
          newOptions.content[0].event = function (contextMenu) {
            Hafas.ps.pub('/tp/details/partialSearchRequest', [{
              'connectionType': currConnection.connectionType,
              'connIdx': currConnection.connectionIdx,
              'secIdx': contextMenu.parent.dataset.secidx,
              'partialSearchEarlier': true
            }]);
          };
          newOptions.content[1].event = function (contextMenu) {
            Hafas.ps.pub('/tp/details/partialSearchRequest', [{
              'connectionType': currConnection.connectionType,
              'connIdx': currConnection.connectionIdx,
              'secIdx': contextMenu.parent.dataset.secidx,
              'partialSearchEarlier': false
            }]);
          };
          Hafas.Core.newType('HafasContextMenu', newOptions).addTo(elem);
        });
      }

      // Open expanded section
      if(typeof me.Controller.TP.currentExpandId === 'object' && typeof me.Controller.TP.currentExpandId.expandId === 'number'  && typeof me.Controller.TP.currentExpandId.arrayIdx === 'number') {
        // Only expand section, if the section in this connection was expanded
        if(me.Controller.TP.currentExpandId.arrayIdx === data.arrayIdx) {
          var expandedSectionId = me.Controller.TP.currentExpandId.expandId;
          var expandSectionButton = Hafas('[data-section-details="' + expandedSectionId + '_' + data.arrayIdx + '"]');
          if (expandSectionButton) {
            var section = currConnection.secL[expandedSectionId];
            Hafas.ps.pub('/tp/details/expand', [{
              trigger: expandSectionButton,
              expandId: expandedSectionId,
              parentId: data.arrayIdx,
              type: section.type
            }]);
            // active just once
            delete me.Controller.TP.currentExpandId;
          }
        }
      }

    });

    // Ende Render Callback Details

    // // For the rendered connection collect the polyline coordinates and set them in the TRM
    Hafas.ps.pub('/trm/prepareJourneyPassesThrough', [currConnection]);

    this.Controller.TP.selectedConnection = currConnection;

    // close all open tabs
    Hafas.ps.pub('/GUI/tabs/closeAll');
    Hafas.Util.gui.resetScrollTop();
    Hafas.bind(this.Controller.TP.toggleElevationLevel, this)();
  },
  overview: {
    refreshConnectionOverview: function (data) {
      this.Controller.TP.focusSelector = Hafas.Util.gui.getFocusElementSelector(); // save refresh button selector to restore focus to

      if (data.ev) {
        data.ev.preventDefault();
        data.ev.stopPropagation();
      }
      Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get("a11y.announce.t_N_areUpdating", {elem: Hafas.Modules.i18n.get("TP.index.t_N_Connections")}));
      // Add Loader
      var loaderHtml = Hafas.Modules.Render.renderTemplate("Common_AtomTplLoaderBarInfinite", {id: "HFS_TP_OverviewLoader"});
      if (Hafas.Config.TP.unifiedPlanner.show) {
        var insertID = '#HFS_FormTripSearch';
      } else {
        var insertID = '#TP_ResultOverview';
      }
      Hafas(insertID).insertAdjacentHTML('afterbegin', loaderHtml);
      Hafas('#HFS_TP_ResultOverviewBtn').disabled = true;
      this.Controller.TP.postForm.bind(this, {form: Hafas('#HFS_FormTripSearch')})();
    },
    removeInfiniteLoader: function () {
      var overviewLoader = document.getElementById('HFS_TP_OverviewLoader');
      if (overviewLoader) {
        overviewLoader.parentNode.parentNode.removeChild(overviewLoader.parentNode);
        Hafas('#HFS_TP_ResultOverviewBtn').disabled = false;
      }
    }
  },
  details: {
    connectionCarouselCleanup: function(){
      if(this.Controller.TP.connectionCarouselDetails != null){
        this.Controller.TP.connectionCarouselDetails.destroy();
        this.Controller.TP.connectionCarouselDetails = null;
      }
    },

    refresh: function (resolvedPolyData, completeData) {
      if (this.Controller.TP.currentView == 'details' && this.Controller.TP.selectedConnection != null) {
        if (this.Controller.TP.selectedConnection.cksum == completeData.connectionRef.connectionData.cksum) {
          Hafas.bind(this.Controller.TP.renderConnectionDetailsContent, this)(this.Controller.TP.selectedConnection, {
            connectionType: this.Controller.TP.activeSelection.connType,
            arrayIdx: this.Controller.TP.activeSelection.arrayIdx
          });
        }
      }
    },
    refreshConnection: function (data) {
      this.Controller.TP.focusSelector = Hafas.Util.gui.getFocusElementSelector(); // save refresh button selector to restore focus to

      if (data.ev) {
        data.ev.preventDefault();
        data.ev.stopPropagation();
      }
      Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get("a11y.announce.t_N_areUpdating", {elem: Hafas.Modules.i18n.get("common.label.t_N_ConnectionDetails")}));
      // Add Loader
      var loaderHtml = Hafas.Modules.Render.renderTemplate("Common_AtomTplLoaderBarInfinite");
      Hafas('#TP_ResultDetail [data-render-element="result_header"]').insertAdjacentHTML('afterbegin', loaderHtml);
      Hafas('#HFS_TPDetailRefreshBtn').disabled = true;

      var currentConnection = this.Controller.TP.selectedConnection;
      var refreshData = {
        'connBitmask': currentConnection.connectionType
      };

      if (typeof currentConnection.connectionIdx !== 'undefined') {
        refreshData['connIdx'] = currentConnection.connectionIdx;
      } else if (typeof currentConnection.arrayIdx !== 'undefined') {
        refreshData['connIdx'] = currentConnection.arrayIdx;
      }
      if (currentConnection.subclusterGrpId) {
        refreshData['subclusterGrpId'] = this.Controller.TP.activeSelection.subclusterGrpId;
      }

      this.Controller.TP.instance.refreshConnection(refreshData);
    },
    expandSection: function (data) {
      if (data.ev) {
        data.ev.preventDefault();
        data.ev.stopPropagation();
      }
      var _me = this,
        $detailResultWrapPos = null;
      if (typeof Hafas.Config.UI.showTPResultsInOverview != 'undefined' && Hafas.Config.UI.showTPResultsInOverview == true) {
        $detailResultWrapPos = Hafas('#' + _me.resultOverviewContainer + ' [data-contid="' + _me.appContext + '"] [data-render-element="result_container"]', false).scrollTop;
      } else {
        $detailResultWrapPos = Hafas('#' + _me.resultDetailContainer + ' [data-contid="' + _me.appContext + '"] [data-render-element="result_container"]', false).scrollTop;
      }

      // Neue Toggle-Funktion mit ARIA-Attributen (Barrierefreiheit)
      var currentVisibilityStatus = Hafas.ps.pub('/GUI/common/atomToggleContainer', [data]);

      // Dynamisch den Tooltip-Text des Buttons verändern
      var tooltipText = Hafas('.lyr_tooltip .lyr_tooltipText', true, data.trigger)[0];
      if (typeof currentVisibilityStatus !== "undefined" && currentVisibilityStatus === true) {
        tooltipText.innerHTML = (typeof data.type != 'undefined' && data.type != 'JNY') ? Hafas.Modules.i18n.get('common.label.t_N_HideGISDescription') : Hafas.Modules.i18n.get('common.label.t_N_HideIntermediateStops');
      } else {
        tooltipText.innerHTML = (typeof data.type != 'undefined' && data.type != 'JNY') ? Hafas.Modules.i18n.get('common.label.t_N_ShowGISDescription') : Hafas.Modules.i18n.get('common.label.t_N_ShowIntermediateStops');
      }

      if(!currentVisibilityStatus) Hafas.ps.pub('/tp/removeHighlightSegment',[]);

      var $routeDesc = Hafas('[data-routedesc-id="' + data.expandId + '"]', true);
      var currentSection = this.Controller.Map.connection.connectionData.secL[parseInt(data.expandId)];

      if (currentVisibilityStatus) {
        this.Controller.TP.currentExpandId = {'expandId': data.expandId, 'arrayIdx': parseInt(data.parentId)};
      } else {
        delete this.Controller.TP.currentExpandId;
      }

      $routeDesc.forEach(Hafas.bind(function (el) {
        if (typeof currentSection.gis.segL != "undefined") {

          var segL = currentSection.gis.segL;
          // ggf. aus m noch km machen
          segL.forEach(function (segment) {
            if (segment.dist !== undefined) {
              var hciDistance = Hafas.Util.getDistanceInUnit(segment.dist, Hafas.Config.Switches.lengthUnit);
              segment.unitDistanceResolved = hciDistance.unit;
              segment.unitDistanceLongResolved = hciDistance.unitLong;
              segment.distResolved = hciDistance.dist;
            }
            if (!segment.drawableLineResolved && currentSection.drawableLineResolved) {
              segment.drawableLineResolved = currentSection.drawableLineResolved;
            }
          });


          Hafas.Modules.Render.render({
            file: 'tp.result.detail.html',
            target: el,
            template: 'TP_AtomTplRouteDescription',
            model: {
              segL: segL,
              secIdx: parseInt(data.expandId)
            }
          });
        }
      }, this));
      Hafas.ps.pub('/app/events/resize', [{
        keepOverviewScrollPos: true,
        scrollDetailPos: $detailResultWrapPos,
        expandId: data.expandId,
        method: '/tp/details/expand'
      }]);
    },
    showDetailsMap: function (opts) {
      var $detailsHeader = Hafas('#TP_ResultDetail .lyr_atomActionbarWrapper', false);
      if (typeof Hafas.Config.UI.showTPResultsInOverview != 'undefined' && Hafas.Config.UI.showTPResultsInOverview == true) {
        $detailsHeader = Hafas('#TP_ResultOverview .lyr_atomActionbarWrapper', false);
      }
      $detailsHeader.addClassName("js_mapMode");

      Hafas.ps.pub('/map/openMapViewerForDetails');
    },
    hideDetailsMap: function (opts) {
      var $detailsHeader = Hafas('#TP_ResultDetail .lyr_atomActionbarWrapper', false);
      if ($detailsHeader) {
        $detailsHeader.removeClassName("js_mapMode");
        Hafas.ps.pub('/map/closeMapViewer');
      }
    },
    selectLocation: function (locKey, opts) {
      var loc = Hafas.Modules.Render.objectKeeper.get(locKey);
      var selectLocationAction;
      if (Hafas.Util.getLayoutClass() === 'small') {
        selectLocationAction = Hafas.Config.TP.selectLocationActionMobile;
      } else {
        selectLocationAction = Hafas.Config.TP.selectLocationActionDesktop;
      }
      if (loc.type === "S") {
        // Check if SQ is available, otherwise use MoveMap as a fallback
        if (this.Controller.SQ === undefined || this.Controller.SQ.instance === undefined){
          selectLocationAction = 'MoveMap';
        }
        if (selectLocationAction === "SwitchToSQInfo" && Hafas.Config.SQ && Hafas.Config.SQ.useInfo !== true) {
          // Fallback to SQ board if it should be SQ info, but SQ info is not available
          selectLocationAction = "SwitchToSQBoard";
        }
        // Wenn ins Stboard gesprungen wird, werden als Options-Aussprungsparameter noch die Uhrzeit und das Datum ergänzt
        if(opts !== undefined && selectLocationAction === 'SwitchToSQBoard' || selectLocationAction === 'SwitchToSQInfo'){
            var section = this.Controller.TP.selectedConnection.secL[opts.secIdx];
            if(opts.type !== undefined && opts.type === 'arr'){
              var time = section[opts.type].aTimeS;
            }else if(opts.type !== undefined && opts.type === 'dep'){
              var time = section[opts.type].dTimeS;
            }
            opts.time = time;
            opts.date = this.Controller.TP.selectedConnection.date;
        }
        switch (selectLocationAction) {
          case "SwitchToSQBoard":
            Hafas.ps.pub('/sq/searchFromOtherContext', [locKey, "dep", opts]);
            break;
          case "SwitchToSQInfo":
            Hafas.ps.pub('/sq/searchFromOtherContext', [locKey, "info", opts]);
            break;
          case "MoveMap":
            Hafas.ps.pub('/tp/centerLocationOnMap', [opts]);
            break;
        }
      } else
        Hafas.ps.pub('/tp/centerLocationOnMap', [opts]);
    },
    selectSection: function (data) {

      switch (Hafas.Config.TP.selectLineAction) {
        case "MoveMap":
          Hafas.ps.pub('/tp/centerSectionOnMap', [data]);
          break;
        case "SwitchToTQ":
          Hafas.ps.pub('/tq/showTrainroute', [data]);
          break;
      }
    },
    openPartialSearchOverlay: function (data) {
      if (Hafas.Config.TP.partialSearch.setChangeTime === true) {
        var _me = this;
        var model = {};
        _me.Controller.TP.partialSearch = _me.Controller.TP.partialSearch || {};
        _me.Controller.TP.partialSearch.secIdx = data.elem.dataset.secidx;
        _me.Controller.TP.partialSearch.overlay = Hafas.Core.newType("HafasOverlay", {
          app: _me,
          anchorElement: data.elem,
          anchoredOverlay: 'DESKTOP',
          title: Hafas.Modules.i18n.get('TP.results.partialSearch.t_N_adaptChange'),
          outputHTML: Hafas.Modules.Render.renderTemplate("TP_AtomTplPartialSearchOverlay", model),
          closeButton: false,
          cssClass: 'hfs_partialSearchOverlay',
          onClose: function () {
            _me.Controller.TP.partialSearch.selectBox.destroy();
          },
          callback: function (html, err) {
            if (err) console.error(err);
            _me.Controller.TP.partialSearch.selectBox = Hafas.Core.newType('HafasSelectBox', {
              holder: 'HFS_PartialSearchSelectBoxHolder'
            }).initiate();
          }
        });
      }
    },
    cancelPartialSearchOverlay: function () {
      var _me = this;
      _me.Controller.TP.partialSearch.overlay.close();
    },
    confirmPartialSearchOverlay: function () {
      var currConnection = this.Controller.TP.selectedConnection;
      var _me = this;
      _me.Controller.TP.partialSearch = _me.Controller.TP.partialSearch || {};
      var selectBoxData = _me.Controller.TP.partialSearch.selectBox.getState();
      var data = {
        'connectionType': currConnection.connectionType,
        'connIdx': currConnection.connectionIdx,
        'secIdx': _me.Controller.TP.partialSearch.secIdx,
        'partialSearchEarlier': !!_me.Controller.TP.partialSearch.earlier,
        'changeTime': selectBoxData.value
      };
      _me.Controller.TP.partialSearch.overlay.close();
      Hafas.bind(_me.Controller.TP.details.partialSearchRequest, _me)(data)
    },
    partialSearchEarlier: function (data) {
      var _me = this;
      _me.Controller.TP.partialSearch = _me.Controller.TP.partialSearch || {};
      _me.Controller.TP.partialSearch.earlier = data;
    },
    partialSearchRequest: function (data) {
      data.connType = this.Controller.TP.activeSelection.connType;
      this.Controller.TP.instance.searchPartialSearch(data);
    }
  },
  /**
   * Redraw the selected connection, e.g. when changing the color scheme.
   */
  redrawSelectedConnection: function () {
    var currConnection;
    if (this.Controller.TP.currentView === 'overview') {
      var data = {connectionType: this.Controller.TP.activeSelection.connType, arrayIdx: this.Controller.TP.activeSelection.arrayIdx};
      currConnection = Hafas.bind(this.Controller.TP.getConnectionByTypeAndIdx, this)(data);
    } else if (this.Controller.TP.currentView === 'details') {
      currConnection = this.Controller.TP.selectedConnection;
    }
    if (currConnection && this.Controller.Map.instance) {
      this.Controller.Map.hideConnection();
      this.Controller.Map.showConnection(currConnection);
    }
  },
  /* drag&drop-pins initialisieren */
  initDragDrop: function () {

    var me = this;

    if (me.appContext == 'TP') {
      // karte als droppable initialisieren
      var droppableMapDiv = Hafas('#' + me.mapId);

      droppableMapDiv.addEventListener('dragenter', function (e) {
        if (e.preventDefault) {
          e.preventDefault();
        }
      });

      droppableMapDiv.addEventListener('dragover', function (e) {
        if (e.preventDefault) {
          e.preventDefault();
        }
      });

      droppableMapDiv.addEventListener('drop', function (e) {
        if ((e.dataTransfer.getData('text') == 'dep' || e.dataTransfer.getData('text') == 'arr')) {
          Hafas.ps.pub('/ui/markerDroppedFromUI/', [{
            x: e.clientX,
            y: e.clientY
          }, e.dataTransfer.getData('text')]);
        }

        if (e.preventDefault) {
          e.preventDefault();
        }
      });

      var draggables = Hafas('[draggable="true"]', true, Hafas(me.formContainer));
      draggables.forEach(function (draggable, index) {

        draggable.style.cursor = 'move';

        draggable.addEventListener('dragstart', function (e) {
          e.dataTransfer.effectAllowed = 'move';

          e.dataTransfer.setData('text', this.getAttribute("data-draggable-type"));

          window.setTimeout(Hafas.bind(function () {
            this.style.opacity = '0';
          }, this), 100);
        }, false);

        draggable.addEventListener('dragend', function (e) {
          this.style.opacity = '1';
          if (e.stopPropagation) {
            e.stopPropagation();
          }
        }, false);
      });

    }

  },
  // H�henprofil
  showElevationLevel: function (secIdx, clickAction) {
    Hafas.bind(this.Controller.TP.hideElevationLevel, this)();
    var layoutClass = Hafas.bind(this.Controller.GUI.common.getLayoutClass, this)();
    if (clickAction && layoutClass == 'small') {
      Hafas.ps.pub('/GUI/map/show', [{
        trigger: this,
        ev: {},
        template: 'Common_MapPageHeaderConnection'
      }]);
    }

    if (typeof this.Controller.Map.connection.connectionData.secL[secIdx] != 'undefined') {
      var section = this.Controller.Map.connection.connectionData.secL[secIdx];
      if ((typeof section.gis != 'undefined') && (typeof section.gis.polyG != 'undefined' || typeof section.gis.poly != 'undefined')) {
        var model = {
          posAlt: section.gis.posAlt / 100,
          negAlt: section.gis.negAlt / 100,
          minAlt: section.gis.minAlt / 100,
          maxAlt: section.gis.maxAlt / 100
        };
        var elevationLevelDiv = document.createElement("div");
        elevationLevelDiv.className = "hfs_toolboxItem";

        // Hinweis zum H�henprofil anzeigen, wenn noch nicht explizit weggeglickt wurde
        var storage = Hafas.Core.newType("hafasStorage");
        var hideHint = storage.get('elevationLevelHint_' + Hafas.Config.Storage.id);
        model.hideHint = hideHint;

        Hafas.Modules.Render.render({
            file: 'common.map.html',
            target: elevationLevelDiv,
            template: 'Common_Map_ElevationLevel_Caption',
            model: model
          }, Hafas.bind(function (html) {
            elevationLevelDiv.innerHTML = html;
            this.Controller.Map.instance.addToToolbox(elevationLevelDiv, {
              id: 'elevationLevelGraph',
              index: 0,
              callback: Hafas.bind(function () {
                Hafas.ps.pub('/tp/hideElevationLevel', [false]);
              }, this)
            });
            var container = Hafas('[data-map-container="elevationLevelContainer"]', false);
            var elevationLevelParams = {
              colorScheme: Hafas.Config.TP.elevationLevel.colorScheme,
              colorSchemeBg: Hafas.Config.TP.elevationLevel.backgroundColor,
              colorSchemeFg: Hafas.Config.TP.elevationLevel.strokeColor,
              colorSchemeHighlight: Hafas.Config.TP.elevationLevel.highlightColor,
              container: container,
              section: section,
              height: 140,
              width: Hafas('.lyr_mapFlyout').offsetWidth, // dynamisch ermitteln
              selectableRoute: true,
              map: this.Controller.Map.instance
            };
            this.Controller.TP.elevationLevel = Hafas.Core.newType("hafasElevationLevel", elevationLevelParams);
          }, this)
        );
      }
    }
  },
  hideElevationLevel: function (hideMapSelection) {
    if (typeof this.Controller.TP.elevationLevel != 'undefined' && this.Controller.TP.elevationLevel != null) {
      this.Controller.TP.elevationLevel.closeProfile();
    }
    if (this.Controller.Map.instance != null) {
      if (typeof hideMapSelection == 'undefined' || hideMapSelection == true) {
        this.Controller.Map.instance.removeToolboxItem('mapSelection', 'id');
      }
      this.Controller.Map.instance.removeToolboxItem('elevationLevelGraph', 'id');
    }
  },
  hideElevationHint: function () {
    var storage = Hafas.Core.newType("hafasStorage");
    var dontShowAgain = Hafas('[data-elevation-level= "dontShowAgain"]', false);
    if (dontShowAgain && dontShowAgain.checked){
      if(Hafas.Util.isCookieTypeActive('functional') == true) {
        storage.set('elevationLevelHint_' + Hafas.Config.Storage.id, true);
      }else{
        Hafas.ps.pub('/GUI/common/showCookieSettingsHint', [['functional']]);
        return;
      }
    }
    var elLevelHint = Hafas('[data-elevation-level="hint"]', false);
    if (elLevelHint) {
      Hafas.Util.gui.setVisibility(elLevelHint, false);
    }
  },
  toggleElevationLevel: function (data) {
    Hafas.ps.pub('/tp/hideElevationLevel'); // Altes ausbelnden

    if (Hafas.Config.TP.elevationLevel.use == true && Hafas.Config.TP.elevationLevel.showInitially == true) {
      if (this.Controller.TP.selectedConnection) {
        var resolvedConnection = this.Controller.TP.selectedConnection;
        if (resolvedConnection.secL.length == 1
          && Hafas.Config.TP.elevationLevel.sectionTypes.indexOf(resolvedConnection.secL[0].type) != -1
          && resolvedConnection.secL[0].showElevationBtnResolved == true) {
          Hafas.bind(this.Controller.TP.showElevationLevel, this)(0, false);
        }
      }
    }
  },
  openTariffDetails: function (data) {
    var selectedConnection = this.Controller.TP.selectedConnection;
    switch (data.content) {
      case "TariffInfoBoxGroupScreen":
        Hafas.bind(this.Controller.TP.renderTariffInfoBoxGroups, this)(selectedConnection);
        break;
      case "TariffOverviewScreen":
        Hafas.bind(this.Controller.TP.renderTariffOverview, this)(selectedConnection);
        break;
    }
    if ((data.type === 'URL_EXT') || (data.type === 'URL_UNIVERSAL')) {
      if (!Hafas.Config.Switches.useTerminalMode) {
        Hafas.ps.pub('/common/openExternalLink', [data.content]);
      } else {
        Hafas.ps.pub('/GUI/showQrCodeOverlay', [{url: data.content, title: data.textS, description: data.text, trigger: data.trigger, anchor: data.anchor}]);
      }
    }
  },
  renderTariffOverview: function (data) {
    var me = this;
    var _targetTemplate = 'TP_ResultDetail';

    var selectedConnection = this.Controller.TP.selectedConnection;

    var tariffResult = selectedConnection.trfRes;

    if (typeof tariffResult.tariffInfoBoxGroupL == 'undefined' || data.boxGroupIdx === undefined) {
      Hafas.bind(this.Controller.TP.renderTariffOverviewFareSets, this)(selectedConnection);
      return;
    }

    var tariffInfoBoxGroup = tariffResult.tariffInfoBoxGroupL[data.boxGroupIdx];
    var tariffInfoBox = tariffInfoBoxGroup.tariffInfoBoxL[data.boxGroupElemIdx];

    var filterFound = false;
    if (typeof tariffInfoBox.fareSetListResolved != 'undefined') {
      for (var s = 0; s < tariffInfoBox.fareSetListResolved.length; s++) {
        var tmpFS = tariffInfoBox.fareSetListResolved[s];
        // Erstes Fareset soll im jeweiligen Context aufgeklappt sein
        if ((s == 0 && typeof Hafas.Config.Tariffs.fareSetDisplay[this.Controller.TP.currentView] != 'undefined' && Hafas.Config.Tariffs.fareSetDisplay[this.Controller.TP.currentView] == 'SHOWFIRST')
          || (typeof Hafas.Config.Tariffs.fareSetDisplay[this.Controller.TP.currentView] != 'undefined' && Hafas.Config.Tariffs.fareSetDisplay[this.Controller.TP.currentView] == 'SHOWALL')
        ) {
          tmpFS.showInitially = true;
        }
        for (var fl = 0; fl < tmpFS.fareL.length; fl++) {
          var tmpF = tmpFS.fareL[fl];
          tmpF.filterPropsResolved = [];
          if (typeof tmpF.filterProps != 'undefined') {
            filterFound = true;
            for (var p in tmpF.filterProps) {
              tmpF.filterPropsResolved.push({
                key: p,
                values: tmpF.filterProps[p].join(" ")
              });
            }
          }
        }
      }

      var currentFilter = Hafas.Util.Tariffs.getDefaultTariffFilter(this.Controller.TP.tariffFilter);

      var model = {
        viewHeader: {
          details: Hafas.Modules.i18n.get('common.label.t_N_DetailsTariff')
        },
        showDetailViewHeader: true,
        tariffInfoBox: tariffInfoBox,
        trfRes: tariffResult,
        filter: currentFilter,
        showFilter: filterFound,
        ctx: 'tp'
      };

      // We got to save both, the function parameter and the selected connection in order to restore it via history later
      Hafas.Modules.History.addOrUpdateData("TP", "tariffOverview", {functionParams: data, selectedConnection: selectedConnection});

      Hafas.Modules.Render.render({
        file: 'tp.result_detail.html',
        target: _targetTemplate,
        template: 'TP_TplDetailTariffOverviewScreen',
        model: model
      }, function (html) {
        Hafas.Util.gui.resetScrollTop();

        if (filterFound) {
          for (var c = 0; c < currentFilter.length; c++) {
            if (currentFilter[c].type == 'select') {
              var tmpSelectBox = Hafas.Core.newType('HafasSelectBox', {
                holder: 'HFS_TariffFilterList_' + currentFilter[c].id + '_Holder', callback: function (tmpId) {
                  return function (data) {
                    Hafas.ps.pub('/tp/updateTariffFilter', [{
                      key: tmpId,
                      value: data.value
                    }]);
                  }
                }(currentFilter[c].id)
              });
              tmpSelectBox.initiate();
              me.Controller.TP.tariffSelectBoxes.push(tmpSelectBox);
            }
          }

          Hafas.bind(me.Controller.TP.updateTariffFilterResults, me)();
        }

        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        Hafas.ps.pub('/GUI/results/details/show', [{}]);

        Hafas.ps.pub('/app/events/resize', []);
      });
      //announce header text
      var actionbarTitle = Hafas(".lyr_atomActionbarTitle", false, Hafas("#HFS_tariffsActionBar"));
      if (actionbarTitle !== null) {
        Hafas.Modules.a11y.Announce.assertive(actionbarTitle.innerText);
      }
      // focus first Element (Backbutton)
      Hafas.Util.gui.focusFirstElement("#HFS_tariffsActionBar");
      me.Controller.TP.currentView = "TariffOverviewScreen";
    }

    this.Controller.TP.currentSelectedTariff = {
      boxGroupIdx:data.boxGroupIdx,
      boxGroupElemIdx:data.boxGroupElemIdx
    }
  },
  renderTariffOverviewFareSets: function (selectedConnection) {
    var me = this;
    var _targetTemplate = 'TP_ResultDetail';

    var filterFound = false;
    for (var s = 0; s < selectedConnection.trfRes.fareSetListResolved.length; s++) {
      var tmpFS = selectedConnection.trfRes.fareSetListResolved[s];
      // Erstes Fareset soll im jeweiligen Context aufgeklappt sein
      if ((s == 0 && typeof Hafas.Config.Tariffs.fareSetDisplay[this.Controller.TP.currentView] != 'undefined' && Hafas.Config.Tariffs.fareSetDisplay[this.Controller.TP.currentView] == 'SHOWFIRST') ||
        (typeof Hafas.Config.Tariffs.fareSetDisplay[this.Controller.TP.currentView] != 'undefined' && Hafas.Config.Tariffs.fareSetDisplay[this.Controller.TP.currentView] == 'SHOWALL')
      ) {
        tmpFS.showInitially = true;
      }
      for (var fl = 0; fl < tmpFS.fareL.length; fl++) {
        var tmpF = tmpFS.fareL[fl];
        tmpF.filterPropsResolved = [];
        if (typeof tmpF.filterProps != 'undefined') {
          filterFound = true;
          for (var p in tmpF.filterProps) {
            tmpF.filterPropsResolved.push({
              key: p,
              values: tmpF.filterProps[p].join(" ")
            });
          }
        }
      }
    }
    var currentFilter = Hafas.Util.Tariffs.getDefaultTariffFilter(this.Controller.TP.tariffFilter);


    var model = {
      viewHeader: {
        details: Hafas.Modules.i18n.get('common.label.t_N_DetailsTariff')
      },
      showDetailViewHeader: true,
      tariffInfoBox: {
        fareSetListResolved: selectedConnection.trfRes.fareSetListResolved
      },
      filter: currentFilter,
      showFilter: filterFound,
      showConnectionHeader: true,
      trfRes: selectedConnection.trfRes,
      ctx: 'tp'
    };


    Hafas.Modules.History.addOrUpdateData("TP", "tariffOverviewFareSets", selectedConnection);


    Hafas.Modules.Render.render({
      file: 'tp.result.detail.html',
      target: _targetTemplate,
      template: 'TP_TplDetailTariffOverviewScreen',
      model: model
    }, function (html) {
      Hafas.Util.gui.resetScrollTop();
      Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
      Hafas.ps.pub('/GUI/results/details/show', [{forceDetails: true}]);

      var headerTargetTpl = Hafas('[data-tariff-header="connection"]', false);
      Hafas.Modules.Render.render({
        file: 'tp.result.detail.html',
        target: headerTargetTpl,
        template: 'TP_TplDetailTariffOverviewHeaderConnection',
        model: selectedConnection
      }, function (html) {
        Hafas.ps.pub('/app/events/resize', []);
      });
    });
    me.Controller.TP.currentView = "TariffOverviewScreen";
  },
  updateTariffFilterResults: function () {
    var allFareSets = Hafas('.lyr_tariffFaresetItemWrapper', true);
    var visibleFaresets = 0;
    for (var a = 0; a < allFareSets.length; a++) {
      var allFSItems = Hafas('[data-tariff-fareset="item"]', true, allFareSets[a]);
      var visElems = false;
      allFSItems.forEach(Hafas.bind(function (elem) {
        var visStatus = Hafas.Util.Tariffs.resolveVisibility(elem, this.Controller.TP.tariffFilter);
        if (visStatus) {
          visElems = true;
        }
        Hafas.Util.gui.setVisibility(elem, visStatus);
      }, this));

      var queryString = '';
      for (var t in this.Controller.TP.tariffFilter) {
        queryString += '[data-' + t.toLowerCase() + '=' + this.Controller.TP.tariffFilter[t] + ']';
      }

      // Wenn Filter dazu führt, dass nix angezeigt wird
      var noResults = Hafas('[data-tariff-noresults="filter"]', false, allFareSets[a]);

      var fareSetContainer = Hafas('[data-tariff-fareset="' + a + '"]', false);
      if (!visElems) {
        Hafas.Util.gui.setVisibility(noResults, true);
        Hafas.Util.gui.setVisibility(fareSetContainer, false);
      } else {
        Hafas.Util.gui.setVisibility(noResults, false);
        Hafas.Util.gui.setVisibility(fareSetContainer, true);
        visibleFaresets++;
      }
    }
    // Wenn gar keine Ergebnisse in den Faresets gefunden worden sind, dann allgemeine Fehlermeldung einblenden
    var fareSetWrapper = Hafas('[data-tariff-wrapper="fareset"]', false);
    var tariffNotFoundContainer = Hafas('[data-tariff-wrapper="errorNotFound"]', false);
    if (visibleFaresets == 0) {
      Hafas.Util.gui.setVisibility(fareSetWrapper, false);
      Hafas.Util.gui.setVisibility(tariffNotFoundContainer, true);
    } else {
      Hafas.Util.gui.setVisibility(fareSetWrapper, true);
      Hafas.Util.gui.setVisibility(tariffNotFoundContainer, false);
    }
    Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('common.label.t_N_LoadingEnds'));
    Hafas.ps.pub('/app/events/resize');
  },
  updateTariffOverview: function (data) {
    this.Controller.TP.tariffFilter[data.key] = data.value;
    Hafas.bind(this.Controller.TP.updateTariffFilterResults, this)();
  },
  refreshTariff:function (data){

    if (data.ev) {
      data.ev.preventDefault();
      data.ev.stopPropagation();
    }
    Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get("a11y.announce.t_N_areUpdating", {elem: Hafas.Modules.i18n.get("TariffSearch.index.t_N_Details")}));
    // Add Loader
    var loaderHtml = Hafas.Modules.Render.renderTemplate("Common_AtomTplLoaderBarInfinite");
    Hafas('#TP_ResultDetail [data-render-element="result_header"]').insertAdjacentHTML('afterbegin', loaderHtml);
    Hafas('#HFS_tariffsRefreshBtn').disabled = true;

    var currConnection = this.Controller.TP.selectedConnection;
    var refreshData = {
      'connBitmask': currConnection.connectionType,
      'connIdx': currConnection.connectionIdx,
      'toggle':false,
      'boxGroupIdx':this.Controller.TP.currentSelectedTariff.boxGroupIdx,
      'boxGroupElemIdx':this.Controller.TP.currentSelectedTariff.boxGroupElemIdx
    };

    this.Controller.TP.instance.refreshConnTariff(refreshData);
  },
  renderTariffInfoBoxGroups: function (connection) {
    var me = this;
    var _targetTemplate = 'TP_ResultDetail';

    Hafas.Modules.History.addOrUpdateData("TP", "tariffInfoBoxGroup", connection);

    Hafas.Modules.Render.render({
      file: 'tp.result_detail.html',
      target: _targetTemplate,
      template: 'TP_TplDetailTariffInfoBoxGroupScreen',
      model: connection
    }, function (html) {
      Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
      Hafas.ps.pub('/GUI/results/details/show', [{}]);

      Hafas.ps.pub('/app/events/resize', []);
    });
    me.Controller.TP.currentView = "TariffInfoBoxGroupScreen";
  },
  showCreateNewAlarmDialog: function (data) {
    //Hafas.Modules.History.addOrUpdateData("TP", "createAlarm", data);

    var model = {};

    if (data.previousFocusSelector) {
      model.previousFocusSelector = data.previousFocusSelector;
    }

    /* Lege neues Default Abo im Push Controller an */
    Hafas.bind(this.Controller.Push.createDefaultSubscription, this)();

    /* Neue Push View rendern */
    Hafas.bind(this.Controller.TP.renderCreateAlarm, this)(model)


  },
  renderCreateAlarm: function (model) {
    model = model || {};
    var currentSubscription = this.Controller.Push.currentSubscription;
    if (typeof currentSubscription.subscrId != 'undefined') {
      model.subscrId = currentSubscription.subscrId;
    }
    if (typeof model.subscrId == 'undefined') {
      model.type = 'new';
    }
    model.availableChannels = [];

    if (model.type === 'new') {
      for (var channelId in Hafas.Config.Push.channels) {
        if (Hafas.Config.Push.channels[channelId].use === true) {
          var tmpAvailableChannel = Hafas.Core.clone(Hafas.Config.Push.channels[channelId]);
          tmpAvailableChannel.id = channelId;
          if (currentSubscription.channels[channelId] !== undefined) {
            var currentSubscriptionAddress = currentSubscription.channels[channelId].address;
            if (currentSubscriptionAddress !== undefined) {
              // TODO jleo: Check what happens if we have an email signed in
              tmpAvailableChannel.address = currentSubscriptionAddress;
            }
            var currentSubscriptionChecked = currentSubscription.channels[channelId].checked;
            if (currentSubscriptionChecked !== undefined) {
              // We need to save the checked status from currentSubscription, otherwise changes of channel checkbox
              // will not be saved after switching into the service days and back
              tmpAvailableChannel.checked = currentSubscriptionChecked;
            }
          }
          model.availableChannels.push(tmpAvailableChannel);
        }
      }
    } else {
      model.availableChannels = currentSubscription.availableChannels;
    }
    var repeatData = this.Controller.Push.getRepeatStatusFromSubscription(currentSubscription);
    model.repeatStatus = repeatData.repeatStatus;
    model.repeatStatusText = repeatData.repeatStatusText;
    model.repeatStatusTextLong = repeatData.repeatStatusTextLong;

    model.targetTemplate = 'TP_ResultDetail';

    Hafas.Modules.History.updateData("TP", "createAlarm", model);

    /* Build model data */
    if (currentSubscription !== null && currentSubscription !== undefined) {
      model.notificationOptions = [];
      for (var n = 0; n < currentSubscription.settings.notificationStartOptions.length; n++) {
        var notificationValue = currentSubscription.settings.notificationStartOptions[n];
        var selected = (notificationValue === currentSubscription.settings.notificationStart);
        model.notificationOptions.push({
          value: notificationValue,
          selected: selected,
          label: Hafas.Modules.i18n.get('Push.result.t_N_NotificationsFromXMinutes', {min: notificationValue})
        });
      }
      model.delayOptions = [];
      for (var d = 0; d < currentSubscription.settings.delayOptions.length; d++) {
        var delayValue = currentSubscription.settings.delayOptions[d];
        var selected = (delayValue === currentSubscription.settings.minDeviationFollowing);
        model.delayOptions.push({
          value: delayValue,
          selected: selected,
          label: Hafas.Modules.i18n.get('Push.result.t_N_EditFromXMinutes', {min: delayValue})
        });
      }

      // Render connection alarm header with actionbar & segmente control
      Hafas.Modules.Render.render({
        file: 'push.index.html',
        target: model.targetTemplate,
        template: 'Push_TplConnectionSubscriptionHeader',
        model: model
      });

      // Create and initiate segmented control  (if not available yet)
      if (typeof this.Controller.TP.segConPush !== 'undefined' &&
          this.Controller.TP.segConPush !== null &&
          typeof this.Controller.TP.segConPush.getState === 'function') {
        // do nothing; segmented control was already initiated
      } else {
        this.Controller.TP.segConPush = Hafas.Core.newType('HafasSegmentedControl', { holder: 'HFS_ConnectionSubscrToggle' });
        this.Controller.TP.segConPush.initiate();
      }

      // Render connection alarm settings into first segmented control panel (ID: HFS_ConnectionAlarm_Settings)
      Hafas.Modules.Render.render({
        file: 'push.index.html',
        target: 'HFS_ConnectionAlarm_Settings', // Segmented control panel
        template: 'Push_TplEditSubscription',
        model: model
      }, Hafas.bind(function (html) {
        if (Hafas.Config.Push !== undefined && Hafas.Config.Push.channels["webpush"] !== undefined && Hafas.Config.Push.channels["webpush"].use === true) {
          var skipPermissionRequest = true;
          Hafas.bind(Hafas.Util.worker.handlePushPermission, this)(skipPermissionRequest);

          var pushCheckbox = Hafas('#HFS_PUSH_CHANNEL_CHECKBOX_WEBPUSH', false);
          if (pushCheckbox !== null && pushCheckbox.checked === true) {
            // If the checkbox for WebPush is already selected, deselect it once and activate it again per click
            // interaction so that WebPush permission request is possible
            Hafas.ps.pub('/push/selectChannel', [{id: 'webpush', checked: false}]);
            pushCheckbox.click();
          }
        }

        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        Hafas.ps.pub('/GUI/results/details/show', [{}]);

        Hafas.bind(this.Controller.Push.initSelectBoxes, this)();

        // Checks if the channel checkboxes have to be disabled
        var skipPermissionRequest = true;
        Hafas.bind(Hafas.Util.worker.handlePushPermission, this)(skipPermissionRequest);

        Hafas.ps.pub('/app/events/resize', []);

        var focusSelector = this.Controller.Push.focusSelector;
        this.Controller.Push.focusSelector = null; // avoid unintentionally restoring focus later on
        if (!focusSelector) {
          focusSelector = Hafas.Util.node.getPath(Hafas.Util.node.getFirstVisibleAndFocusableElement(Hafas('#HFS_DocumentDetailOverview')));
        }
        Hafas.Util.gui.restoreFocus(focusSelector);
      }, this));

      this.Controller.TP.currentView = "AlarmCenterCreate";
    }
  },
  printSearchLink: function () {
    console.log(this.Controller.TP.instance.createSearchLink());
  },

  printReconstructionLink: function () {
    var selectedConnection = this.Controller.TP.selectedConnection;
    if (selectedConnection == null) {
      console.warn("selectedConnection is null!");
      return;
    }
    // HCI 1.35 -> 1.39
    var ctxRecon = selectedConnection.ctxRecon || selectedConnection.recon.ctx;
    console.log(Hafas.Core.getWebAppBasePath() + "?ctxRecon=" + encodeURIComponent(ctxRecon));
  },

  printSelectedConnection: function () {
    var selectedConnection = this.Controller.TP.selectedConnection;
    if (selectedConnection == null) {
      console.warn("selectedConnection is null!");
      return;
    }
    console.log(selectedConnection);
  },

  setFormForOverview: function (boolval) {
    var tpOVActionbar = Hafas("#TP_ResultActionbar");
    if (tpOVActionbar) {
      Hafas.Util.gui.setVisibility(tpOVActionbar, boolval);
    }
    var formEle = Hafas("#HFS_DocumentFormInput");
    if (formEle && boolval) {
      formEle.addClassName("lyr_flexHeader");
    } else if (formEle && !boolval) {
      formEle.removeClassName("lyr_flexHeader");
    }
  },

  closeView: function (histData, newHistData) {
    // console.log("+++ close view +++", histData);
    switch (histData.view) {
      case "index":
        Hafas.ps.pub('/GUI/form/hide', [{}]);
        break;
      // Strawberry 1.5: Diverse Korrekturen in Verbindung mit der Rekonstruktion und dem History Modul, au�erdem werden die Bl�tter Buttons bei Aufruf mit Rekonstruktionskontext nicht mehr angezeigt
      case "reconstruction":
      case "overviewIV":
      case "reconstructionError":
      case "overview":
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        Hafas.bind(this.Controller.TP.clearMap, this)();
        break;
      case "details":
        if (Hafas.Config.TP.unifiedPlanner.show) {
          Hafas.ps.pub('/GUI/form/show', [{appcontext: this.appContext}]);
        }
        Hafas.ps.pub('/GUI/results/details/hide', [{}]);
        Hafas.ps.pub('/tp/hideElevationLevel');
        Hafas.bind(this.Controller.TP.clearMap, this)();
        break;
      case "options":
        Hafas.ps.pub('/GUI/form/show', [{}]);
        Hafas.ps.pub('/options/gui/toggle', [{target: 'HFS_CustomerOptionsWrap', open: false, view: 'options'}]);
        // Nur Unified Planner antriggern, wenn es sich nicht um eine Rekonstruktionsverbindung handelt und nicht index geöffnet wird.
        if (Hafas.Config.TP.unifiedPlanner.show && !this.Controller.TP.instance.data.results.isReconstruction && this.Controller.TP.options.hasOptionTextChanged() && newHistData.view !== 'index') {
          Hafas.ps.pub('/tp/events/trigger/unified');
        }
        break;
      case "optionsDetails":
        histData.data.open = false;
        // Daten durch histData setzen
        Hafas.ps.pub('/options/gui/toggle/group', [{
          groupId: histData.data.groupId,
          target: histData.data.target + '_Panel',
          view: histData.data.view,
          open: false
        }]);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/hide', []);
        break;
      case "tariffOverview":
        var trfSelBoxes = this.Controller.TP.tariffSelectBoxes;
        for (var t = 0; t < trfSelBoxes.length; t++) {
          trfSelBoxes[t].destroy();
        }
        this.Controller.TP.tariffSelectBoxes = [];
        break;
      case "createAlarm":
      case "subscriptionHistory":
        break;
      case "editSmartLocations":
        Hafas.ps.pub('/favorites/smartLocations/closeView');
        break;
    }

  },
  restoreView: function (histData) {
    // console.log("+++ restore view +++", histData);
    var view = histData.view;
    switch (view) {
      case "index":
        this.Controller.App.sendMetaInformation("TP", "index");
        Hafas.bind(this.Controller.TP.renderIndex, this)(histData.data);
        Hafas.ps.pub('/livemap/clearJourneyFilter', [true, true]); // Strawberry 1.5: Diverse Anpassungen f�r die Livemap Umschaltung, umfasst Fixes/Umsetzungen f�r Mantis IDs 0080621, 0081118
        Hafas.bind(this.Controller.TP.hideElevationLevel, this)();
        break;
      case "overview":
        // Manipulierte Verbindungen zurücksetzen
        this.Controller.TP.instance.resetManipulatedConnections();
        //Hafas.bind(this.Controller.TP.details.connectionCarouselCleanup,this)();

        var saveSelectedClusterGrp = this.Controller.TP.visibleClusterGroup;
        if (Hafas.Config.TP.unifiedPlanner.show) {
          Hafas.bind(this.Controller.TP.renderIndex, this)(histData.data.response);
          Hafas.ps.pub('/GUI/form/show', [{appcontext: 'TP'}]);
        }
        // Optionen dürfen nur aus dem History-Modul entnommen werden, wenn sie nicht gerade angepasst worden sind
        // bzw. der vorherige Screen die Anfrageoptionen waren /mroe ... und die Optionen überhaupt an sind /jleo
        if(!this.Controller.TP.optionsChanged && Hafas.Config.TP.useQueryOptions === true) {
          this.Controller.TP.options.injectModifiedModel(histData.data.optionModel);
        }
        this.Controller.TP.optionsChanged = false;
        Hafas.bind(this.Controller.TP.showResultOverview, this)(histData.data.response);
        if (this.Controller.TP.instance.isGroupingUsed()) {
          Hafas.bind(this.Controller.TP.updateGroupResults, this)(histData.data.response, true, false);
          var clusterIdx = this.Controller.TP.getClusterIndexByBitmask(saveSelectedClusterGrp);
          var isFromList = false;
          this.Controller.TP.selectClusterGroup(saveSelectedClusterGrp, true, clusterIdx, isFromList);
        }
        break;
      case "overviewIV":
        Hafas.bind(this.Controller.TP.showIVResultOverview, this)(histData.data.data, histData.data.type);
        break;
      case "details":
        if (this.Controller.Map.instance) {
          this.Controller.Map.hideConnection();
        }
        this.Controller.TP.instance.setResults(histData.data.results);
        var locTypes = ["dep", "arr"];
        for(var lIdx = 0; lIdx < locTypes.length; lIdx++) {
          this.Controller.TP.instance.setLocation(locTypes[lIdx], histData.data.results.query[locTypes[lIdx]]);
        }
        Hafas.bind(this.Controller.TP.renderConnectionDetails, this)(histData.data.currConnection, histData.data.data);
        break;
      // Strawberry 1.5: Diverse Korrekturen in Verbindung mit der Rekonstruktion und dem History Modul, au�erdem werden die Bl�tter Buttons bei Aufruf mit Rekonstruktionskontext nicht mehr angezeigt
      case "reconstruction":
        Hafas.bind(this.Controller.TP.showResultOverview, this)(histData.data, {});
        break;
      case "reconstructionError":
        Hafas.bind(this.Controller.TP.showReconstructionError, this)(histData.data);
        break;
      case "options":
        Hafas.bind(this.Controller.TP.renderIndex, this)(histData.data);
        Hafas.ps.pub('/GUI/form/show', [{appcontext: 'TP'}]);
        Hafas.ps.pub('/options/gui/toggle', [{target: 'HFS_CustomerOptionsWrap', open: true, view: 'options'}]);
        break;
      case "optionsDetails":
        Hafas.bind(this.Controller.TP.renderIndex, this)(histData.data);
        Hafas.ps.pub('/GUI/form/show', [{appcontext: 'TP'}]);
        Hafas.ps.pub('/options/gui/toggle', [{target: 'HFS_CustomerOptionsWrap', open: true, view: 'options'}]);
        // Daten durch histData setzen
        Hafas.ps.pub('/options/gui/toggle/group', [{
          groupId: histData.data.groupId,
          target: histData.data.target + '_Panel',
          view: histData.data.view,
          open: true
        }]);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/show', [{template: 'Common_MapPageHeaderDefault'}]);
        break;
      case "tariffInfoBoxGroup":
        Hafas.bind(this.Controller.TP.renderTariffInfoBoxGroups, this)(histData.data, {});
        break;
      case "tariffOverview":
        // set selected connection back to last state, when this view was saved
        this.Controller.TP.selectedConnection = histData.data.selectedConnection;
        // call function to render tariff overview
        Hafas.bind(this.Controller.TP.renderTariffOverview,this)(histData.data.functionParams);
        break;
      case "createAlarm":
        Hafas.bind(this.Controller.TP.renderCreateAlarm, this)(histData.data, {});
        break;
      case "subscriptionHistory":
        Hafas.bind(this.Controller.Push.showMessages, this)(histData.data);
        break;
      case "editSmartLocations":
        Hafas.ps.pub('/favorites/smartLocations/edit', [{locKey: Hafas.Modules.Render.objectKeeper.keep(histData.data.loc), target: this.smartLocationsContainer}]);
        break;
    }
  },
  restoreTripMarker: function () {
    this.Controller.Map.hideTripMarker();
    var dep = this.Controller.TP.instance.getLocation("dep");
    var arr = this.Controller.TP.instance.getLocation("arr");

    if (dep != null)
      Hafas.ps.pub('/map/addLocationMarker', ["dep", dep]);

    if (arr != null)
      Hafas.ps.pub('/map/addLocationMarker', ["arr", arr]);

    var currentViaList = this.Controller.TP.instance.getViaList();
    for(var v=0; v < currentViaList.length;v++){
      if(currentViaList[v].loc !== undefined && currentViaList[v].loc !== "" && Object.keys(currentViaList[v].loc).length > 0) {
        Hafas.ps.pub('/map/addLocationMarker', ["via", currentViaList[v].loc, {index: v}]);
      }
    }
  },
  /**
   * removes map content (that has been created in the trip planner context)
   *
   * @method clearMap
   */
  clearMap: function () {
    if (typeof this.Controller.Map != 'undefined') {
      this.Controller.Map.hideConnection();
      this.Controller.Map.hideTripMarker();
    }
  },
  cleanupSegmentedControls: function () {
    if (this.Controller.TP.segConClusterMore !== undefined) {
      this.Controller.TP.segConClusterMore.destroy();
      delete this.Controller.TP.segConClusterMore;
    }

    if (this.Controller.TP.segConClusterMain !== undefined) {
      this.Controller.TP.segConClusterMain.destroy();
      delete this.Controller.TP.segConClusterMain;
    }

    if (this.Controller.TP.segConPush !== undefined) {
      this.Controller.TP.segConPush.destroy();
      delete this.Controller.TP.segConPush;
    }
  },
  cleanup: function () {
    /* TP relevante Karteninhalte l?schen */
    if(Hafas.Config.Switches.useTravelplanner) {
      // Send "leaveContext" metadata info to Iframe API
      this.Controller.App.sendMetaInformation("TP", "leaveContext");

      Hafas.bind(this.Controller.TP.clearMap, this)();
      this.Controller.TP.currentConnections = [];
      this.Controller.TP.selectedConnection = null;
      this.Controller.TP.currentView = null; // Strawberry 1.5

      this.Controller.TP.instance.resetManipulatedConnections();
      Hafas.bind(this.Controller.TP.cleanupSegmentedControls, this)();
      Hafas.bind(this.Controller.TP.details.connectionCarouselCleanup, this)();

      // If we have a popover, close it
      if (this.Controller.TP.locationSelectPopover) {
        Hafas.bind(this.Controller.TP.hideLocationSelectionPopover, this)();
      }

      this.Controller.TP.highlightAlarmElements = false; // Deactivate highlight mode when leaving context
    }

    // If we have smart locations, close the edit view
    if (Hafas.Config.Switches.useSmartLocations === true) {
      Hafas.ps.pub('/favorites/smartLocations/closeView');
    }

    Hafas.ps.pub('/options/gui/close/groups', [{}]);
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/GUI/results/details/hide', [{}]);
    Hafas.ps.pub('/GUI/form/hide', [{}]);
    // Strawberry 1.5: Diverse Anpassungen f�r die Livemap Umschaltung, umfasst Fixes/Umsetzungen f�r Mantis IDs 0080621, 0081118
    if (this.Controller.Livemap.getLivemapContext() != 'tq') {
      Hafas.ps.pub('/livemap/clearJourneyFilter', [true, true]);
    }
  },
  /**
   * clears all input data (including options) and switches back to trip planner
   *
   * @method
   */
  clearInput: function () {
    // Entferne aktuellen History-Eintrag, da nachfolgend über switchContext ein neuer hinzu kommt

    // This function resets the context of the "TP" module and clears all related data. It's used as a callback in removeCurrentStep
    var me = this
    var inst = this.Controller.TP.instance;

    Hafas.ps.pub('/options/reset');
    Hafas.ps.pub('/app/switchContext', [{context: 'TP', method: 'index'}]);

    me.Controller.TP.inpFrom.resetLocation(); // Remove from-input from session storage
    me.Controller.TP.inpTo.resetLocation(); // Remove to-input from session storage
    me.Controller.TP.dateTimePicker.setTimeNowOn();
    inst.clearArr();
    inst.clearDep();

    if (this.Controller.TP.currentView === "overview") {
      Hafas.Modules.History.removeCurrentStep("overview", () => {
        Hafas.Modules.History.removeCurrentStep("index")
      });
    }

    // Map Marker löschen
    this.Controller.Map.clearAllMapMarker.bind(this)();
    // Delete via inputs, when they are in form
    if (Hafas.Config.TP.vias.showInForm === true) {
      this.Controller.TP.instance.clearAllVias();
    }
    Hafas.bind(this.Controller.TP.resetVias, this)();
    Hafas.bind(this.Controller.TP.updateVias, this)(true);

    Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get('common.menu.t_N_clearInput_success'));
  },

  via: {
    init: function (params) {
      var me = this;
      var viaList = this.Controller.TP.options.getModelsByType("via");
      var i = 0,
        iLen = viaList.length;
      for (i; i < iLen; i++) {
        // Bei einem Via-Input-Feld darf es Mobil in der Vorschlagsliste keine Auswahl aus der Karte geben // Strawerry 1.6.0
        if (Hafas("#HFS_Suggest_" + viaList[i].id) == null) {
          var viaSuggestConfig = {};
          viaSuggestConfig.useChooseFromMap = false;
          viaSuggestConfig.preventDefaultOnEnter = true;
          viaSuggestConfig.useActualPosition = false;
          this.Controller.TP['inp' + viaList[i].id] = Hafas.Core.newType('hafasSuggest', {
            loc: viaList[i].id,
            config: viaSuggestConfig, // Strawerry 1.6.0
            type: "V",
            onBlur: function (blurEvent) {
              // When user removes via using Del/backspace, they expect it to be actually gone
              // -> Check on blur if input is empty but model is not and remove via
              var viaInput = blurEvent.target;
              var viaIndex = viaInput.dataset.viaFormIndex;
              if (viaInput.value.length === 0 && me.Controller.TP.instance.getVia(viaIndex)) {
                Hafas.ps.pub('/tp/removeVia', [viaIndex]);
              }
            }
          });
          this.Controller.TP['inp' + viaList[i].id + '_inputTimeout'] = null;
          if(Hafas.Config.TP.vias.stationOnly && this.Controller.TP['inp' + viaList[i].id]) {
            this.Controller.TP['inp' + viaList[i].id].setSuggestType("S");
          }
        }
        // Deactivate Via-Options (Duration and Via-Delete) when via value is empty
        if (viaList[i].value == "") {
          Hafas.ps.pub('/options/gui/toggle/via/options', [{id: viaList[i].id, visibility: false}]);
        }
      }
    },
    remove: function (index) {
      this.Controller.TP.options.setRandomParameter("HFS_Via" + index, "value", "");
      this.Controller.TP.options.setRandomParameter("HFS_Via" + index, "dur", "");
      this.Controller.TP.options.setRandomParameter("HFS_Via" + index, "min", 0);
      Hafas('#HFS_Via' + index).value = '';
      this.Controller.TP.resetVia(this.Controller.TP['inpHFS_Via' + index]);

      // Via-Duration-Element in der GUI zurücksetzen, wenn vorhanden
      var durationEle = Hafas('#HFS_Via' + index + "_Container [data-hci-viaduration]");
      if (durationEle) {
        durationEle.value = '';
      }
      Hafas.ps.pub('/options/gui/toggle/via/options', [{id: "HFS_Via" + index, visibility: false}]);
      // Marker auf der Karte löschen
      Hafas.ps.pub('/map/clearLocationMarker',["via",{index: index}]);
    }
  },
  // eu-spirit/scandria
  findEuRegionByProvider: function (prvId) {
    var found = false;
    var optGroup = 0;
    // Default
    var result = {
      index: 0,
      value: Hafas.Config.euSpiritRegions[0].prvCtx,
      label: Hafas.Config.euSpiritRegions[0].name
    };
    Hafas.Config.euSpiritRegions.forEach(function (region, index) {
      if (!found) {
        // OptGroup hat ein index jedoch nicht in der SelectBox daher selectedIndex.
        if (region.optgroup) {
          optGroup++;
        }
        if (region && region.prvCtx) {
          if (region.prvCtx === prvId) {

            result = {
              index: index,
              selectedIndex: index - optGroup,
              value: region.prvCtx,
              optgroup: region.optgroup,
              label: region.name
            };
            found = true;
          } else {
            // Prüfen ob ProviderId unter ProviderGruppe vorkommt, mit Komma getrennt.
            var configCtx = region.prvCtx.split(',');
            configCtx.forEach(function (cPrvCtx) {
              if (prvId === cPrvCtx) {
                result = {
                  index: index,
                  selectedIndex: index - optGroup,
                  value: region.prvCtx,
                  optgroup: region.optgroup,
                  label: region.name
                };
                found = true;
              }
            });
          }
        }
      }
    });
    return result;
  },
  setEuSpiritOption: function (type, location) {
    if (type && location) {
      var providerId = Hafas.Util.location.getProviderId(location);
      var region = this.Controller.TP.findEuRegionByProvider(providerId);
      if (type === 'dep') {
        region.name = 'euDepRegion';
      } else if (type === 'arr') {
        region.name = 'euArrRegion';
      }
      Hafas.bind(this.Controller.TP.changeEUSpiritOption, this)(region);
    }
  },
  changeEUSpiritOption: function (region) {
    var type = region.type;
    if (region.name === 'euDepRegion') {
      type = 'From';
    } else if (region.name === 'euArrRegion') {
      type = 'To';
    }
    if (type && typeof region.value === "string") {

      var newRegion = this.Controller.TP.findEuRegionByProvider(region.value);
      if (!newRegion) return;
      var tpController = this.Controller.TP;

      if (tpController['euSpiritSelectBox' + type]) {
        var selectBoxState = tpController['euSpiritSelectBox' + type].getState()
        if (selectBoxState.active !== (newRegion.selectedIndex + 1)) {
          tpController['euSpiritSelectBox' + type].setActiveIndex(newRegion.selectedIndex + 1);
        }
        tpController['inp' + type].inp.disabled = '';
      }
      if (tpController['inpFrom'] && !tpController['inpFrom'].inp.disabled && tpController['inpTo'] && !tpController['inpTo'].inp.disabled) {
        Hafas('#HFS_TpSwitchFromTo', false).disabled = '';
      }

      // Einstellungen Suggest
      this.Controller.TP.euProvider[type] = {
        label: newRegion.label,
        prvCtx: newRegion.value,
        optgroup: newRegion.optgroup,
        index: newRegion.index
      };

      if (this.Controller.TP["inp" + type] !== undefined) {
        this.Controller.TP["inp" + type].setProviderCtx(newRegion.value);
        this.Controller.TP["inp" + type].setSystem('E');
      }
      this.Controller.TP.instance.setSystem('E');
    }
  },
  switchEuSpiritRegions: function () {
    var fromCtx, toCtx;
    var inpFrom = this.Controller.TP["inpFrom"];
    var inpTo = this.Controller.TP["inpTo"];

    // Valid Locations has the right providerCtx and will switch by getLocations and setLocation functions
    if (!inpFrom.hasValidLocation) fromCtx = inpFrom.getProviderCtx();
    if (!inpTo.hasValidLocation) toCtx = inpTo.getProviderCtx();
    if (toCtx) Hafas.ps.pub('/tp/changeEUSpiritOption', [{name: 'euDepRegion', value: toCtx}]);
    if (fromCtx) Hafas.ps.pub('/tp/changeEUSpiritOption', [{name: 'euArrRegion', value: fromCtx}]);
  },
  /**
   * Decides whether the options should be stored locally or not (temporarily [de]activating)
   * @param {Boolean} boolval Sets the value of localOptionsActive
   */
  setOptionStorageActive: function (boolval) {
    if (Hafas.Config.Options && Hafas.Config.Options.storeOptions === true) {
      this.Controller.TP.localOptionsActive = boolval;
    }
  }
};
